import React, { useState, useEffect } from 'react'
import { connect } from "react-redux";
import { apiServices } from '../../../services/apiServices'
import moment from 'moment';
import swal from 'sweetalert'
import Loader from 'react-loader-spinner'
import PropTypes from 'prop-types';
import QrReader from 'react-qr-reader';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGripLinesVertical, faQrcode, faTimes } from "@fortawesome/free-solid-svg-icons";
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import _ from 'lodash';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Customcasescard from '../../../pages/cases/Customcasescard';
import IndividualCasescard from '../../../pages/individualCases/Customcasescard.js';
import IconButton from '@material-ui/core/IconButton';
import CardHeader from '@material-ui/core/CardHeader';
import CloseIcon from '@material-ui/icons/Close';

import CreateField from '../../fields/CreateField'
import CreateSearchField from '../../fields/CreateSearchField'
import CreateStageField from '../../fields/CreateStageField'
import SeeIndividualRecordAccordian from '../../../pages/seeIndividualRecord/SeeIndividualRecordAccordian'

import { useTranslation, Trans } from 'react-i18next';
import '../../../assets/css/customstyles.css'
import OfflineDb from '../../../db'
import { useGlobalSpinnerActionsContext } from '../../../context/GlobalSpinnerContext'
import { formValues, setPostResgistrationResponse, setSelectedTabs, setTabHideValues } from '../../../redux/actions/action'

import { ButtonStrip, InputFieldFF, SingleSelectFieldFF, ReactFinalForm, hasValue, AlertBar, CircularLoader, CenteredContent } from '@dhis2/ui';
import { useHistory } from "react-router-dom";
import { Configuration as UIConfig } from '../../../assets/data/config';
import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from "@fullcalendar/interaction"; // needed for dayClick
import TaskList from '../../taskList/TaskList'
import { useSelector, useDispatch } from "react-redux"
import AddIcon from '@material-ui/icons/Add';
import EventNoteIcon from '@material-ui/icons/EventNote';
import VisibilityIcon from '@material-ui/icons/Visibility';
import EditIcon from '@material-ui/icons/Edit';
import GroupIcon from '@material-ui/icons/Group';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Avatar from '@material-ui/core/Avatar';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import clsx from 'clsx';
import Customcaseslist from '../../../pages/cases/Customcaseslist.js';
import PersonIcon from '@material-ui/icons/Person';
import DeleteIcon from '@material-ui/icons/Delete';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import { useLocation } from "react-router-dom";

//custom radio button
//import Formradio from './formradio.js'

import axios from 'axios';
import ImageDatahandle from '../../ocr/ImageDataHandle'

import Camera, { FACING_MODES, IMAGE_TYPES } from 'react-html5-camera-photo';
import 'react-html5-camera-photo/build/css/index.css';

import ControlCameraIcon from '@material-ui/icons/ControlCamera';
import { keys } from '@material-ui/core/styles/createBreakpoints';
import { el } from 'date-fns/locale';

//last
const { Form, Field, FormSpy } = ReactFinalForm



const getTranslatedLabels = (stage) => {
    if (localStorage.getItem("locale") == "en") {
        return stage.displayName;
    } else if (stage.translations && stage.translations.length > 0) {
        //debugger;
        let label = stage.translations.filter(tanslation => tanslation.property == "NAME" && tanslation.locale == localStorage.getItem("locale"))
        if (label.length > 0) {
            return label[0].value;
        } else {
            return stage.displayName;
        }
    }
    return stage.displayName;
};

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        // backgroundColor: theme.palette.background.paper,
    },
    table: {
        minWidth: 650,
    },
}));

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            className="reginnertabcontainer"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

function SimpleTabs(props) {
    let activeTabs = [];
    let activeTabsOnSubmit = []
    let userData = props.userData
    let programData = props.programData
    let programRules = props.programRules.programRules
    let programRulesVariables = props.programRulesVariables.programRuleVariables
    let dedupEnabled = props.dedupEnabled
    let searchEnabled = props.searchEnabled
    let relationShipId = props.relationShipId
    let dataElementGroup = props.dataElementGroup.dataElementGroups
    let geolocation = props.geolocation
    let currentGeolocation = props.currentGeolocation
    let OUJSON = props.OUJSON
    const location = useLocation();
    console.log("props", props)
    //let workFlow = programData.programs[0].attributeValues.length > 0 ? programData.programs[0].attributeValues[0].attribute.name == "Is workflow" ? true : false : false
    let workFlow = false;
    try {
        workFlow = programData.programs[0].attributeValues.length > 0
            ? _.filter(programData.programs[0].attributeValues, ['attribute.name', 'Is workflow'])
                ? true : false : false
    } catch (e) {
        console.log(e)
        workFlow = true;
    }

    const history = useHistory();
    const classes = useStyles();
    const [value, setValue] = React.useState(0);
    const [searchTabvalue, setSearchTabValue] = React.useState(0);
    const [activeCaseDetails, setActiveCaseDetails] = useState(null)
    const [activeCaseFormData, setActiveCaseFormData] = useState(null)
    const [tempActiveCaseFormData, setTempActiveCaseFormData] = useState(null)
    const [linkContactFlag, setLinkContactFlag] = useState(null)
    const [trackentityInstanceDetails, setTrackentityInstanceDetails] = useState(null)
    const [newServiceStartFlag, setServiceStartFlag] = useState(false)
    const [searchResponse, setSearchResponse] = React.useState(null);
    const [searchHeader, setSearchHeader] = React.useState(null);
    const [formValuePostDeDup, setFormValuePostDeDup] = React.useState(null);
    const [dataUri, setDataUri] = useState('')
    const [Configuration, setConfiguration] = React.useState(null);

    const [openCamera, setCameraStatus] = React.useState(false)
    const [showOCRDataPopUp, SetShowOCRDataPopUp] = useState([])

    //this is for full calender
    const [fullCalendarEvents, setFullCalendarEvents] = useState([])
    const [isFullCalenderPresentInStage, setIsFullCalenderPresentInStage] = useState(false)
    const [fullCalenderSelectedDate, setFullCalenderSelectedDate] = useState(null)
    const [dateMedicineTakenId, setDateMedicineTakenId] = useState(null)
    const [medicineTakenId, setMedicineTakenId] = useState(null)
    const [medicineColorCodeId, setMedicineColorCodeId] = useState(null)
    //calendarComponentRef = React.createRef();
    //code for regimen
    const [regimenStageId, setregimenStageId] = useState(null)
    const [adherenceStageId, setAdherenceStageId] = useState(null)
    const [medicineTable, setMedicineTable] = useState([])
    const [treatmentRegimenId, setTreatmentRegimenId] = useState(null)
    const [treatmentPhaseId, setTreatmentPhaseId] = useState(null)
    const [fixedDoseAdult, setFixedDoseAdult] = useState(null)
    const [fixedDoseChildren, setFixedDoseChildren] = useState(null)
    const [singleDoseAdult, setSingleDoseAdult] = useState(null)
    const [singleDoseChildren, setSingleDoseChildren] = useState(null)
    const [treatmentStartDateId, setTreatmentStartDateId] = useState(null)
    const [treatmentEndDateId, setTreatmentEndDateId] = useState(null)
    const [treatmentDoseId, setTreatmentDoseId] = useState(null)
    const [treatmentAdherenceId, setTreatmentAdherenceId] = useState(null)
    const [medicineRadioId, setMedicineRadioId] = useState(null)

    const [medicineListForCalender, setMedicineListForCalender] = useState([])
    //custom
    const [rhzRadio, setRhzRadio] = React.useState('yes');
    const [ethambutolRadio, setEthambutolRadio] = React.useState('yes');

    const [radioValue, setRadioValue] = React.useState({})

    // Code for Search start
    const [sessionUserBoValue, setSessionUserBoValue] = useState(null)
    const [metaData, setMetaData] = useState(null)
    const [searchResult, setSearchResult] = useState([])
    let stepIncrement = searchEnabled && navigator.onLine ? 2 : 1
    // code for link Tab
    const [linkIndexList, setLinkIndexList] = useState([])
    const [linkContactList, setLinkContactList] = useState([])
    const [showScanner, setshowScanner] = useState(false)
    const [categoryOptions, setCategoryOptions] = React.useState(null);
    const [currentLoginUserID, setCurrentLoginUserID] = useState(null);
    const [currentLoginUsername, setCurrentLoginUsername] = useState(null)
    const [caseNumberId, setCaseNumberId] = useState(null)
    const [statesList, setStatesList] = useState(null)
    const [townshipList, setTownshipList] = useState(null)
    const [newUIC, setNewUIC] = useState(null)
    const [offlineRecordStatus, setOfflineRecordStatus] = useState(null)
    const [customIsDisable, setCustomIsDisable] = useState(false)
    let userType = '';
    useEffect(() => {
        if (value == (programData.programs[0].programStages.length + stepIncrement)) {
            createIndexContactList()
        }
    }, [value])
    // const [stepIncrement,setStepIncrement] =  useState(1)
    async function getMetaData() {
        let metadata = await OfflineDb.getDataFromPouchDB('metaData')
        setMetaData(metadata.data)

        let loginDetails = await OfflineDb.getDataFromPouchDB('loginDetails')
        setSessionUserBoValue(loginDetails.data)
        userType = sessionUserBoValue ? sessionUserBoValue.userCredentials ? sessionUserBoValue.userRoles ? sessionUserBoValue.userRoles[0].name : '' : '' : '';
        //setCurrentLoginUserID(loginDetails.data.id);
        if (loginDetails.data && loginDetails.data.userCredentials) {
            setCurrentLoginUsername(loginDetails.data.username);
            //console.log("loginDetails.data.userCredentials.id",loginDetails.data.userCredentials.id,loginDetails.data);
        }

        let configurations = await OfflineDb.getDataFromPouchDB('configurations')
        setConfiguration(configurations.data.configuration)

        let categoryOption = await OfflineDb.getDataFromPouchDB('categoryOptions')
        setCategoryOptions(categoryOption.data)

        let stateData = await OfflineDb.getDataFromPouchDB('allStates')
        setStatesList(stateData)

        let townshipData = await OfflineDb.getDataFromPouchDB('allTownships')
        setTownshipList(townshipData)
    }
    useEffect(() => {
        getMetaData();
    }, [])

    useEffect(() => {
        //FOR SAMPLE COLLECTION
        getSampleCollectionStageDetail()
    }, [metaData])
    // Code for Search END
    const setGlobalSpinner = useGlobalSpinnerActionsContext()

    const { t, i18n } = useTranslation();

    //=========for Search UNDP==================
    const [searchFilter, setsearchFilter] = useState({});
    const [stageDetail, setStageDetail] = useState(null);
    const [dataElementDetail, setdataElementDetail] = useState(null);
    const [qrDataElementDetail, setqrDataElementDetail] = useState(null);

    const [customfieldobj, setcustomfieldobj] = useState(null);


    //=========custom logic for UNDP==================
    const [PresentlyOnAntiTBMedicationId, setPresentlyOnAntiTBMedicationId] = useState(null)
    const [clientTypeID, setClientTypeID] = useState(null)
    const [verifiedFieldId, setVerifiedFieldId] = useState(null)

    const [specimenStageId, setspecimenStageId] = useState(null);
    const [specimenType, setspecimenType] = useState(null);
    const [dateOfSampleCollection, setdateOfSampleCollection] = useState(null);
    const [specimenid, setspecimenid] = useState(null);
    const [noOfSputumCollected, setnoOfSputumCollected] = useState(null);
    const [sputumQRCode, setsputumQRCode] = useState(null);
    const [sampleCollectionAt, setsampleCollectionAt] = useState(null);
    const [sputumTable, setsputumTable] = useState([])
    const [searchdata, setsearchdata] = useState(null)
    const [offlineFieldId, setOfflineFieldId] = useState(null)
    const [hotspotsID, setHotspotsID] = useState(null)
    const [usernameID, setUserNameID] = useState(null)
    const [patientenrolledincare, setPatientenrolledincare] = useState(null)
    const [FirsttimeyoureceivePreventionservicesinyourlife, setFirsttimeyoureceivePreventionservicesinyourlife] = useState(null)
    const [DidyoureceivePreventionservicesfromotherorganizationsinthisyear, setDidyoureceivePreventionservicesfromotherorganizationsinthisyear] = useState(null)
    const [facilityofEnrollment, setFacilityofEnrollment] = useState(null)
    const [ARTinitiated, setARTinitiated] = useState(null)
    const [ReasonsfornotARTinitiated, setReasonsfornotARTinitiated] = useState(null)
    const [dateofartInitiated, setDateofartInitiated] = useState(null)
    const [facilityofArtInitiatedTownship, setfacilityofArtInitiatedTownship] = useState(null)
    const [facilityofArtInitiated, setfacilityofArtInitiated] = useState(null)
    const [HTSriskexposure, setHTSriskexposure] = useState(null)
    const [HTStestedinlast6months, setHTStestedinlast6months] = useState(null)
    const [HTSclientStatus, setHTSclientStatus] = useState(null)
    const [HTCservices, setHTCservices] = useState(null)
    const [HTCEverTested, setHTCEverTested] = useState(null)
    const [HTCOnART, setHTCHTCOnART] = useState(null)
    const [HTCIsPrEPavailable, setHTCIsPrEPavailable] = useState(null)
    const [HTCIsPrEPservices, setHTCIsPrEPservices] = useState(null)
    const [HTCPrEPreferral, setHTCPrEPreferral] = useState(null)
    const [HTCWheredidyoureceivetheART, setHTCWheredidyoureceivetheART] = useState(null)
    const [HTCReferral, setHTCReferral] = useState(null)
    const [wheredidyoureceivetheartFacilities, setwheredidyoureceivetheartFacilities] = useState(null)

    const [isclientcomfortabletodisclosehivstatustoorw, setisclientcomfortabletodisclosehivstatustoorw] = useState(null)

    const [ARTreferralservice, setARTreferralservice] = useState(null)
    const [CommoditiesDidclientacceptcondoms, setCommoditiesDidclientacceptcondoms] = useState(null)
    const [CommoditiesNumberofMalecondomsprovided, setCommoditiesNumberofMalecondomsprovided] = useState(null)
    const [CommoditiesNumberofFemalecondomsprovided, setCommoditiesNumberofFemalecondomsprovided] = useState(null)
    const [regUsernameID, setRegUserNameID] = useState(null)
    const [artInitiationStage, setArtInitiationStage] = useState(null)
    function getCustomVariableIds() {
        let tempobj = {};
        programData.programs[0].programTrackedEntityAttributes.map(regField => {
            //setOfflineRecordStatus
            if (regField.trackedEntityAttribute.displayName.trim().toLocaleLowerCase() == "isoffline") {
                setOfflineRecordStatus(regField.trackedEntityAttribute.id)
            }
            if (regField.trackedEntityAttribute.displayName.trim().toLocaleLowerCase() == "client type") {
                setClientTypeID(regField.trackedEntityAttribute.id)
            }
            if (regField.trackedEntityAttribute.displayName.trim().toLocaleLowerCase() == "presently on anti-tb medication?") {
                setPresentlyOnAntiTBMedicationId(regField.trackedEntityAttribute.id)
            }
            if (regField.trackedEntityAttribute.displayName.trim().toLocaleLowerCase() == "documents verified") {
                setVerifiedFieldId(regField.trackedEntityAttribute.id)
            }
            if (regField.trackedEntityAttribute.displayName.trim().toLocaleLowerCase() == "offlineid") {
                setOfflineFieldId(regField.trackedEntityAttribute.id)
            }
            if (regField.trackedEntityAttribute.displayName.trim().toLocaleLowerCase() == "hotspots") {
                setHotspotsID(regField.trackedEntityAttribute.id)
            }
            if (regField.trackedEntityAttribute.displayName.trim().toLocaleLowerCase() == "user name") {
                setRegUserNameID(regField.trackedEntityAttribute.id)
            }
            if (regField.trackedEntityAttribute.displayName.trim().toLocaleLowerCase() == "case number") {
                setCaseNumberId(regField.trackedEntityAttribute.id)
            }
        })

        programData.dataElements.map(stageFields => {
            console.log("stageFields", stageFields)
            let fieldname = stageFields.displayName ? stageFields.displayName : stageFields.description
            console.log("fieldname", fieldname)
            if (fieldname.trim().toLocaleLowerCase() == "data entry user") {
                setUserNameID(stageFields.id)
            }
            //did you receive prevention services in this year?
            if (fieldname.trim().toLocaleLowerCase() == "first time you receive prevention services in your life?") {
                setFirsttimeyoureceivePreventionservicesinyourlife(stageFields.id)
                tempobj = { ...tempobj, ["FirsttimeyoureceivePreventionservicesinyourlife"]: stageFields.id };
            }
            if (fieldname.trim().toLocaleLowerCase() == "did you receive prevention services in this year?") {
                setDidyoureceivePreventionservicesfromotherorganizationsinthisyear(stageFields.id)
                tempobj = { ...tempobj, ["DidyoureceivePreventionservicesfromotherorganizationsinthisyear"]: stageFields.id };
            }
            if (fieldname.trim().toLocaleLowerCase() == "art 1 - patient enrolled in care") {
                setPatientenrolledincare(stageFields.id)
                tempobj = { ...tempobj, ["patientenrolledincare"]: stageFields.id };
            }
            if (fieldname.trim().toLocaleLowerCase() == "art 4 - facility of enrollment") {
                setFacilityofEnrollment(stageFields.id)
                tempobj = { ...tempobj, ["facilityofEnrollment"]: stageFields.id };
            }
            if (fieldname.trim().toLocaleLowerCase() == "art 5 - art initiated") {
                setARTinitiated(stageFields.id)
                tempobj = { ...tempobj, ["ARTinitiated"]: stageFields.id };
            }
            if (fieldname.trim().toLocaleLowerCase() == "art 7 - reasons for not initiating art") {
                setReasonsfornotARTinitiated(stageFields.id)
                tempobj = { ...tempobj, ["ReasonsfornotARTinitiated"]: stageFields.id };
            }
            if (fieldname.trim().toLocaleLowerCase() == "art 6 - date of art initiated") {
                setDateofartInitiated(stageFields.id)
                tempobj = { ...tempobj, ["dateofartInitiated"]: stageFields.id };
            }
            // if (fieldname.trim().toLocaleLowerCase() == "art 8 - facility of art initiated"){
            if (fieldname.trim().toLocaleLowerCase() == "art 9 - facility of art initiated (facility)") {
                setfacilityofArtInitiated(stageFields.id)
                tempobj = { ...tempobj, ["facilityofArtInitiated"]: stageFields.id };
            }
            if (fieldname.trim().toLocaleLowerCase() == "art 8 - facility of art initiated (township)") {
                setfacilityofArtInitiatedTownship(stageFields.id)
                tempobj = { ...tempobj, ["facilityofArtInitiatedTownship"]: stageFields.id };
            }
            if (fieldname.trim().toLocaleLowerCase() == "hts 17 - risk exposure") {
                setHTSriskexposure(stageFields.id)
                tempobj = { ...tempobj, ["HTSriskexposure"]: stageFields.id };
            }
            if (fieldname.trim().toLocaleLowerCase() == "hts 5 - tested in last 6 months") {
                setHTStestedinlast6months(stageFields.id)
                tempobj = { ...tempobj, ["HTStestedinlast6months"]: stageFields.id };
            }
            if (fieldname.trim().toLocaleLowerCase() == "hts 4 - client status") {
                setHTSclientStatus(stageFields.id)
                tempobj = { ...tempobj, ["HTSclientStatus"]: stageFields.id };
            }
            if (fieldname.trim().toLocaleLowerCase() == "hts 6 - htc services") {
                setHTCservices(stageFields.id)
                tempobj = { ...tempobj, ["HTCservices"]: stageFields.id };
            }
            if (fieldname.trim().toLocaleLowerCase() == "hts 3 - ever tested") {
                setHTCEverTested(stageFields.id)
                tempobj = { ...tempobj, ["HTCEverTested"]: stageFields.id };
            }
            if (fieldname.trim().toLocaleLowerCase() == "hts 14 - on art") {
                setHTCHTCOnART(stageFields.id)
                tempobj = { ...tempobj, ["HTCOnART"]: stageFields.id };
            }
            if (fieldname.trim().toLocaleLowerCase() == "hts 11 - is prep available?") {
                setHTCIsPrEPavailable(stageFields.id)
                tempobj = { ...tempobj, ["HTCIsPrEPavailable"]: stageFields.id };
            }
            if (fieldname.trim().toLocaleLowerCase() == "hts 12 - prep referral services") {
                setHTCIsPrEPservices(stageFields.id)
                tempobj = { ...tempobj, ["HTCIsPrEPservices"]: stageFields.id };
            }
            if (fieldname.trim().toLocaleLowerCase() == "HTS 13 - PrEP referral") {
                setHTCPrEPreferral(stageFields.id)
                tempobj = { ...tempobj, ["HTCPrEPreferral"]: stageFields.id };
            }
            if (fieldname.trim().toLocaleLowerCase() == "hts 18 - where did you receive the art? (township)") {
                setHTCWheredidyoureceivetheART(stageFields.id)
                tempobj = { ...tempobj, ["HTCWheredidyoureceivetheART"]: stageFields.id };
            }
            if (fieldname.trim().toLocaleLowerCase() == "hts 9 - referral htc") {
                setHTCReferral(stageFields.id)
                tempobj = { ...tempobj, ["HTCReferral"]: stageFields.id };
            }
            if (fieldname.trim().toLocaleLowerCase() == "hts 19 - where did you receive the art? (facilities)") {
                setwheredidyoureceivetheartFacilities(stageFields.id)
                tempobj = { ...tempobj, ["wheredidyoureceivetheartFacilities"]: stageFields.id };
            }
            if (fieldname.trim().toLocaleLowerCase() == "htc 4 - is client comfortable to disclose hiv status to orw") {
                setisclientcomfortabletodisclosehivstatustoorw(stageFields.id)
                tempobj = { ...tempobj, ["isclientcomfortabletodisclosehivstatustoorw"]: stageFields.id };
            }
            if (fieldname.trim().toLocaleLowerCase() == "hts 15 - art referral service") {
                setARTreferralservice(stageFields.id)
                tempobj = { ...tempobj, ["ARTreferralservice"]: stageFields.id };
            }
            if (fieldname.trim().toLocaleLowerCase() == "commodities 3 - did client accept condoms?") {
                setCommoditiesDidclientacceptcondoms(stageFields.id)
                tempobj = { ...tempobj, ["CommoditiesDidclientacceptcondoms"]: stageFields.id };
            }
            if (fieldname.trim().toLocaleLowerCase() == "commodities 4.1 - number of male condoms provided") {
                setCommoditiesNumberofMalecondomsprovided(stageFields.id)
                tempobj = { ...tempobj, ["CommoditiesNumberofMalecondomsprovided"]: stageFields.id };
            }
            if (fieldname.trim().toLocaleLowerCase() == "commodities 4.2 - number of female condoms provided") {
                setCommoditiesNumberofFemalecondomsprovided(stageFields.id)
                tempobj = { ...tempobj, ["CommoditiesNumberofFemalecondomsprovided"]: stageFields.id };
            }

        })

        programData.programs[0].programStages.map((stage) => {
            let stageName = stage.description ? stage.description : stage.displayName;
            if (stageName.trim() == "ART Initiation") {
                setArtInitiationStage(stage.id);
            }
            stage.attributeValues.map((val) => {
                if (val.attribute.displayName === "SpecimenTable") {
                    stage.programStageDataElements.map(de => {
                        de.dataElement.attributeValues.map((attr) => {
                            if (attr.attribute.displayName === "ShowInTable") {
                                if (de.dataElement.displayName.trim()
                                    .toLocaleLowerCase() == "specimen type") {
                                    setspecimenType(de.dataElement.id);
                                }
                                if (de.dataElement.displayName.trim()
                                    .toLocaleLowerCase() == "date of sample collection") {
                                    setdateOfSampleCollection(de.dataElement.id);
                                }
                                if (de.dataElement.displayName.trim()
                                    .toLocaleLowerCase() == "specimen id") {
                                    setspecimenid(de.dataElement.id);
                                }
                                if (de.dataElement.displayName.trim()
                                    .toLocaleLowerCase() == "collection interval") {
                                    setnoOfSputumCollected(de.dataElement.id);
                                }
                                if (de.dataElement.displayName.trim()
                                    .toLocaleLowerCase() == "qr code/sample id scan") {
                                    setsputumQRCode(de.dataElement.id);
                                }
                            }
                        })
                        if (de.dataElement.displayName.trim()
                            .toLocaleLowerCase() == "sample collection at") {
                            setsampleCollectionAt(de.dataElement.id);
                        }
                    })
                }
            })
        })
        setcustomfieldobj(tempobj);
    }

    async function fetchCaseDetailsFromDatabase() {
        let CaseDetails = await OfflineDb.getDataFromPouchDB('activeCaseDetails')
        setActiveCaseDetails(CaseDetails)

        let CaseFormData = await OfflineDb.getDataFromPouchDB('activeCaseFormData')
        setActiveCaseFormData(CaseFormData)

        let ContactFlag = await OfflineDb.getDataFromPouchDB('linkContactFlag')
        setLinkContactFlag(ContactFlag)
    }
    function setRegimenStageDataElements() {
        if (programData.programs[0].programStages.length > 0) {
            programData.programs[0].programStages.map(stage => {
                if (stage.attributeValues && stage.attributeValues.length > 0) {
                    stage.attributeValues.map((val) => {
                        if (val.attribute.displayName === "showFullCalender") {
                            setAdherenceStageId(stage.id)
                            stage.programStageDataElements.map(field => {

                                if (field.dataElement.displayName.trim().toLocaleLowerCase() == "date medicine taken") {
                                    setDateMedicineTakenId(field.dataElement.id)
                                } else if (field.dataElement.displayName.trim().toLocaleLowerCase() == "medicine taken") {
                                    setMedicineTakenId(field.dataElement.id)
                                } else if (field.dataElement.displayName.trim().toLocaleLowerCase() == "colour code") {
                                    setMedicineColorCodeId(field.dataElement.id)
                                }
                            })
                        } else if (val.attribute.displayName === "Regimen") {
                            setregimenStageId(stage.id)
                            setRegimenStageDEIds(stage)
                        } else if (val.attribute.displayName === "SpecimenTable") { //FOR SPECIMEN COLLECTION STAGE
                            setspecimenStageId(stage.id)
                        }
                    })
                }
            })
        }

    }

    useEffect(() => {
        fetchCaseDetailsFromDatabase()

        return () => {
            localStorage.removeItem("childDropDown");
            // localStorage.removeItem("specimen");
            // localStorage.removeItem("searchtype");
        }
    }, [])

    //this is for UNDP
    useEffect(() => {
        getCustomVariableIds()
        setRegimenStageDataElements()
    }, [])

    useEffect(() => {
        if (trackentityInstanceDetails != null && !_.isEmpty(trackentityInstanceDetails) && navigator.onLine) {
            let InitialValueData = {}
            let promises = []
            const DataElementGroup = dataElementGroup
            const stageList = programData.programs[0].programStages
            let registrationData = _.isEmpty(trackentityInstanceDetails) ? [] : trackentityInstanceDetails.attributes
            let stageData1 = _.isEmpty(trackentityInstanceDetails) ? [] : trackentityInstanceDetails.enrollments[0].events
            let stageData = []

            if (stageList != null) {
                stageList.map(stages => {
                    const filterEvent = stageData1.filter(obj => obj.programStage == stages.id)
                    if (filterEvent.length > 1) {
                        stageData.push(filterEvent[filterEvent.length - 1])
                    } else if (filterEvent.length == 1) {
                        stageData.push(filterEvent[0])
                    }
                    // set stage id regimen
                    if (stages.attributeValues && stages.attributeValues.length > 0) {
                        stages.attributeValues.map((val) => {
                            if (val.attribute.displayName === "Regimen") {
                                if (!_.isEmpty(stageData1)) {

                                    getMedicinesListFromEvents(stages)
                                }
                            } else if (val.attribute.displayName === "showFullCalender") {
                                //handleMedicineRadioChange(event,value,name)
                                let sortedEvents = _.filter(stageData1, { 'programStage': stages.id });
                                if (sortedEvents.length > 0) {
                                    //const grouped = _.groupBy(sortedEvents, { dataValues: ['value']});
                                    //console.log("grouped",grouped,dateMedicineTakenId)
                                    let finalEvents = _.filter(sortedEvents, { dataValues: [{ dataElement: dateMedicineTakenId }] });
                                    //console.log("grouped",finalEvents,dateMedicineTakenId)
                                    let events = [];
                                    finalEvents.map(event => {
                                        let mediDateObj = _.filter(event.dataValues, { dataElement: dateMedicineTakenId });
                                        let mediColorCodeObj = _.filter(event.dataValues, { dataElement: medicineColorCodeId });
                                        if (mediDateObj.length > 0 && mediColorCodeObj.length > 0) {
                                            let obj = {};
                                            obj['start'] = mediDateObj[0].value
                                            obj['end'] = mediDateObj[0].value
                                            obj['allDay'] = true
                                            obj['backgroundColor'] = mediColorCodeObj[0].value
                                            obj['display'] = 'background'
                                            obj['overlap'] = false
                                            obj['editmode'] = true
                                            events.push(obj)
                                        }
                                    })
                                    events = _.uniqBy(events, 'start');
                                    setFullCalendarEvents(events)
                                    //console.log("groupedevents",events)

                                }

                            } else if (val.attribute.displayName === "SpecimenTable") {
                                if (!_.isEmpty(stageData1)) {
                                    // console.log('getdatasputuntable>>>', stages, stageData1, trackentityInstanceDetails)
                                    getSputumTableDetail(stages)
                                }
                            }
                        })
                    }
                })
            }


            registrationData.map(fields => {
                const filterField = programData.programs[0].programTrackedEntityAttributes.find(obj => obj.trackedEntityAttribute.id == fields.attribute)

                InitialValueData[fields.attribute] = fields.value

                if (filterField.trackedEntityAttribute.valueType == 'IMAGE' || filterField.trackedEntityAttribute.valueType == 'FILE_RESOURCE') {

                    if (fields.value) {
                        const resourceGetApi = 'fileResources/' + fields.value
                        promises.push(apiServices.getAPI(resourceGetApi)
                            .then(resources => {
                                return { 'dataElement': fields.dataElement, "value": resources.data }
                            }))
                    }
                }

                // multicheckbox edit logic
                programData.programs[0].programSections.map(programSection => {
                    if (programSection.renderType['DESKTOP'].type == "SEQUENTIAL") {
                        programSection.trackedEntityAttributes.map(elements => {
                            if (programSection.trackedEntityAttributes.find(array => array.id == fields.attribute)) {
                                if (InitialValueData[programSection.id] == undefined) {
                                    InitialValueData[programSection.id] = [fields.attribute]
                                } else {
                                    if (!InitialValueData[programSection.id].includes(fields.attribute)) {
                                        InitialValueData[programSection.id].push(fields.attribute)
                                    }
                                }
                            }
                        })
                    }
                })

            })

            stageData.map(events => {
                events.dataValues.map(fields => {
                    if (stageList != null) {
                        stageList.map(stages => {
                            const filter = stages.programStageDataElements.filter(obj => obj.dataElement.id == fields.dataElement)

                            if (filter.length > 0) {

                                if (filter[0].dataElement.fieldMask == 'Facility Referral') {
                                    InitialValueData[fields.dataElement] = fields.value.split(",")
                                } else if (filter[0].dataElement.valueType == 'IMAGE' || filter[0].dataElement.valueType == 'FILE_RESOURCE') {

                                    if (fields.value) {
                                        const resourceGetApi = 'fileResources/' + fields.value
                                        promises.push(apiServices.getAPI(resourceGetApi)
                                            .then(resources => {
                                                return { 'dataElement': fields.dataElement, "value": resources.data }
                                            }))
                                    }
                                } else {

                                    DataElementGroup.map(DEG => {

                                        DEG.dataElements.map(dataElements => {

                                            if (DEG.dataElements.find(array => array.id == fields.dataElement && fields.value == 'true')) {

                                                if (InitialValueData[DEG.id] == undefined) {
                                                    InitialValueData[DEG.id] = [fields.dataElement]

                                                } else {

                                                    if (!InitialValueData[DEG.id].includes(fields.dataElement)) {
                                                        InitialValueData[DEG.id].push(fields.dataElement)
                                                    }

                                                }
                                            }
                                        })
                                    })
                                    InitialValueData[fields.dataElement] = fields.value == 'false' ? false : fields.value == 'true' ? true : fields.value
                                }
                            }


                        })
                    }

                    // InitialValueData[fields.dataElement] = fields.value

                })
            })


            if (promises.length == 0) {
                const activeCaseFormData = {
                    "data": {
                        'formFormat': InitialValueData, //valueForFormInput,
                        'dhisFormat': null //
                    }

                }

                OfflineDb.setDataIntoPouchDB('activeCaseFormData', activeCaseFormData)
                setActiveCaseFormData(activeCaseFormData)

                if (props.stageTabValue) {
                    setValue(props.stageTabValue)
                } else {
                    if (value == 0 && location?.state?.stageId != "individualrecord") {
                        setValue(1)
                    }
                }





            } else {
                Promise.all(promises).then((responses) => {
                    responses.map(response => {
                        InitialValueData[response.dataElement] = [new File([""], response.value.displayName, {
                            "size": response.value.contentLength,
                            "type": response.value.contentType,
                            "webkitRelativePath": ""
                        })

                        ]

                    })
                    const activeCaseFormData = {
                        "data": {
                            'formFormat': InitialValueData, //valueForFormInput,
                            'dhisFormat': null //
                        }

                    }

                    OfflineDb.setDataIntoPouchDB('activeCaseFormData', activeCaseFormData)
                    setActiveCaseFormData(activeCaseFormData)

                    if (props.stageTabValue) {
                        setValue(props.stageTabValue)
                    } else {
                        if (value == 0 && location?.state?.stageId != "individualrecord") {
                            setValue(1)
                        }
                    }


                })

            }

            //FOR SPECIMEN COLLECTION 


            //GET SPECIMEN ID


        }/*else{
            // if user is offline 
            const activeCaseFormData = {
                "data": {
                    'formFormat': InitialValueData, //valueForFormInput,
                    'dhisFormat': null //
                }

            }

            OfflineDb.setDataIntoPouchDB('activeCaseFormData', activeCaseFormData)
            setActiveCaseFormData(activeCaseFormData)
        }*/
    }, [trackentityInstanceDetails])

    useEffect(() => {
        // console.log('activeCaseFormData>>>', activeCaseFormData)
        resetSpecimen()
    }, [activeCaseFormData])

    useEffect(() => {

        if (activeCaseDetails != null) {
            //DownLoad trackentity instace data using api
            if (activeCaseDetails.data != undefined && navigator.onLine) {
                const getURL = 'trackedEntityInstances/' + activeCaseDetails.data.trackedEntityInstance + '.json?program=' + programData.programs[0].id + '&fields=*?'
                setGlobalSpinner(true)
                apiServices.getAPI(getURL)
                    .then(trackentityInstanceData => {
                        //console.log("trackentityInstanceData789 ",trackentityInstanceData,categoryOptions);
                        setGlobalSpinner(false);
                        if (trackentityInstanceData.data) {
                            setTrackentityInstanceDetails(trackentityInstanceData.data)
                            const indexOfNextTab = programData.programs[0].programStages.findIndex(obj => obj.id == activeCaseDetails.data.stageuid)
                            if (indexOfNextTab > 0) {
                                console.log("indexOfNextTab", indexOfNextTab)
                                setValue(indexOfNextTab + stepIncrement)
                            }
                            if ((!categoryOptions || (categoryOptions && categoryOptions.categoryOptions.length == 0)) && trackentityInstanceData.data.enrollments && trackentityInstanceData.data.enrollments.length > 0) {
                                apiServices.getAPI('categoryOptions?filter=name:eq:' + trackentityInstanceData.data.enrollments[0].storedBy.trim()).then(categoryRes => {
                                    setCategoryOptions(categoryRes.data)
                                }).catch(error => {

                                })
                            }
                        } else {
                            setTrackentityInstanceDetails({})
                        }

                    }).catch(err => {
                        setGlobalSpinner(false)
                    })
            } else {
                setTrackentityInstanceDetails({})
            }
        }
    }, [activeCaseDetails])

    useEffect(() => {
        if (activeCaseFormData && activeCaseFormData.status != 404 && activeCaseFormData != null
            && trackentityInstanceDetails != null
            && localStorage.getItem('searchtype') && localStorage.getItem('specimen')
        ) {
            getSpecimenId()
        }

        if (activeCaseFormData && activeCaseFormData.status != 404 && activeCaseFormData != null
            && searchdata != null && localStorage.getItem('searchtype')) {
            configSpecimenInFormData(searchdata, activeCaseFormData)
        }
    }, [
        activeCaseFormData,
        trackentityInstanceDetails,
        searchdata,
        localStorage.getItem('searchtype'),
        localStorage.getItem('specimen')
    ])

    // configSpecimenInFormData({[dv.dataElement]: dv.value})
    // setsearchdata({[dv.dataElement]: dv.value})

    /*useEffect(()=>{
        if(dateMedicineTakenId != null){
            let initialValues = activeCaseFormData.data ? activeCaseFormData.data.formFormat != null ? activeCaseFormData.data.formFormat : {} : {}
            
            if(!_.isEmpty(initialValues)){
                if(initialValues[dateMedicineTakenId]){
                    let events =[{
                        start  : initialValues[dateMedicineTakenId],
                        end    : initialValues[dateMedicineTakenId],
                        allDay : true,
                        backgroundColor: (initialValues[medicineTakenId] && initialValues[medicineTakenId] == 'Yes') ? 
                                        '#4caf50': 
                                        (initialValues[medicineTakenId] && initialValues[medicineTakenId] == 'No') ? 
                                        "#f44336" :
                                        (initialValues[medicineTakenId] && initialValues[medicineTakenId] == 'Partially Taken') ? 
                                        "#ff5722":
                                        "#00bcd4",
                        display: 'background',
                        overlap: false
                    }]
                    setFullCalendarEvents(events)
                }
            }
        }
    },[dateMedicineTakenId])*/

    const getSampleCollectionStageDetail = () => {
        if (metaData != null && Configuration != null) {
            const searchPageMeta = Configuration.searchpage;
            metaData.programs[0].programStages.map(stage => {
                if (stage.displayName && stage.displayName === searchPageMeta.searchby.stagename) {
                    setStageDetail(stage)
                    stage.programStageDataElements.map(field => {
                        if (field.dataElement.displayName === searchPageMeta.searchby.dataelement) {
                            setdataElementDetail(field.dataElement)
                        }
                        if (field.renderType && field.renderType["DESKTOP"].type == "QR_CODE") {
                            setqrDataElementDetail(field.dataElement)
                        }
                    })
                }
            })
        }
    }

    const getSpecimenId = () => {
        if (!localStorage.getItem('specimen') && !localStorage.getItem('searchtype')) {
            return;
        }
        let selectedSpecimen = JSON.parse(localStorage.getItem('specimen'))
        let searchType = localStorage.getItem('searchtype')

        let sortedEvents = _.filter(trackentityInstanceDetails.enrollments[0].events, { 'programStage': specimenStageId });
        if (sortedEvents.length > 0) {
            // console.log('getSpecimenIdsortedEvents>>>11', selectedSpecimen, sortedEvents)

            sortedEvents.map(event => {
                let sputumTableObj = {}
                sputumTableObj['eventdetails'] = Object.assign({}, event);
                event.dataValues.map(dv => {
                    // console.log('getSpecimenIdsortedEvents>>>00', dv.dataElement, selectedSpecimen[dv.dataElement])

                    if (selectedSpecimen.hasOwnProperty(dv.dataElement)
                        && dv.value == selectedSpecimen[dv.dataElement]
                        && searchType == 'id') {
                        // console.log('getSpecimenIdsortedEvents>>>22', dv.value)
                        setsearchdata({ [dv.dataElement]: dv.value })
                    }

                    if (selectedSpecimen.hasOwnProperty(dv.dataElement)
                        && dv.value == selectedSpecimen[dv.dataElement]
                        && searchType == 'qr') {
                        let spid = _.find(event.dataValues, { 'dataElement': specimenid });
                        setsearchdata({ [spid.dataElement]: spid.value })
                    }
                })
            })

        }
    }

    const configSpecimenInFormData = (obj, formData) => {
        if (!formData) {
            return
        }
        if (formData == null) {
            return
        }
        let formvalues = _.cloneDeep(formData);
        formvalues.data.formFormat[Object.keys(obj)[0]] = Object.values(obj)[0];
        const activeCaseFormData = {
            data: {
                'formFormat': formvalues.data.formFormat, //valueForFormInput,
                'dhisFormat': null //
            }
        }
        let tempobj = _.cloneDeep(activeCaseFormData)
        setActiveCaseFormData(tempobj)
        setsearchdata(null)
        localStorage.removeItem('specimen')
        localStorage.removeItem('searchtype')
    }

    const handleChange = (event, newValue) => {

        setValue(newValue);
    };

    function fetchActiveTabs(currentStage, formValues) {
        // console.log('currentStageformValues', formValues)
        let Flag = true
        const values = formValues //activeCaseFormData.data ? activeCaseFormData.data.formFormat : {}
        // console.log('tabschecking', values)
        let prevStageId = ''
        let workFlowHideFlag = true
        let submittedEventsList = _.isEmpty(trackentityInstanceDetails) ? [] : trackentityInstanceDetails.enrollments[0].events
        if (programRules != null && programRulesVariables != null) {
            programRules.map(rules => {

                const filteredRule = rules.programRuleActions.filter(obj => obj.programRuleActionType == "HIDEPROGRAMSTAGE")

                if (filteredRule.length > 0) {
                    const getStageRule = filteredRule.find(obj => obj.programStage.id == currentStage.id)
                    if (getStageRule != undefined) {

                        const operators = ['==', '!=']
                        const condition = rules.condition
                        const splitConditions = condition.split("&&")

                        let val = null
                        let conditionArray = []
                        splitConditions.map(splitCondition => {
                            const variableName = splitCondition.match(/\{(.*?)\}/)[1]
                            const parentRaw = programRulesVariables.filter(obj => obj.displayName == splitCondition.match(/\{(.*?)\}/)[1]) //[0] .dataElement.id
                            const parentNameFromFilter = parentRaw.length > 0 ? parentRaw[0].displayName : undefined
                            const parentId = parentRaw.length > 0 ? parentRaw[0].dataElement ? parentRaw[0].dataElement.id : undefined : undefined

                            const parentNameFromFilterStart = splitCondition.search(parentNameFromFilter)
                            const parentNameLength = parentNameFromFilter ? parentNameFromFilter.length : undefined

                            const operatorInitLength = parentNameFromFilterStart + parentNameLength + 2

                            const operator = splitCondition.substring(operatorInitLength, operatorInitLength + 2)

                            const alternateOperatorFinding = operators.map(ops => {
                                if (splitCondition.search(ops) > -1) {
                                    const a = {
                                        'operator': ops,
                                        'operatorLength': splitCondition.search(ops)
                                    }
                                    return a
                                }
                            })

                            const stringLength = splitCondition.length
                            if (parentNameFromFilter) {

                                const filteredOperator = alternateOperatorFinding.filter(obj => obj != undefined)

                                const conditionValueRaw = filteredOperator.length > 0 ? splitCondition.substring(filteredOperator[0].operatorLength + 3, splitCondition.length) : undefined

                                const removeEmptySpace =
                                    conditionValueRaw != undefined
                                        ?
                                        conditionValueRaw.substring(conditionValueRaw.length - 1, conditionValueRaw.length) == ' '
                                            ?
                                            conditionValueRaw.substring(0, conditionValueRaw.length - 1)
                                            :
                                            conditionValueRaw
                                        :
                                        undefined

                                const conditionValue = removeEmptySpace != undefined ? removeEmptySpace.substring(1, removeEmptySpace.length - 1) : undefined
                                const conditionalOperator = filteredOperator.length > 0 ? filteredOperator[0].operator : undefined
                                let conditionForValidation = null
                                if (conditionalOperator != undefined) {

                                    val = conditionValue
                                    switch (conditionalOperator) {
                                        case '==':
                                            if (values != undefined) {

                                                if (values[parentId] != undefined && String(values[parentId]) == String(conditionValue)) {

                                                    Flag = false
                                                } else {
                                                    Flag = true
                                                }
                                            }

                                            break;
                                    }


                                }

                            }
                        })


                    }
                }

            })
        }



        if (Flag == true) {
            if (activeTabsOnSubmit[activeTabsOnSubmit.length - 1]) {


                // console.log('submittedEventsList', submittedEventsList, activeTabsOnSubmit)
                prevStageId = activeTabsOnSubmit[activeTabsOnSubmit.length - 1]
                let filterPrevStageEvents = submittedEventsList.filter(obj => obj.programStage == prevStageId)
                // console.log('filterPrevStageEvents', filterPrevStageEvents)
                if (filterPrevStageEvents.length > 0) {

                    const prevStageLatestData = filterPrevStageEvents[0] //filterPrevStageEvents[filterPrevStageEvents.length - 1]
                    const prevStageLatestDataEventId = prevStageLatestData.event
                    const findIndexOfPrevStageLatestDataEventId = submittedEventsList.findIndex(obj => obj.event == prevStageLatestDataEventId)
                    const findNextIndexOfIndexOfPrevStageLatestDataEventId = submittedEventsList[findIndexOfPrevStageLatestDataEventId + 1]

                    if (findNextIndexOfIndexOfPrevStageLatestDataEventId == undefined) {
                        workFlowHideFlag = false

                    } else {
                        workFlowHideFlag = true

                    }

                } else {

                    workFlowHideFlag = false
                }
            } else {

                workFlowHideFlag = true
            }

            activeTabsOnSubmit.push(currentStage.id)

        } else {

        }
        // console.log('activeTabsOnSubmit', activeTabsOnSubmit)
        return activeTabsOnSubmit
    }

    function checkTabs(currentStage) {
        // console.log('currentStage', currentStage, trackentityInstanceDetails, activeCaseFormData, programRules, programRulesVariables)
        let Flag = true
        const values = activeCaseFormData.data ? activeCaseFormData.data.formFormat : {}
        // console.log('tabschecking', values)
        let prevStageId = ''
        let workFlowHideFlag = true
        let submittedEventsList = _.isEmpty(trackentityInstanceDetails) ? [] : trackentityInstanceDetails.enrollments[0].events
        if (programRules != null && programRulesVariables != null) {
            programRules.map(rules => {

                const filteredRule = rules.programRuleActions.filter(obj => obj.programRuleActionType == "HIDEPROGRAMSTAGE")

                if (filteredRule.length > 0) {
                    const getStageRule = filteredRule.find(obj => obj.programStage.id == currentStage.id)
                    if (getStageRule != undefined) {

                        const operators = ['==', '!=']
                        const condition = rules.condition
                        const splitConditions = condition.split("&&")

                        let val = null
                        let conditionArray = []
                        splitConditions.map(splitCondition => {
                            const variableName = splitCondition.match(/\{(.*?)\}/)[1]
                            const parentRaw = programRulesVariables.filter(obj => obj.displayName == splitCondition.match(/\{(.*?)\}/)[1]) //[0] .dataElement.id
                            const parentNameFromFilter = parentRaw.length > 0 ? parentRaw[0].displayName : undefined
                            const parentId = parentRaw.length > 0 ? parentRaw[0].dataElement ? parentRaw[0].dataElement.id : undefined : undefined

                            const parentNameFromFilterStart = splitCondition.search(parentNameFromFilter)
                            const parentNameLength = parentNameFromFilter ? parentNameFromFilter.length : undefined

                            const operatorInitLength = parentNameFromFilterStart + parentNameLength + 2

                            const operator = splitCondition.substring(operatorInitLength, operatorInitLength + 2)

                            const alternateOperatorFinding = operators.map(ops => {
                                if (splitCondition.search(ops) > -1) {
                                    const a = {
                                        'operator': ops,
                                        'operatorLength': splitCondition.search(ops)
                                    }
                                    return a
                                }
                            })

                            const stringLength = splitCondition.length
                            if (parentNameFromFilter) {

                                const filteredOperator = alternateOperatorFinding.filter(obj => obj != undefined)

                                const conditionValueRaw = filteredOperator.length > 0 ? splitCondition.substring(filteredOperator[0].operatorLength + 3, splitCondition.length) : undefined

                                const removeEmptySpace =
                                    conditionValueRaw != undefined
                                        ?
                                        conditionValueRaw.substring(conditionValueRaw.length - 1, conditionValueRaw.length) == ' '
                                            ?
                                            conditionValueRaw.substring(0, conditionValueRaw.length - 1)
                                            :
                                            conditionValueRaw
                                        :
                                        undefined

                                const conditionValue = removeEmptySpace != undefined ? removeEmptySpace.substring(1, removeEmptySpace.length - 1) : undefined
                                const conditionalOperator = filteredOperator.length > 0 ? filteredOperator[0].operator : undefined
                                let conditionForValidation = null
                                if (conditionalOperator != undefined) {

                                    val = conditionValue
                                    switch (conditionalOperator) {
                                        case '==':
                                            if (values != undefined) {

                                                if (values[parentId] != undefined && String(values[parentId]) == String(conditionValue)) {

                                                    Flag = false
                                                } else {
                                                    Flag = true
                                                }
                                            }

                                            break;
                                    }


                                }

                            }
                        })


                    }
                }

            })
        }



        if (Flag == true) {
            if (activeTabs[activeTabs.length - 1]) {


                // console.log('submittedEventsList', submittedEventsList, activeTabs)
                prevStageId = activeTabs[activeTabs.length - 1]
                let filterPrevStageEvents = submittedEventsList.filter(obj => obj.programStage == prevStageId)
                // console.log('filterPrevStageEvents', filterPrevStageEvents)
                if (filterPrevStageEvents.length > 0) {

                    const prevStageLatestData = filterPrevStageEvents[0] //filterPrevStageEvents[filterPrevStageEvents.length - 1]
                    const prevStageLatestDataEventId = prevStageLatestData.event
                    const findIndexOfPrevStageLatestDataEventId = submittedEventsList.findIndex(obj => obj.event == prevStageLatestDataEventId)
                    const findNextIndexOfIndexOfPrevStageLatestDataEventId = submittedEventsList[findIndexOfPrevStageLatestDataEventId + 1]

                    if (findNextIndexOfIndexOfPrevStageLatestDataEventId == undefined) {
                        workFlowHideFlag = false

                    } else {
                        workFlowHideFlag = true

                    }

                } else {

                    workFlowHideFlag = false
                }
            } else {

                workFlowHideFlag = true
            }

            activeTabs.push(currentStage.id)

        } else {

        }
        //console.log('activeTabs', activeTabs)
        if (workFlow) {
            if (Flag && workFlowHideFlag) {
                return true
            } else {
                return false
            }
        } else {
            return Flag
        }

    }
    function stageAccessCheck(stages) {
        const userList = stages.userAccesses
        let stageAcsess = false
        const getUSerBo = userData
        const filterUserIdInMeta = userList.filter(obj => obj.id == getUSerBo.id)
        if (filterUserIdInMeta.length > 0) {
            const filteredUserList = filterUserIdInMeta[0].access
            if (filteredUserList == 'rw------' || filteredUserList == 'rwrw----') {
                stageAcsess = true
            }
        }
        return stageAcsess
    }

    function renderRegistrationSections() {

    }



    function renderRegistrationField(registrationFields, values, form) {
        if (values && values["dHDHVYFgokt"]) {
            if (values["dHDHVYFgokt"].includes('-')) {
                let yob = values["dHDHVYFgokt"].split('-');
                if (yob[0]) {
                    values["dHDHVYFgokt"] = yob[0];
                }
            }
        }

        const onGoogleLocatioChangeParent = (value) => {
            values[value.fieldId] = value.value.label
            if (Configuration.registrationForm.googleLocationLatLngFeilds[value.fieldId]) {
                if (Configuration.registrationForm.googleLocationLatLngFeilds[value.fieldId].lat && Configuration.registrationForm.googleLocationLatLngFeilds[value.fieldId].lng) {
                    if (value.lat && value.lng) {
                        values[Configuration.registrationForm.googleLocationLatLngFeilds[value.fieldId].lat] = value.lat.toString()
                        values[Configuration.registrationForm.googleLocationLatLngFeilds[value.fieldId].lng] = value.lng.toString()
                    }
                }
            }

            const activeCaseFormData = {
                "data": {
                    'formFormat': values, //valueForFormInput,
                    'dhisFormat': null //
                }

            }

            OfflineDb.setDataIntoPouchDB('activeCaseFormData', activeCaseFormData)
            setActiveCaseFormData(activeCaseFormData)
        }
        return <CreateField fieldData={registrationFields} values={values} programRules={programRules} programData={programData.programs[0]} programRulesVariables={programRulesVariables} linkContactFlag={linkContactFlag} onGoogleLocatioChangeParent={onGoogleLocatioChangeParent} activeCaseDetails={activeCaseDetails} OUJSON={OUJSON} Configuration={Configuration} sessionUserBo={sessionUserBoValue}
            stateList={statesList} townshipList={townshipList} customfieldobj={customfieldobj}
        />
    }

    function renderStageField(fields, values, form, stages, section) {
        let allEvents = _.isEmpty(trackentityInstanceDetails) ? [] : trackentityInstanceDetails.enrollments[0].events;
        let event = _.filter(allEvents, { "programStage": stages[0].programStage.id });
        let orgID = values ? values[hotspotsID] ? values[hotspotsID] : userData.organisationUnits[0].id : userData.organisationUnits[0].id;
        let newServiceData = {}
        // if(newServiceStartFlag){
        //             if((fields.id == FirsttimeyoureceivePreventionservicesinyourlife) 
        //                 &&
        //                 values[FirsttimeyoureceivePreventionservicesinyourlife]  &&
        //                 values[FirsttimeyoureceivePreventionservicesinyourlife] == "Yes" 
        //             ){ 
        //                 // isDisabled = true;
        //                 values[FirsttimeyoureceivePreventionservicesinyourlife] = "No";
        //             }
        //         }
        if (tempActiveCaseFormData) {
            event = [];
        } else if (sessionUserBoValue && sessionUserBoValue.userCredentials && sessionUserBoValue.userRoles && sessionUserBoValue.userRoles[0].name && (sessionUserBoValue.userRoles[0].name == 'HTC' || sessionUserBoValue.userRoles[0].name == 'ART user' || sessionUserBoValue.userRoles[0].name == 'Supervisor user' || sessionUserBoValue.userRoles[0].name == 'ART-I user')) {
            event = [];
        }
        if (newServiceStartFlag && tempActiveCaseFormData) {
            let tempData = tempActiveCaseFormData.data.formFormat
            if (section && section.name == 'HTS' && tempData["tgft2rEpVts"] && tempData["tgft2rEpVts"] == "Yes") {
                values = tempData
                newServiceData["isNewService"] = true
                newServiceData["values"] = tempData
                event = _.filter(allEvents, { "programStage": stages[0].programStage.id });
                setServiceStartFlag(false)
                //console.log("values",values);
            }
        }
        return <CreateStageField customfieldobj={customfieldobj} customIsDisable={customIsDisable} fieldData={fields} values={values} programRules={programRules} programData={programData.programs[0]} programRulesVariables={programRulesVariables} dataElementGroup={dataElementGroup} stages={stages} orgid={orgID} OUJSON={OUJSON} stagesData={event} newServiceData={newServiceData} townshipList={townshipList} />
    }

    function renderStageBySection(stage, values, form, programRules, icons) {
        let sectionWiseDE = [];
        stage.programStageSections.map((section) => {
            let hidesection = false;
            // if(stage.name == "ORW component" && section.name == "General"){
            //     hidesection = true;
            //     // if(activeCaseDetails && activeCaseDetails.data && activeCaseDetails.data.caseType &&
            //     //     (activeCaseDetails.data.caseType == "ServicedBy" || activeCaseDetails.data.caseType == "RegisteredBy") 
            //     //     // && newServiceStartFlag
            //     // ){
            //     //         hidesection = false;
            //     // }
            // }
            // if(hidesection){
            //     return;
            // }
            sectionWiseDE.push(
                <Grid container spacing={3} className="mb-30px tasklistcontainer sectiondivmaincontainer">
                    <Grid item xs={12} sm={12} md={12}>
                        <Accordion defaultExpanded>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography className={classes.heading}>{t(section.name)}</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Typography>
                                    {/* <div>
                                        <p className="sectionquestiontitle">1.Food Safety</p>
                                    </div> */}
                                    <div>

                                        <Grid container spacing={3} className="">
                                            {/* <Grid item xs={12} sm={6} md={6} lg={3}> */}
                                            {section.dataElements.map((de) => {
                                                return stage.programStageDataElements.map((fields) => {
                                                    if (de.id == fields.dataElement.id) {
                                                        //console.log(de.id, fields.dataElement.id);
                                                        return renderStageField(fields, values ? values : {}, form, stage.programStageDataElements, section)
                                                    }
                                                });
                                            })}
                                            {/* </Grid> */}
                                        </Grid>
                                    </div>
                                </Typography>
                            </AccordionDetails>
                        </Accordion>
                    </Grid>
                </Grid>
            )
        });
        //console.log(sectionWiseDE);
        return sectionWiseDE;
    }

    function getUICFromAPI() {
        return new Promise((resolve, reject) => {
            if (navigator.onLine) {
                setGlobalSpinner(true)
                apiServices.generateUIC(caseNumberId)
                    .then(response => {
                        resolve(response.value)
                        setGlobalSpinner(false)
                    }).catch(err => {
                        setGlobalSpinner(false)
                        resolve()
                    })
            } else {
                resolve("OFFEOAPP")
            }
        })
    }
    function loadErrorPopup(err) {
        let errorMsg = ''
        let errorCode = ''
        try {
            if (err.response && err.response.data && err.response.data.response && err.response.data.response.importSummaries && err.response.data.response.importSummaries[0] && err.response.data.response.importSummaries[0].conflicts && err.response.data.response.importSummaries[0].conflicts[0]) {
                errorCode = err.response.data.httpStatusCode + " : " + err.response.data.httpStatus
                errorMsg = err.response.data.response.importSummaries[0].conflicts[0].value
                if (err.response.data.response.importSummaries[0].conflicts.length > 1 && err.response.data.response.importSummaries[0].conflicts[1]) {
                    errorMsg = errorMsg + " <br/> " + err.response.data.response.importSummaries[0].conflicts[1].value
                }
            } else if (err.response && err.response.data && err.response.data.response && err.response.data.response.conflicts && err.response.data.response.conflicts[0]) {
                errorCode = err.response.data.httpStatusCode + " : " + err.response.data.httpStatus
                errorMsg = err.response.data.response.conflicts[0].value
                if (err.response.data.response.conflicts.length > 1 && err.response.data.response.conflicts[1]) {
                    errorMsg = errorMsg + " <br/> " + err.response.data.response.conflicts[1].value
                }
            } else if (err.response && err.response.data && err.response.data && err.response.data.httpStatusCode) {
                errorCode = err.response.data.httpStatusCode
                errorMsg = err.response.data.httpStatus + " : " + err.response.data.message
            }

        } catch (e) {
            console.log(e)
            errorMsg = t("Sorry, something went wrong...")
            setGlobalSpinner(false)
        }
        swal({
            title: errorCode ? errorCode : t("Error"),
            text: errorMsg,
            icon: "error",
            button: t("Close"),
        });
        setGlobalSpinner(false)
    }


    //   if(location.state?.from?.pathname == "layout/individualrecord"){
    console.log("activeCaseDetails>>>", activeCaseDetails)
    //   }
    async function saveRegData(valuesToSave, valueForFormInput) {
        // console.log("valuesToSave",valuesToSave,valueForFormInput)

        const orgUnit = valueForFormInput ? valueForFormInput[hotspotsID] ? valueForFormInput[hotspotsID] : userData.organisationUnits[0].id : userData.organisationUnits[0].id;//userData.organisationUnits[0].id
        const trackedEntityType = programData.programs[0].trackedEntityType.id
        let registrationFields = programData.programs[0].programTrackedEntityAttributes
        try {
            //valuesToSave.push({"attribute":regUsernameID,"value":currentLoginUsername})
            let userNameField = _.find(valuesToSave, { "attribute": regUsernameID })
            if (!userNameField && !valueForFormInput[regUsernameID]) {
                valuesToSave.push({ "attribute": regUsernameID, "value": currentLoginUsername })
            }
            let checkCaseNumber = _.find(valuesToSave, { "attribute": caseNumberId })
            if (!checkCaseNumber && !valueForFormInput[caseNumberId]) {
                let getCaseNumber = await getUICFromAPI()
                valueForFormInput[caseNumberId] = getCaseNumber
                valuesToSave.push({ "attribute": caseNumberId, "value": getCaseNumber })
            }
        } catch (e) {
            console.log(e);
        }
        let saveCaseInput = {
            "trackedEntityType": trackedEntityType,
            "orgUnit": orgUnit,
            "attributes": valuesToSave,
            "enrollments": [
                {
                    //"trackedEntityInstance": trackedEntityInstance,
                    "program": programData.programs[0].id,
                    //"status": "ACTIVE",
                    "orgUnit": orgUnit,
                    "enrollmentDate": moment().format("YYYY-MM-DD"),
                    "incidentDate": moment().format("YYYY-MM-DD")
                }
            ],
            "geometry": { "type": "Point", "coordinates": [currentGeolocation.lng, currentGeolocation.lat] }
        }

        let searchableFields = []
        let searchQuery = ``
        if (navigator.onLine) {
            if (dedupEnabled) {
                setGlobalSpinner(true)
                registrationFields.map(fields => {
                    if ((fields.searchable == true || fields.fields == 'true') && (fields.trackedEntityAttribute.displayName.trim().toLowerCase() != 'qr code')) {
                        searchableFields.push(fields.trackedEntityAttribute.id)
                    }
                })

                searchableFields.map(searchableField => {
                    if (valuesToSave.find(obj => obj.attribute == searchableField) != undefined) {
                        const findValue = valuesToSave.find(obj => obj.attribute == searchableField)
                        searchQuery += `&attribute=${searchableField}:LIKE:${findValue.value}`
                    }

                })
                //let subURL = 'trackedEntityInstances/query.json?ou=' + orgUnit + '&ouMode=ACCESSIBLE&&order=created:desc&program=' + programData.programs[0].id + searchQuery + '&pageSize=50&page=1&totalPages=false'
                let subURL = 'trackedEntityInstances/query.json?&ouMode=ALL&&order=created:desc&program=' + programData.programs[0].id + searchQuery + '&pageSize=50&page=1&totalPages=false'
                apiServices.getAPI(subURL).then(searchResponse => {
                    setGlobalSpinner(false)

                    if (searchResponse.data.rows.length > 0) {

                        setSearchHeader(searchResponse.data.headers)
                        setSearchResponse(searchResponse.data.rows)
                        setFormValuePostDeDup({ 'valuesToSave': valuesToSave, 'valueForFormInput': valueForFormInput })
                    }

                })

            } else {

                setGlobalSpinner(true)
                apiServices.postAPI('trackedEntityInstances', saveCaseInput)
                    .then(response => {


                        const trackedEntityInstance = response.data.response.importSummaries[0].reference
                        const programId = programData.programs[0].id
                        const enrollmentInputJson = {
                            "trackedEntityInstance": trackedEntityInstance,
                            "program": programId,
                            "status": "ACTIVE",
                            "orgUnit": orgUnit,
                            "enrollmentDate": moment().format("YYYY-MM-DD"),
                            "incidentDate": moment().format("YYYY-MM-DD")
                        }
                        setGlobalSpinner(false)
                        //apiServices.postAPI('enrollments', enrollmentInputJson)
                        //.then(enrollmentResponse => {
                        const enroll = '';//enrollmentResponse.data.response.importSummaries[0].reference
                        if (programData.programs[0].useFirstStageDuringRegistration == false && relationShipId != "" && Configuration.registrationForm.linkContactInAlert) {
                            // Not in use
                            if (valueForFormInput[PresentlyOnAntiTBMedicationId] && valueForFormInput[PresentlyOnAntiTBMedicationId] == "YES") {
                                swal({
                                    title: t("Individual Registered"),
                                    text: t("Do you want to initiate the individual registration?"),
                                    icon: "success",
                                    buttons: [t("No"), t("Yes")],
                                })
                                    .then((AlertRes) => {
                                        if (AlertRes) {
                                            //save data
                                            const activeCaseDetails = {
                                                'trackedEntityInstance': trackedEntityInstance,
                                                'enrollmentId': enroll,
                                            }
                                            const linkContact = {
                                                "enabled": true,
                                                "linkTrackedEntityInstance": trackedEntityInstance
                                            }
                                            const activeCaseFormData = {
                                                'formFormat': null, //valueForFormInput,
                                                'dhisFormat': null //
                                            }
                                            // setActiveCaseDetails({
                                            //     'data': {

                                            //         'trackedEntityInstance': trackedEntityInstance,
                                            //         'enrollmentId': enroll,

                                            //     }
                                            // })

                                            OfflineDb.setDataIntoPouchDB('activeCaseDetails', activeCaseDetails)
                                            OfflineDb.setDataIntoPouchDB('activeCaseFormData', activeCaseFormData)
                                            OfflineDb.setDataIntoPouchDB('linkContactFlag', linkContact)


                                            // setActiveCaseDetails({
                                            //     'data': {

                                            //         'trackedEntityInstance': trackedEntityInstance,
                                            //         'enrollmentId': enroll,

                                            //     }
                                            // })
                                            setLinkContactFlag({
                                                "data": linkContact
                                            })
                                            OfflineDb.setDataIntoPouchDB('activeCaseDetails', activeCaseDetails)
                                            OfflineDb.setDataIntoPouchDB('activeCaseFormData', activeCaseFormData)
                                            OfflineDb.setDataIntoPouchDB('linkContactFlag', linkContact)

                                            setActiveCaseFormData({
                                                "data": {
                                                    'formFormat': null, //valueForFormInput,
                                                    'dhisFormat': null //
                                                }
                                            })
                                            setValue(0)

                                            //empty form
                                        } else {
                                            history.push("/layout/home");

                                        }

                                    })
                            } else {
                                //save data
                                const activeCaseDetails = {
                                    'trackedEntityInstance': trackedEntityInstance,
                                    'enrollmentId': enroll,
                                }

                                const activeCaseFormData = {
                                    'formFormat': valueForFormInput,
                                    'dhisFormat': valuesToSave
                                }
                                const linkContact = {
                                    "enabled": false,
                                    "linkTrackedEntityInstance": trackedEntityInstance
                                }
                                OfflineDb.setDataIntoPouchDB('activeCaseDetails', activeCaseDetails)
                                OfflineDb.setDataIntoPouchDB('activeCaseFormData', activeCaseFormData)
                                OfflineDb.setDataIntoPouchDB('linkContactFlag', linkContact)
                                swal({
                                    title: t("Success"),
                                    text: t("Individual Registered"),
                                    icon: "success",
                                    button: t("Close"),
                                });
                                //laod next active tab
                                const nextTab = activeTabs[0]
                                console.log("nextTab", nextTab, programData.programs[0].programStages)
                                if (nextTab) {
                                    const indexOfNextTab = programData.programs[0].programStages.findIndex(obj => obj.id == nextTab)
                                    console.log("nextTab", nextTab, indexOfNextTab, programData.programs[0].programStages)
                                    setValue(indexOfNextTab + 1)
                                } else {
                                    setValue(value)
                                }
                                console.log("nextTab", nextTab, value)
                                setActiveCaseDetails({
                                    'data': {
                                        'trackedEntityInstance': trackedEntityInstance,
                                        'enrollmentId': enroll,
                                    }
                                })
                            }

                        } else {
                            const activeCaseDetails = {
                                'trackedEntityInstance': trackedEntityInstance,
                                'enrollmentId': enroll,
                            }

                            const activeCaseFormData = {
                                'formFormat': valueForFormInput,
                                'dhisFormat': valuesToSave
                            }
                            const linkContact = {
                                "enabled": false,
                                "linkTrackedEntityInstance": trackedEntityInstance
                            }
                            OfflineDb.setDataIntoPouchDB('activeCaseDetails', activeCaseDetails)
                            OfflineDb.setDataIntoPouchDB('activeCaseFormData', activeCaseFormData)
                            OfflineDb.setDataIntoPouchDB('linkContactFlag', linkContact)
                            swal({
                                title: t("Success"),
                                text: t("Individual Registered"),
                                icon: "success",
                                button: t("Close"),
                            });
                            //save data 
                            if (valueForFormInput[PresentlyOnAntiTBMedicationId] && valueForFormInput[PresentlyOnAntiTBMedicationId] == "YES" && valueForFormInput[verifiedFieldId] && valueForFormInput[verifiedFieldId] == "Yes") {

                                const indexOfNextTab = programData.programs[0].programStages.findIndex(obj => obj.displayName == "TB treatment initiation form")
                                setValue(indexOfNextTab + stepIncrement)
                            } else {
                                //laod next active tab
                                const nextTab = activeTabs[0]
                                console.log("nextTab", nextTab, activeTabs, programData.programs[0].programStages, valueForFormInput)
                                if (nextTab) {
                                    const indexOfNextTab = programData.programs[0].programStages.findIndex(obj => obj.id == nextTab)
                                    console.log("nextTab", nextTab, indexOfNextTab, programData.programs[0].programStages)
                                    setValue(indexOfNextTab + stepIncrement)
                                } else {
                                    setValue(value)
                                    console.log("nextTab", nextTab, value, programData.programs[0].programStages)
                                }
                            }
                            setActiveCaseDetails({
                                'data': {
                                    'trackedEntityInstance': trackedEntityInstance,
                                    'enrollmentId': enroll,
                                }
                            })
                            setActiveCaseFormData({
                                "data": {
                                    'formFormat': valueForFormInput, //valueForFormInput,
                                    'dhisFormat': valuesToSave //
                                }
                            })
                        }
                        //})
                        setGlobalSpinner(false)
                    }).catch(err => {

                        // swal({
                        //     title: t("Error"),
                        //     text: "",
                        //     icon: "error",
                        //     button: t("Close"),
                        // });
                        loadErrorPopup(err)
                        setGlobalSpinner(false)
                    })

            }
        } else {

            //OfflineStorage
            OfflineDb.getAllEntities().then(res => {
                if (res && res.total_rows == Configuration.offline.storagelimit) {
                    swal({
                        title: t("LIMIT EXCEEDED"),
                        text: t(`you have reached a limit of ${Configuration.offline.storagelimit} records, please sync offline records and try again`),
                        icon: "warning",
                        button: t("Close"),
                    });
                } else {
                    //console.log('valuesToSave, valueForFormInput',valuesToSave, valueForFormInput,offlineFieldId)
                    //valueForFormInput[offlineFieldId] = Date.now();
                    // console.log(' valueForFormInput', valueForFormInput,valuesToSave)
                    // return;
                    let offlineObj = { data: valueForFormInput, "registration": saveCaseInput, "services": [], "formVersion": programData.programs[0].version };
                    OfflineDb.saveEntity(offlineObj).then(res => {

                        const activeCaseDetails = {
                            'trackedEntityInstance': res.id,
                            'enrollmentId': "",
                        }
                        const activeCaseFormData = {
                            'formFormat': valueForFormInput,
                            'dhisFormat': valuesToSave
                        }
                        const linkContact = {
                            "enabled": false,
                            "linkTrackedEntityInstance": res.id
                        }

                        setActiveCaseDetails({
                            'data': {
                                'trackedEntityInstance': res.id,
                                'enrollmentId': ""
                            }
                        })
                        setActiveCaseFormData({
                            data: activeCaseFormData,
                        });
                        OfflineDb.setDataIntoPouchDB('activeCaseDetails', activeCaseDetails)
                        OfflineDb.setDataIntoPouchDB('activeCaseFormData', activeCaseFormData)
                        OfflineDb.setDataIntoPouchDB('linkContactFlag', linkContact)
                        swal({
                            title: t("Success"),
                            text: t("Individual Registered Offline"),
                            icon: "success",
                            button: t("Close"),
                        });
                        //save data 

                        //laod next active tab
                        const nextTab = activeTabs[0]
                        if (nextTab) {
                            const indexOfNextTab = programData.programs[0].programStages.findIndex(obj => obj.id == nextTab)

                            setValue(indexOfNextTab + 1)
                        } else {
                            setValue(value)
                        }
                    })
                }
            })
        }
    }

    function linkeRegData(valuesToSave, valueForFormInput) {
        const orgUnit = valueForFormInput ? valueForFormInput[hotspotsID] ? valueForFormInput[hotspotsID] : userData.organisationUnits[0].id : userData.organisationUnits[0].id;//userData.organisationUnits[0].id
        const trackedEntityType = programData.programs[0].trackedEntityType.id
        let registrationFields = programData.programs[0].programTrackedEntityAttributes

        let saveCaseInput =
        //{
        //     "trackedEntityType": trackedEntityType,
        //     "orgUnit": orgUnit,
        //     "attributes": valuesToSave
        // }

        {
            "trackedEntityType": trackedEntityType,
            "orgUnit": orgUnit,
            "attributes": valuesToSave,
            "enrollments": [
                {
                    //"trackedEntityInstance": trackedEntityInstance,
                    "program": programData.programs[0].id,
                    //"status": "ACTIVE",
                    "orgUnit": orgUnit,
                    "enrollmentDate": moment().format("YYYY-MM-DD"),
                    "incidentDate": moment().format("YYYY-MM-DD")
                }
            ],
            "geometry": { "type": "Point", "coordinates": [currentGeolocation.lng, currentGeolocation.lat] }
        }

        if (navigator.onLine) {


            setGlobalSpinner(true)
            apiServices.postAPI('trackedEntityInstances', saveCaseInput)
                .then(response => {

                    const trackedEntityInstance = response.data.response.importSummaries[0].reference
                    const programId = programData.programs[0].id
                    const enrollmentInputJson = {
                        "trackedEntityInstance": trackedEntityInstance,
                        "program": programId,
                        "status": "ACTIVE",
                        "orgUnit": orgUnit,
                        "enrollmentDate": moment().format("YYYY-MM-DD"),
                        "incidentDate": moment().format("YYYY-MM-DD")
                    }

                    // apiServices.postAPI('enrollments', enrollmentInputJson)
                    //     .then(enrollmentResponse => {

                    const enroll = '' //enrollmentResponse.data.response.importSummaries[0].reference
                    const getURL = 'trackedEntityInstances/' + linkContactFlag.data.linkTrackedEntityInstance + '.json?program=' + programId + '&fields=*?'
                    apiServices.getAPI(getURL)
                        .then(getParentData => {
                            const parentAttribute = []
                            getParentData.data.attributes.map(attributes => {
                                const obj = {
                                    'attribute': attributes.attribute,
                                    'value': attributes.value
                                }
                                parentAttribute.push(obj)
                            })

                            getParentData.data.relationships.push({
                                "from":
                                {
                                    "trackedEntityInstance":
                                        { "trackedEntityInstance": linkContactFlag.data.linkTrackedEntityInstance }
                                },
                                "to":
                                {
                                    "trackedEntityInstance":
                                        { "trackedEntityInstance": trackedEntityInstance }
                                },
                                "relationshipType": relationShipId
                            });

                            const linkContactJson = {
                                "created": moment().format("YYYY-MM-DD"),
                                "orgUnit": orgUnit,
                                "createdAtClient": moment().format("YYYY-MM-DD"),
                                "trackedEntityInstance": linkContactFlag.data.linkTrackedEntityInstance,
                                "lastUpdated": moment().format("YYYY-MM-DD"),
                                "trackedEntityType": trackedEntityType,
                                "lastUpdatedAtClient": moment().format("YYYY-MM-DD"),
                                "inactive": false,
                                "deleted": false,
                                "featureType": "NONE",
                                "programOwners": [
                                    {
                                        "ownerOrgUnit": orgUnit,
                                        "program": programId,
                                        "trackedEntityInstance": linkContactFlag.data.linkTrackedEntityInstance
                                    }],
                                "relationships": getParentData.data.relationships,
                                "attributes": parentAttribute,
                                "geometry": { "type": "Point", "coordinates": [currentGeolocation.lng, currentGeolocation.lat] }
                            }

                            const putURL = 'trackedEntityInstances/' + linkContactFlag.data.linkTrackedEntityInstance

                            apiServices.putAPI(putURL, linkContactJson)
                                .then(linkResponse => {
                                    if (Configuration.registrationForm.linkContactInAlert) {
                                        swal({
                                            title: t("Contact Registered"),
                                            text: t("Do you want to register another Contact?"),
                                            icon: "success",
                                            buttons: [t("No"), t("Yes")],
                                        })
                                            .then((AlertRes) => {
                                                if (AlertRes) {
                                                    //save data
                                                    const activeCaseDetails = {
                                                        'trackedEntityInstance': trackedEntityInstance,
                                                        'enrollmentId': enroll,
                                                    }
                                                    const linkContact = {
                                                        "enabled": true,
                                                        "linkTrackedEntityInstance": linkContactFlag.data.linkTrackedEntityInstance
                                                    }
                                                    const activeCaseFormData = {
                                                        'formFormat': null,
                                                        'dhisFormat': null
                                                    }
                                                    OfflineDb.setDataIntoPouchDB('activeCaseDetails', activeCaseDetails)
                                                    OfflineDb.setDataIntoPouchDB('activeCaseFormData', activeCaseFormData)
                                                    OfflineDb.setDataIntoPouchDB('linkContactFlag', linkContact)

                                                    setActiveCaseFormData({
                                                        "data": {
                                                            'formFormat': null, //valueForFormInput,
                                                            'dhisFormat': null //
                                                        }
                                                    })
                                                    setValue(0)


                                                    //empty form
                                                } else {
                                                    //save data
                                                    const activeCaseDetails = {
                                                        'trackedEntityInstance': trackedEntityInstance,
                                                        'enrollmentId': enroll,
                                                    }
                                                    const activeCaseFormData = {
                                                        'formFormat': valueForFormInput,
                                                        'dhisFormat': valuesToSave
                                                    }
                                                    const linkContact = {
                                                        "enabled": false,
                                                        "linkTrackedEntityInstance": trackedEntityInstance
                                                    }

                                                    OfflineDb.setDataIntoPouchDB('activeCaseDetails', activeCaseDetails)
                                                    OfflineDb.setDataIntoPouchDB('activeCaseFormData', activeCaseFormData)
                                                    OfflineDb.setDataIntoPouchDB('linkContactFlag', linkContact)

                                                    //load next active tabs
                                                    const nextTab = activeTabs[0]
                                                    if (nextTab) {
                                                        const indexOfNextTab = programData.programs[0].programStages.findIndex(obj => obj.id == nextTab)
                                                        setValue(indexOfNextTab + stepIncrement)
                                                    } else {
                                                        setValue(value)
                                                    }
                                                    setActiveCaseDetails({
                                                        'data': {
                                                            'trackedEntityInstance': trackedEntityInstance,
                                                            'enrollmentId': enroll,
                                                        }
                                                    })
                                                }
                                            })
                                    } else {

                                        const activeCaseDetails = {
                                            'trackedEntityInstance': trackedEntityInstance,
                                            'enrollmentId': enroll,
                                        }
                                        const activeCaseFormData = {
                                            'formFormat': valueForFormInput,
                                            'dhisFormat': valuesToSave
                                        }
                                        const linkContact = {
                                            "enabled": false,
                                            "linkTrackedEntityInstance": trackedEntityInstance
                                        }

                                        OfflineDb.setDataIntoPouchDB('activeCaseDetails', activeCaseDetails)
                                        OfflineDb.setDataIntoPouchDB('activeCaseFormData', activeCaseFormData)
                                        OfflineDb.setDataIntoPouchDB('linkContactFlag', linkContact)

                                        //load next active tabs
                                        const nextTab = activeTabs[0]
                                        if (nextTab) {
                                            const indexOfNextTab = programData.programs[0].programStages.findIndex(obj => obj.id == nextTab)
                                            setValue(indexOfNextTab + stepIncrement)
                                        } else {
                                            setValue(value)
                                        }
                                        setActiveCaseDetails({
                                            'data': {
                                                'trackedEntityInstance': trackedEntityInstance,
                                                'enrollmentId': enroll,
                                            }
                                        })
                                    }
                                    setGlobalSpinner(false)
                                })
                            setGlobalSpinner(false)
                        })
                    // })
                })

        } else {
            //OfflineStorage
        }




    }

    async function updateRegData(valuesToSave, valueForFormInput, trackentityInstanceDetail) {
        try {
            //valuesToSave.push({"attribute":regUsernameID,"value":currentLoginUsername})
            try {
                let userNameField = _.find(valuesToSave, { "attribute": regUsernameID })
                if (!userNameField && !valueForFormInput[regUsernameID]) {
                    valuesToSave.push({ "attribute": regUsernameID, "value": currentLoginUsername })
                }
                let checkCaseNumber = _.find(valuesToSave, { "attribute": caseNumberId })
                if (!checkCaseNumber && !valueForFormInput[caseNumberId]) {
                    let getCaseNumber = await getUICFromAPI()
                    valueForFormInput[caseNumberId] = getCaseNumber
                    valuesToSave.push({ "attribute": caseNumberId, "value": getCaseNumber })
                }
            } catch (e) {
                console.log(e);
            }
        } catch (e) {
            console.log(e);
        }
        if (navigator.onLine) {
            const orgUnit = valueForFormInput ? valueForFormInput[hotspotsID] ? valueForFormInput[hotspotsID] : userData.organisationUnits[0].id : userData.organisationUnits[0].id;//userData.organisationUnits[0].id
            const programId = programData.programs[0].id
            const trackedEntityType = programData.programs[0].trackedEntityType.id
            const updateURL = 'trackedEntityInstances/' + trackentityInstanceDetail.trackedEntityInstance
            const lat = trackentityInstanceDetail.geometry ? trackentityInstanceDetail.geometry.coordinates[1] : ''
            const lng = trackentityInstanceDetail.geometry ? trackentityInstanceDetail.geometry.coordinates[0] : ''
            const updateCaseInput = {
                "created": trackentityInstanceDetail.created,
                "orgUnit": orgUnit,
                "createdAtClient": trackentityInstanceDetail.createdAtClient,
                "trackedEntityInstance": trackentityInstanceDetail.trackedEntityInstance,
                "lastUpdated": trackentityInstanceDetail.lastUpdated,
                "trackedEntityType": trackedEntityType,
                "lastUpdatedAtClient": trackentityInstanceDetail.lastUpdatedAtClient,
                "inactive": false,
                "deleted": false,
                "featureType": "NONE",
                "programOwners": [
                    {
                        "ownerOrgUnit": orgUnit,
                        "program": programId,
                        "trackedEntityInstance": trackentityInstanceDetail.trackedEntityInstance,
                    }
                ],
                "relationships": [],
                "attributes": valuesToSave,
                "geometry": { "type": "Point", "coordinates": [lng, lat] }
            }
            setGlobalSpinner(true)
            apiServices.putAPI(updateURL, updateCaseInput)
                .then(updateRes => {
                    setGlobalSpinner(false)
                    swal({
                        title: t("Updated"),
                        text: t("Client data successfully updated"),
                        icon: "success",
                        button: t("Close"),
                    });
                    const activeCaseFormData = {
                        'formFormat': valueForFormInput,
                        'dhisFormat': valuesToSave
                    }

                    OfflineDb.setDataIntoPouchDB('activeCaseFormData', activeCaseFormData)
                    setActiveCaseFormData({
                        "data": {
                            'formFormat': valueForFormInput, //valueForFormInput,
                            'dhisFormat': valuesToSave //
                        }
                    })
                    if (valueForFormInput[PresentlyOnAntiTBMedicationId] && valueForFormInput[PresentlyOnAntiTBMedicationId] == "YES" && valueForFormInput[verifiedFieldId] && valueForFormInput[verifiedFieldId] == "Yes") {
                        //if present tb submitted and its yes then don't go ahead

                        const indexOfNextTab = programData.programs[0].programStages.findIndex(obj => obj.displayName == "TB treatment initiation form")
                        setValue(indexOfNextTab + stepIncrement)
                    } else {
                        // const nextTab = activeTabs[0]
                        // if (nextTab) {
                        //     const indexOfNextTab = programData.programs[0].programStages.findIndex(obj => obj.id == nextTab)
                        //     setValue(indexOfNextTab + 1)
                        // } else {
                        //     setValue(value)
                        // }

                        const nextTab = activeTabs[0]
                        // console.log("programData.programs[0].programStages",programData,nextTab,activeTabs);
                        if (nextTab) {
                            const indexOfNextTab = programData.programs[0].programStages.findIndex(obj => obj.id == nextTab)
                            setValue(indexOfNextTab + stepIncrement)
                            /*if(nextTab == 'd7NYjKu2SCY'){
                                if(valueForFormInput && valueForFormInput["tgft2rEpVts"] && valueForFormInput["tgft2rEpVts"] == 'Yes' && valueForFormInput["mnb6wbjMavs"] && (valueForFormInput["mnb6wbjMavs"] == 'Referral' || valueForFormInput["mnb6wbjMavs"] == 'Accompanied Referral') && valueForFormInput['LEP6NIPQ0pZ'] && valueForFormInput['Bm6GvfF7OOj']){ //check if disclosure given
                                    setValue(indexOfNextTab + stepIncrement + 1)
                                }
                            }*/
                        } else {
                            setValue(value)
                        }
                    }

                }).catch(err => {
                    loadErrorPopup(err)
                })
        } else {
            OfflineDb.getSingleEntity(activeCaseDetails.data.trackedEntityInstance).then(res => {
                const tempdata = { ...res }
                tempdata.formVersion = programData.programs[0].version
                tempdata.data = { ...tempdata.data, ...valueForFormInput };
                tempdata.registration.attributes = valuesToSave;
                //console.log("tempdata",tempdata);
                OfflineDb.updateFullEntity(tempdata).then(response => {
                    const activeCaseFormData = {
                        "data": {
                            'formFormat': valueForFormInput,
                            'dhisFormat': valuesToSave
                        }

                    }
                    OfflineDb.setDataIntoPouchDB('activeCaseFormData', activeCaseFormData)
                    setActiveCaseFormData(activeCaseFormData)
                    swal({
                        title: t("Updated offline"),
                        text: t("Client data successfully updated"),
                        icon: "success",
                        button: t("Close"),
                    });
                    const nextTab = activeTabs[0]
                    if (nextTab) {
                        const indexOfNextTab = programData.programs[0].programStages.findIndex(obj => obj.id == nextTab)
                        setValue(indexOfNextTab + stepIncrement)
                        /*if(nextTab == 'd7NYjKu2SCY'){
                            if(valueForFormInput && valueForFormInput["tgft2rEpVts"] && valueForFormInput["tgft2rEpVts"] == 'Yes' && valueForFormInput["mnb6wbjMavs"] && (valueForFormInput["mnb6wbjMavs"] == 'Referral' || valueForFormInput["mnb6wbjMavs"] == 'Accompanied Referral') && valueForFormInput['LEP6NIPQ0pZ'] && valueForFormInput['Bm6GvfF7OOj']){ //check if disclosure given
                                setValue(indexOfNextTab + stepIncrement + 1)
                            }
                        }*/
                    } else {
                        setValue(value)
                    }
                })
            })
        }
    }


    function onSubmit(values) {
        let registrationFields = programData.programs[0].programTrackedEntityAttributes


        let fieldValueWithAttribute = []
        const data = values
        if (!navigator.onLine && values[offlineFieldId] == undefined) {
            values[offlineFieldId] = Date.now()
        }
        let promises = []
        Object.keys(values).map(function (objectKey, index) {
            var obj = {
                "attribute": objectKey,
                "value": values[objectKey]
            }
            const CurrentValueFilter = registrationFields ? registrationFields.find(obj => obj.trackedEntityAttribute.id == objectKey) : undefined
            if (CurrentValueFilter) {

                if (CurrentValueFilter.trackedEntityAttribute.valueType == "IMAGE" || CurrentValueFilter.trackedEntityAttribute.valueType == "FILE_RESOURCE") {
                    let formData = new FormData();
                    formData.append('file', data[objectKey][0]);
                    promises.push(apiServices.postAPI('fileResources', formData)
                        .then(res => {
                            if (res.data) {
                                return { "attribute": objectKey, "value": res.data.response.fileResource.id }
                            }
                        }))
                } else {
                    fieldValueWithAttribute.push(obj)
                }

            }

        });



        if (promises.length == 0) {
            if (linkContactFlag.data) {
                if (linkContactFlag.data.enabled == true) {
                    //linkContact function

                    linkeRegData(fieldValueWithAttribute, values)
                } else {
                    if (activeCaseDetails.data) {
                        //update

                        updateRegData(fieldValueWithAttribute, values, trackentityInstanceDetails)
                    }
                    else {
                        //save

                        saveRegData(fieldValueWithAttribute, values)
                    }
                }
            } else {
                if (activeCaseDetails.data) {
                    //update

                    updateRegData(fieldValueWithAttribute, values, trackentityInstanceDetails)
                }
                else {
                    //save

                    saveRegData(fieldValueWithAttribute, values)
                }
            }
        } else {
            Promise.all(promises).then((responses) => {
                responses.map(imageData => {
                    fieldValueWithAttribute.push(imageData)
                })
                if (linkContactFlag.data) {
                    if (linkContactFlag.data.enabled == true) {
                        //linkContact function

                        linkeRegData(fieldValueWithAttribute, values)
                    } else {
                        if (activeCaseDetails.data) {
                            //update

                            updateRegData(fieldValueWithAttribute, values, trackentityInstanceDetails)
                        }
                        else {
                            //save

                            saveRegData(fieldValueWithAttribute, values)
                        }
                    }
                } else {
                    if (activeCaseDetails.data) {
                        //update

                        updateRegData(fieldValueWithAttribute, values, trackentityInstanceDetails)
                    }
                    else {
                        //save

                        saveRegData(fieldValueWithAttribute, values)
                    }
                }
            })
        }



        //saveRegData(fieldValueWithAttribute, values)
    }
    // Code for Link Tab
    function addContactCallBack() {

        const activeCaseDetails1 = {
            'trackedEntityInstance': activeCaseDetails.data.trackedEntityInstance,
            'enrollmentId': activeCaseDetails.data.enrollmentId,
        }
        const linkContact = {
            "enabled": true,
            "linkTrackedEntityInstance": activeCaseDetails.data.trackedEntityInstance
        }
        const activeCaseFormData = {
            'formFormat': null, //valueForFormInput,
            'dhisFormat': null //
        }

        OfflineDb.setDataIntoPouchDB('activeCaseDetails', activeCaseDetails1)
        OfflineDb.setDataIntoPouchDB('activeCaseFormData', activeCaseFormData)
        OfflineDb.setDataIntoPouchDB('linkContactFlag', linkContact)

        setActiveCaseFormData({
            "data": {
                'formFormat': null, //valueForFormInput,
                'dhisFormat': null //
            }
        })
        setLinkContactFlag({
            "data": {
                "enabled": true,
                "linkTrackedEntityInstance": activeCaseDetails.data.trackedEntityInstance
            }
        })
        // setActiveCaseDetails({
        //     "data": {
        //         'trackedEntityInstance': activeCaseDetails.data.trackedEntityInstance,
        //         'enrollmentId': activeCaseDetails.data.enrollmentId,
        //     }
        // })
        setValue(0)
        setsputumTable([])
    }
    function createLinkForm(programObj) {
        function editLinks(linkObject) {
            const activeCaseDetails = {
                'trackedEntityInstance': linkObject.trackedEntityInstance,
                'enrollmentId': "",
            }
            OfflineDb.setDataIntoPouchDB('activeCaseDetails', activeCaseDetails)
            setActiveCaseDetails({
                'data': {
                    'trackedEntityInstance': linkObject.trackedEntityInstance,
                    'enrollmentId': '',

                }
            })
            setSearchResponse(null)
            if (location?.state?.stageId != "individualrecord") {
                setValue(1)
            }
        }
        return (
            <div>
                <form className="fullWidth" onSubmit={e => e.preventDefault()}>
                    <div className="innertabdivreg">
                        <div className="buttons">
                            <button className="regformsubmitbtn" onClick={addContactCallBack}>
                                <Trans>Add Contact</Trans>
                            </button>
                        </div>
                        <p>Linked Index:</p>
                        {linkIndexList.length > 0 ? linkIndexList.map((indexItem) => {
                            return indexItem.data.attributes.map(item => {
                                if (item.displayName.trim() == 'Name') {
                                    return (
                                        <div style={{ marginBottom: 10 }}>
                                            <Grid item xs={12} sm={12} md={12} >
                                                <Card className={classes.root} onClick={() => editLinks(indexItem.data)}>
                                                    <CardContent className="casescardheader">
                                                        <PersonIcon />
                                                        {item.value}
                                                    </CardContent>
                                                </Card>
                                            </Grid>
                                        </div>
                                    )
                                }
                            })
                        })
                            : ''}
                        <p>Linked Contact:</p>
                        {linkContactList.length > 0 ? linkContactList.map((contactItem) => {
                            return contactItem.data.attributes.map(item => {
                                if (item.displayName.trim() == 'Name') {
                                    return (
                                        <div style={{ marginBottom: 10 }}>
                                            <Grid item xs={12} sm={12} md={12} style={{ marginBottom: '10' }}>
                                                <Card className={classes.root} onClick={() => editLinks(contactItem.data)}>
                                                    <CardContent className="casescardheader">
                                                        <PersonIcon />
                                                        {item.value}
                                                    </CardContent>
                                                </Card>
                                            </Grid>
                                        </div>
                                    )
                                }
                            })
                        }) :
                            ''}
                    </div>
                </form>
            </div>
        )
    }
    function createIndexContactList() {

        if (activeCaseDetails.data && navigator.onLine) {
            let programID = programData.programs[0].id,
                url = `trackedEntityInstances/${activeCaseDetails.data.trackedEntityInstance}.json?program=${programID}&fields=relationships`;
            apiServices.getAPI(url).then(res => {

                getChildrenById(res.data.relationships, programID);
            }).catch(error => {
                setGlobalSpinner(false);
                swal({
                    title: t("Error"),
                    text: "",
                    icon: "error",
                    button: t("Close"),
                });

            })
        }
    }
    function getChildrenById(relationshipsArr, programid) {
        let p = [];
        let q = [];
        //setGlobalSpinner(true);
        relationshipsArr.map((relobj) => {
            if (relobj.from.trackedEntityInstance.trackedEntityInstance != activeCaseDetails.data.trackedEntityInstance) {
                let url = `trackedEntityInstances/${relobj.from.trackedEntityInstance.trackedEntityInstance}.json?program=${programid}&fields=*?`;
                q.push(apiServices.getAPI(url));
            }
            if (relobj.to.trackedEntityInstance.trackedEntityInstance != activeCaseDetails.data.trackedEntityInstance) {
                let url1 = `trackedEntityInstances/${relobj.to.trackedEntityInstance.trackedEntityInstance}.json?program=${programid}&fields=*?`;
                p.push(apiServices.getAPI(url1));
            }
        });

        Promise.all([...p]).then(([...res]) => {
            let childrenArr = [...res];
            setGlobalSpinner(false);
            setLinkContactList(childrenArr)
        });
        Promise.all([...q]).then(([...res]) => {
            let childrenArr = [...res];
            setGlobalSpinner(false);
            setLinkIndexList(childrenArr)

        });
    }
    // Code for Search tab
    function _createSearchForm(programObj) {

        const rulesObject = {
            programRule: [],
            programRuleVariable: [],
        }
        let attributes = programObj.programs[0].programTrackedEntityAttributes
        return (
            <Form
                onSubmit={values => searchAPI(values, null, 2)}

                render={({ handleSubmit, form, submitting, pristine, values }) => (


                    <form className="fullWidth" onSubmit={handleSubmit}>
                        <div className="innertabdivreg">
                            <>
                                <Grid container spacing={3}>
                                    {
                                        attributes.map((attribute, i) => {
                                            if (attribute.searchable && attribute.trackedEntityAttribute.displayName.trim().toLowerCase() != 'qr code') {
                                                return <CreateField fieldData={attribute} values={values} programRules={[]} programData={programObj.programs[0]} programRulesVariables={[]} linkContactFlag={linkContactFlag} activeCaseDetails={activeCaseDetails} Configuration={Configuration} />
                                                //fieldData={registrationFields} values={values} programRules={programRules} programData={programData.programs[0]} programRulesVariables={programRulesVariables} linkContactFlag={linkContactFlag} onGoogleLocatioChangeParent = {onGoogleLocatioChangeParent}
                                                // return <CreateField fieldData ={attribute} values={values} form={form} programRules={rulesObject} key={i}/>
                                            }
                                        })
                                    }

                                </Grid>

                                <div className="buttons">
                                    <button className="regformsubmitbtn" type="submit" disabled={submitting}>
                                        <Trans>Submit</Trans>
                                    </button>
                                    <button
                                        className="regformresetbtn"
                                        type="button"
                                        onClick={() => this.resetForm(form, values)}
                                        disabled={submitting || pristine}
                                    >
                                        <Trans>Reset</Trans>
                                    </button>
                                </div>

                                {/* {
                    searchResult.length > 0 ?
                    <>
                    <p className="searchformheading"><Trans>Search Results</Trans> :
                        {searchResult[1].length == 0 ?
                            <>
                            <Trans> No result found. Do you want to register the client?</Trans> 
                            <button style={{marginLeft:'20px'}} className="regformsubmitbtn" >
                                <Trans>Add New Client</Trans>
                            </button> </>: null
                        
                        }
                        
                    </p>                            
                    <SearchResults
                        searchResult = {searchResult}
                        viewType={'card'}
                        metaData={programObj}
                    />
                    </> : null
                    } */}
                                {/* <pre>{JSON.stringify(values, 0, 2)}</pre> */}

                            </>
                        </div>
                    </form>
                )}
            />
        )
    }

    function searchAPI(param) {
        setGlobalSpinner(true)

        //let programData = programObj.programs[0]
        let registrationFields = props.programData.programs[0].programTrackedEntityAttributes
        let clientTypeID = null
        registrationFields.map((field, index) => {
            if (field.trackedEntityAttribute.displayName == "Client type") {
                clientTypeID = field.trackedEntityAttribute.id
                param[clientTypeID] = Configuration.ltbiLinkVariables.presumptivetb
            }
        })

        OfflineDb.setDataIntoPouchDB('activeCaseFormData', {
            'formFormat': param, //valueForFormInput,
            'dhisFormat': null //
        })
        setActiveCaseFormData({
            "data": {
                'formFormat': param, //valueForFormInput,
                'dhisFormat': null //
            }
        })
        //const metaData = JSON.parse(localStorage.getItem('metaData')) || '';
        //const sessionUserBoValue = JSON.parse(sessionStorage.getItem('userBO')) || JSON.parse(localStorage.getItem('userBO'))
        // setLoading(true)   
        let allOU = sessionUserBoValue ? sessionUserBoValue ? sessionUserBoValue.organisationUnits : sessionUserBoValue.organisationUnits[0].id : sessionUserBoValue.organisationUnits[0].id;
        let hotspots = null;
        if (allOU) {
            //allOU = _.filter(allOU,{"level":6})
            allOU.map((hotspot, i) => {
                //if(hotspot["level"] && hotspot["level"] == 6){
                if (hotspots) {
                    hotspots = hotspots + ';' + hotspot.id
                } else {
                    hotspots = hotspot.id
                }

                //}
            })
        }
        let orgID = hotspots ? hotspots : sessionUserBoValue.organisationUnits[0].id, //`UuYrI1twhmN`,
            programID = sessionUserBoValue.programs[0], //`nSy7PFqQykt`, 
            searchQuery = ``

        for (var i in param) {
            /*if(param["dHDHVYFgokt"]){
                param["dHDHVYFgokt"] = moment(param["dHDHVYFgokt"]).format("YYYY-MM-DD")
            }*/
            searchQuery += `&attribute=${i}:LIKE:${param[i]}`
        }

        console.log("param", param)


        if (sessionUserBoValue && sessionUserBoValue.userCredentials && sessionUserBoValue.userRoles && sessionUserBoValue.userRoles[0].name && (sessionUserBoValue.userRoles[0].name == 'HTC' || sessionUserBoValue.userRoles[0].name == 'ART user' || sessionUserBoValue.userRoles[0].name == 'ART-I user')) {
            let params = {
                orguid: orgID,
                programuid: programID,
            }
            let counter = 0;
            for (var i in param) {
                counter = counter + 1;
                params["attributeuid" + counter] = i
                params["attributevalue" + counter] = param[i]
            }
            apiServices
                .postAPI('save/dashboard/getreferallist', params)
                .then(searchResponse => {
                    setGlobalSpinner(false)
                    // console.log("searchResponse",searchResponse)    
                    if (searchResponse.data && searchResponse.data.data && Object.keys(searchResponse.data.data).length > 0) {
                        console.log("do something here");
                        let headers = [{
                            "name": "instance",
                            "column": "Instance",
                            "type": "java.lang.String",
                            "hidden": false,
                            "meta": false
                        }]
                        setSearchHeader(headers)
                        var rows = [];
                        for (var row in searchResponse.data.data) {
                            var allkeys = _.keys(searchResponse.data.data[row][0]);
                            var attributes = metaData.programs[0].programTrackedEntityAttributes;
                            allkeys.map((k, i) => {
                                var fName = _.filter(attributes, { trackedEntityAttribute: { id: k } });
                                if (fName && fName.length > 0) {
                                    headers.push({
                                        "name": k,
                                        "column": fName[0].trackedEntityAttribute.displayName,
                                        "type": "java.lang.String",
                                        "hidden": false,
                                        "meta": false
                                    })
                                }
                            })
                            searchResponse.data.data[row].map((attribute, i) => {
                                //var row = []
                                headers.map((header, j) => {
                                    for (let k in attribute) {
                                        if (header["name"] == k) {
                                            headers[j]["value"] = attribute[k];
                                        } else if (k == 'instanceid' && header["name"] == 'instance') {
                                            headers[j]["value"] = attribute[k];
                                        }
                                    }
                                    //console.log("row",row);
                                })
                                //rows.push(row)
                            })
                        }
                        var row = []
                        headers.map((attribute, i) => {
                            if (attribute["value"]) {
                                row.push(attribute["value"])
                            } else {
                                row.push("")
                            }
                        })
                        rows.push(row)
                        setSearchResponse(rows)
                        //console.log("rows",rows,headers);

                    } else {
                        setSearchHeader([])
                        setSearchResponse([])
                    }
                }).catch(error => {
                    setGlobalSpinner(false)
                    // setLoading(false) 
                    swal({
                        title: t('Error'),
                        text: navigator.onLine ? t("At least 1 attributes should be mentioned in the search criteria.") : t("Could not search in offline mode"),
                        icon: "error",
                        button: t("Close"),
                    });
                })
        } else {

            //let subURL = 'trackedEntityInstances/query.json?ou=' + orgID + '&ouMode=ACCESSIBLE&&order=created:desc&program=' + programID + searchQuery + '&pageSize=50&page=1&totalPages=false'
            let subURL = 'trackedEntityInstances/query.json?&ouMode=ALL&&order=created:desc&program=' + programID + searchQuery + '&pageSize=50&page=1&totalPages=false'

            apiServices.getAPI(subURL).then(searchResponse => {
                setGlobalSpinner(false)
                if (searchResponse.data.rows.length > 0) {

                    setSearchHeader(searchResponse.data.headers)
                    setSearchResponse(searchResponse.data.rows)
                    // setFormValuePostDeDup({ 'valuesToSave': valuesToSave, 'valueForFormInput': valueForFormInput })
                } else {
                    setSearchHeader([])
                    setSearchResponse([])
                }
                // let searchArray = []
                // searchArray.push(res.data.headers)
                // searchArray.push(res.data.rows)
                // setSearchResult(searchArray)   
                // setLoading(false)                          
            }).catch(error => {
                setGlobalSpinner(false)
                // setLoading(false) 
                swal({
                    title: t('Error'),
                    text: navigator.onLine ? t("At least 1 attributes should be mentioned in the search criteria.") : t("Could not search in offline mode"),
                    icon: "error",
                    button: t("Close"),
                });
            })
        }


    }


    const searchBySpecimenId = (param, event, a, searchtype) => {
        // console.log("searchBySpecimenId>>", param, event, a, searchtype, sessionUserBoValue, metaData);
        if (Object.keys(param).length > 1) {
            delete param[qrDataElementDetail.id]
        }
        if (searchtype) {
            localStorage.setItem('searchtype', searchtype)
        }
        setsearchFilter(param);
        setGlobalSpinner(true)
        let orgID = sessionUserBoValue.organisationUnits[0].id,
            programID = sessionUserBoValue.programs[0],
            searchQuery = ``;
        let params = {
            orguid: orgID,
            programuid: programID,
            stageuid: stageDetail.id,
            dataelementuid: Object.keys(param)[0],
            dataelementvalue: Object.values(param)[0]
        }
        // console.log('params>>', params)
        // setGlobalSpinner(false)
        // return;
        apiServices
            .postAPI('indicators/searchdataelement', params)
            .then((searchResponse) => {
                // let searchArray = [];
                // searchArray.push(res.data.headers);
                // searchArray.push(res.data.rows);
                // setSearchResult(searchArray);
                setGlobalSpinner(false);

                if (searchResponse.data.rows.length > 0) {
                    setSearchHeader(searchResponse.data.headers)
                    setSearchResponse(searchResponse.data.rows)
                } else {
                    setSearchHeader([])
                    setSearchResponse([])
                }

                // localStorage.removeItem("specimen");
                // localStorage.removeItem("searchtype");
            })
            .catch((error) => {
                setGlobalSpinner(false);
                // localStorage.removeItem("specimen");
                // localStorage.removeItem("searchtype");
                swal({
                    title: t("Error"),
                    text: navigator.onLine ? t(
                        "At least 1 attributes should be mentioned in the search criteria."
                    ) : t("Could not search in offline mode"),
                    icon: "error",
                    button: t("Close"),
                });
            });
    }

    function createSearchForm(programObj) {
        let QRdata = ""

        const rulesObject = {
            programRule: [],
            programRuleVariable: [],
        }
        let attributes = programObj.programs[0].programTrackedEntityAttributes
        const searchPageMeta = Configuration.searchpage;
        //const [showScanner, setshowScanner] = useState(false)
        function createCustomSearchForm() {
            const rulesObject = {
                programRule: [],
                programRuleVariable: [],
            }
            let attributes = metaData.programs[0].programTrackedEntityAttributes
            return (
                <Form
                    onSubmit={values => searchAPI(values, null, 2)}

                    render={({ handleSubmit, form, submitting, pristine, values }) => (


                        <form className="fullWidth" onSubmit={handleSubmit}>
                            <div className="innertabdivreg">
                                <>
                                    <Grid container spacing={3}>
                                        {
                                            attributes.map((attribute, i) => {
                                                if (attribute.searchable && attribute.trackedEntityAttribute.displayName.trim().toLowerCase() != 'qr code' && attribute.trackedEntityAttribute.displayName.trim().toLowerCase() != 'uic') {
                                                    return <CreateSearchField fieldData={attribute} values={values} programRules={[]} programData={programObj.programs[0]} programRulesVariables={[]} linkContactFlag={linkContactFlag} activeCaseDetails={activeCaseDetails} stateList={statesList} townshipList={townshipList} />
                                                    //fieldData={registrationFields} values={values} programRules={programRules} programData={programData.programs[0]} programRulesVariables={programRulesVariables} linkContactFlag={linkContactFlag} onGoogleLocatioChangeParent = {onGoogleLocatioChangeParent}
                                                    // return <CreateField fieldData ={attribute} values={values} form={form} programRules={rulesObject} key={i}/>
                                                }
                                            })
                                        }

                                    </Grid>

                                    <div className="buttons">
                                        <button className="regformsubmitbtn" type="submit" disabled={submitting}>
                                            <Trans>Submit</Trans>
                                        </button>
                                        <button
                                            className="regformresetbtn"
                                            type="button"
                                            onClick={() => form.reset()}
                                            disabled={submitting}
                                        >
                                            <Trans>Reset</Trans>
                                        </button>
                                    </div>

                                    {/* {
                    searchResult.length > 0 ?
                    <>
                    <p className="searchformheading"><Trans>Search Results</Trans> :
                        {searchResult[1].length == 0 ?
                            <>
                            <Trans> No result found. Do you want to register the client?</Trans> 
                            <button style={{marginLeft:'20px'}} className="regformsubmitbtn" >
                                <Trans>Add New Client</Trans>
                            </button> </>: null
                        
                        }
                        
                    </p>                            
                    <SearchResults
                        searchResult = {searchResult}
                        viewType={'card'}
                        metaData={programObj}
                    />
                    </> : null
                    } */}
                                    {/* <pre>{JSON.stringify(values, 0, 2)}</pre> */}

                                </>
                            </div>
                        </form>
                    )}
                />
            )
        }

        function createUICSearchForm() {

            const rulesObject = {
                programRule: [],
                programRuleVariable: [],
            }
            let attributes = metaData.programs[0].programTrackedEntityAttributes
            return (
                <Form
                    onSubmit={values => searchAPI(values, null, 2)}

                    render={({ handleSubmit, form, submitting, pristine, values }) => (


                        <form className="fullWidth" onSubmit={handleSubmit}>
                            <div className="innertabdivreg">
                                <>
                                    <Grid container spacing={3}>
                                        {
                                            attributes.map((attribute, i) => {
                                                if (attribute.trackedEntityAttribute.displayName == "UIC") {
                                                    attribute.trackedEntityAttribute.unique = true;
                                                }
                                                if (attribute.trackedEntityAttribute.unique) {
                                                    return <CreateSearchField key={i} fieldData={attribute} values={values} form={form} programRules={rulesObject} />
                                                }
                                            })
                                        }

                                    </Grid>

                                    <div className="buttons buttonFlex">
                                        <button className="regformsubmitbtn" type="submit" disabled={submitting}>
                                            <Trans>Submit</Trans>
                                        </button>
                                        <button
                                            className="regformresetbtn hide"
                                            type="button"
                                            onClick={() => form.reset()}
                                            disabled={submitting}
                                        >
                                            <Trans>Reset</Trans>
                                        </button>
                                    </div>


                                    {/* <pre>{JSON.stringify(values, 0, 2)}</pre> */}
                                </>
                            </div>

                        </form>
                    )}
                />
            )



        }

        function handleQRScanForSpecimen(data) {
            // console.log('handleQRScanForSpecimen>>', data)
            if (data) {
                setshowScanner(false);
                let obj = {};
                metaData.programs[0].programStages.map(stage => {
                    if (stage.displayName && stage.displayName === searchPageMeta.searchby.stagename) {
                        stage.programStageDataElements.map(field => {
                            if (field.renderType && field.renderType["DESKTOP"].type == "QR_CODE") {
                                // setqrDataElementDetail(field.dataElement)
                                obj[field.dataElement.id] = data;
                            }
                        })
                    }
                })

                searchBySpecimenId(obj, null, 2, 'qr');
            }
        }

        const closeQrScanner = () => {
            setshowScanner(false);
        }

        function openQrSacnnerForSpecimen() {
            if (window.cordova) {
                openCordovaQrScannerForSpecimen();
            } else {
                setshowScanner(true);
            }
        }

        function createQRForSpecimen() {
            return (
                <>
                    {showScanner ? (
                        <>
                            <QrReader
                                delay={300}
                                onError={() => qrErrorhandler()}
                                onScan={(e) => handleQRScanForSpecimen(e)}
                                style={{ width: "50%" }}
                            />
                            <button onClick={() => closeQrScanner()}>Close</button>
                        </>
                    ) : (
                        <p className="qrIcon" onClick={() => openQrSacnnerForSpecimen()}>
                            <FontAwesomeIcon className="fa-5x" icon={faQrcode} />
                        </p>
                    )}
                </>
            );
        }

        function createSpecimenSearchForm(searchFilter) {

            return (

                <Grid container spacing={3}>
                    <Grid xs={12} md={4}>

                        <Form
                            onSubmit={(values) => searchBySpecimenId(values, null, 2, 'id')}
                            initialValues={searchFilter}
                            render={({ handleSubmit, form, submitting, pristine, values }) => (
                                <form id="reg-searchby-specimen" onSubmit={handleSubmit}>

                                    <Grid xs={12} md={12}>
                                        <Field
                                            name={dataElementDetail.id}
                                            label='Specimen Id'
                                            component={InputFieldFF}
                                            key={dataElementDetail.id}
                                            className=""
                                            required
                                        />
                                    </Grid>
                                    <Grid xs={12} md={12}>
                                        <div className="buttons btn-specimen">
                                            <button
                                                className="regformsubmitbtn"
                                                type="submit"
                                                disabled={submitting}
                                            >
                                                <Trans>Submit</Trans>
                                            </button>
                                            <button
                                                className="regformresetbtn"
                                                type="button"
                                                onClick={() => {
                                                    form.reset();
                                                    setsearchFilter({});
                                                    resetSearch();
                                                }}
                                            // disabled={submitting}
                                            >
                                                <Trans>Reset</Trans>
                                            </button>
                                        </div>
                                    </Grid>

                                </form>
                            )}
                        />
                    </Grid>
                    <Grid xs={12} md={4}><h4 className="text-center">OR</h4></Grid>
                    <Grid xs={12} md={4}>{createQRForSpecimen()}</Grid>
                </Grid>

            );
        }

        function handleQRScan(data) {
            if (QRdata) {
                console.log("QRdata", QRdata)
                setshowScanner(false)
                let obj = {};
                programObj.programs[0].programTrackedEntityAttributes.map(attribute => {
                    if (attribute.renderType && attribute.renderType['DESKTOP'].type == "QR_CODE") {
                        obj[attribute.trackedEntityAttribute.id] = QRdata;
                    }
                })
                searchAPI(obj);
            }
        }

        function qrErrorhandler(err) {
            setshowScanner(false)
            alert(err)
        }

        function createQRFrom() {
            return (
                <div className="searchformcontainer qrreaderholder" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    {showScanner
                        ?
                        <QrReader
                            delay={300}
                            onError={() => qrErrorhandler()}
                            onScan={(result, error) => {
                                QRdata = result
                                console.log("result", result)
                                handleQRScan()
                            }}
                            style={{ width: '30%', cursor: 'pointer' }}
                        />
                        :
                        <p className="qrIcon" onClick={() => openQrSacnner()}><FontAwesomeIcon className="fa-5x" icon={faQrcode} /></p>
                    }
                </div>
            )
        }

        const resetSearch = () => {
            setSearchResult([]);
            setsearchFilter({});
        };

        function openCordovaQrScannerForSpecimen() {
            let that = this;
            window.cordova.plugins.barcodeScanner.scan(
                function (result) {
                    handleQRScanForSpecimen(result.text);
                },
                function (error) { },
                {
                    preferFrontCamera: false, // iOS and Android
                    showFlipCameraButton: true, // iOS and Android
                    showTorchButton: false, // iOS and Android
                    torchOn: false, // Android, launch with the torch switched on (if available)
                    prompt: "Place a barcode inside the scan area", // Android
                    resultDisplayDuration: 500, // Android, display scanned text for X ms. 0 suppresses it entirely, default 1500
                    //formats : "QR_CODE,PDF_417", // default: all but PDF_417 and RSS_EXPANDED
                    //orientation : "portrait", // Android only (portrait|landscape), default unset so it rotates with the device
                    disableAnimations: true, // iOS
                    disableSuccessBeep: false, // iOS
                }
            );
        }
        function openCordovaQrScanner() {

            let that = this;
            window.cordova.plugins.barcodeScanner.scan(
                function (result) {
                    QRdata = result.text
                    handleQRScan(result.text);
                },
                function (error) {

                },
                {
                    preferFrontCamera: false, // iOS and Android
                    showFlipCameraButton: true, // iOS and Android
                    showTorchButton: false, // iOS and Android
                    torchOn: false, // Android, launch with the torch switched on (if available)
                    prompt: 'Place a barcode inside the scan area', // Android
                    resultDisplayDuration: 500, // Android, display scanned text for X ms. 0 suppresses it entirely, default 1500
                    //formats : "QR_CODE,PDF_417", // default: all but PDF_417 and RSS_EXPANDED
                    //orientation : "portrait", // Android only (portrait|landscape), default unset so it rotates with the device
                    disableAnimations: true, // iOS
                    disableSuccessBeep: false // iOS
                }
            );
        }
        function openQrSacnner() {
            if (window.cordova) {
                openCordovaQrScanner()
            } else {
                setshowScanner(true)
            }
        }

        const handleSearchTabChange = (event, newValue) => {

            setSearchTabValue(newValue);
        };

        return (
            <div className="searchtabscontainer customregistrationtabs regcasetabs ">
                <AppBar position="static" style={{ bottom: '115px' }}>
                    <Tabs value={searchTabvalue} onChange={handleSearchTabChange} aria-label="simple tabs example" variant="fullWidth">
                        {
                            searchPageMeta.tabsList.map((tabdetails, i) => {
                                if (tabdetails.showMenu) {
                                    return <Tab className="whitetext" key={i} style={{ color: '#fff !important' }} label={t(tabdetails.name)} {...a11yProps(i)} />
                                }
                            })
                        }
                    </Tabs>
                </AppBar>

                <TabPanel value={searchTabvalue} index={0} style={{ padding: '0px 0px !important' }}>
                    {(metaData != null) ? createCustomSearchForm() : null}
                </TabPanel>

                <TabPanel value={searchTabvalue} index={1} className={classes.paddingclass} style={{ padding: '20px 0px !important' }}>
                    {(metaData != null) ? createUICSearchForm() : null}
                </TabPanel>

                <TabPanel value={searchTabvalue} index={2} className={classes.paddingclass} style={{ padding: '20px 0px !important' }}>
                    {(metaData != null) ? createQRFrom() : null}
                </TabPanel>
                <TabPanel
                    value={searchTabvalue}
                    index={3}
                    className={classes.paddingclass}
                    style={{ padding: "20px 0px !important" }}
                >
                    {metaData != null ? createSpecimenSearchForm(searchFilter) : null}
                </TabPanel>
            </div>

        )
    }

    function CustomeCaseCard(row) {
        const history = useHistory();
        const { t } = useTranslation();

        const [headers] = React.useState(row.searchHeader)
        const findIndexOfClientType = headers.findIndex(obj => obj.column.trim().toLocaleLowerCase() == "client type")
        const clientType = row.row[findIndexOfClientType] ? row.row[findIndexOfClientType] : ""
        const clientTypeId = headers[findIndexOfClientType] ? headers[findIndexOfClientType].name : '';
        //const [vType] = useState(row.viewType)
        const classes = useStyles();
        const [expanded, setExpanded] = useState(false);

        const [anchorEl, setAnchorEl] = useState(null);
        const [UserBO, setUserBO] = useState(null);
        const [metaData, setMetaData] = useState(null)
        const setGlobalSpinner = useGlobalSpinnerActionsContext()
        //redux state selector and dispatch action
        const postResgistrationResponse = useSelector(state => state.postResgistrationResponse);
        const dispatch = useDispatch();

        // async function getUserBO() {
        //   let userdata = await OfflineDb.getDataFromPouchDB('loginDetails');
        //   setUserBO(userdata.data)

        //   let metaData = await OfflineDb.getDataFromPouchDB('metaData');
        //   setMetaData(metaData.data)
        // }

        const handleClick = (event) => {
            setAnchorEl(event.currentTarget);
        };

        const handleClose = () => {
            setAnchorEl(null);
        };

        const handleExpandClick = () => {
            setExpanded(!expanded);
        };

        const seeIndividualRecordClick = () => {

            localStorage.setItem('trackedEntityInstance', row.row[0])
            localStorage.setItem('linkContact', false)
            localStorage.setItem('hidebutton', true)


            setAnchorEl(null);
            setGlobalSpinner(true)
            history.push('/layout/individualrecord', { 'trackedEntityInstance': row.row[0] });
        }

        const addContcat = () => {

            const activeCaseFormData = {
                'formFormat': { [clientTypeId]: Configuration.ltbiLinkVariables.contact },
                'dhisFormat': null
            }
            const linkContact = {
                "enabled": true,
                "linkTrackedEntityInstance": row.row[0]
            }
            //OfflineDb.setDataIntoPouchDB('activeCaseDetails', activeCaseDetails)
            OfflineDb.setDataIntoPouchDB('activeCaseFormData', activeCaseFormData)
            OfflineDb.setDataIntoPouchDB('linkContactFlag', linkContact)
            history.push('/layout/registration')
        }

        function UpdateRecordClick() {
            setGlobalSpinner(true)


            //   const formDataMassaged = {}

            //   row.metaData.programs[0].programTrackedEntityAttributes.map(field => {
            //     const fieldId = field.trackedEntityAttribute.id
            //     const fieldValue = row.row[row.searchHeader.findIndex(obj => obj.name == field.trackedEntityAttribute.id)]


            //     formDataMassaged[fieldId]= fieldValue
            //   })

            const activeCaseDetails = {
                'trackedEntityInstance': row.row[0],
                'enrollmentId': "",
            }
            //   const activeCaseFormData = {
            //     'formFormat': null, //formDataMassaged,
            //     'dhisFormat': null
            //   }
            //   const linkContact = {
            //     "enabled": false,
            //     "linkTrackedEntityInstance": row.row[0]
            //   }
            OfflineDb.setDataIntoPouchDB('activeCaseDetails', activeCaseDetails)
            //   // OfflineDb.setDataIntoPouchDB('activeCaseFormData', activeCaseFormData)
            //   OfflineDb.setDataIntoPouchDB('linkContactFlag', linkContact)
            //   setGlobalSpinner(false)
            //   history.push('/layout/registration')
            setActiveCaseDetails({
                'data': {
                    'trackedEntityInstance': row.row[0],
                    'enrollmentId': '',

                }
            })
            setSearchResponse(null)
            if (location?.state?.stageId != "individualrecord") {
                setValue(1)
            }
            history.push('/layout/registration')
        }

        const getIndividualsList = () => {
            localStorage.setItem('trackedEntityInstance', row.row[0]);
            history.push('/layout/individual-cases-list', { 'trackedEntityInstance': row.row[0] });
        }

        const caseCardView = () => {

            return (
                <Grid item xs={12} sm={6} md={row.parentPage && row.parentPage == "registration" ? 6 : 3}>
                    <Card className={classes.root}>
                        <CardHeader
                            className="casescardheader"
                            avatar={
                                <Avatar aria-label="recipe" className={classes.avatar}>
                                    <EventNoteIcon />
                                </Avatar>
                            }
                            //   action={
                            //     <div>
                            //       {row.hideOptions != 'true' ? <IconButton aria-controls="simple-menu" aria-haspopup="true" onClick={handleClick}>
                            //         <MoreVertIcon />
                            //       </IconButton > : <> </>}

                            //       <Menu
                            //         id="simple-menu"
                            //         className="casesactionmenu"
                            //         anchorEl={anchorEl}
                            //         keepMounted
                            //         open={Boolean(anchorEl)}
                            //         onClose={handleClose}
                            //       >
                            //         <MenuItem onClick={() =>seeIndividualRecordClick()}><VisibilityIcon /> {t('See Individual Record')}</MenuItem>
                            //         <MenuItem onClick={() =>UpdateRecordClick()}><EditIcon /> {t('New/Update Individual Record')}</MenuItem>
                            //       </Menu>
                            //     </div>
                            //   }
                            title=""
                            subheader=""
                        />

                        <CardContent className="zero caselistholder">
                            <Customcaseslist row={row} viewType={row.viewType}></Customcaseslist>
                        </CardContent>
                        <CardActions disableSpacing className="cardactionfooter">
                            {row.hideOptions != 'true' ?
                                <>
                                    {/* <IconButton aria-label="add to favorites" onClick={seeIndividualRecordClick}>
                        <VisibilityIcon />
                      </IconButton> */}
                                    {/* {className={sessionUserBoValue && sessionUserBoValue.userCredentials && sessionUserBoValue.userRoles && sessionUserBoValue.userRoles[0].name && sessionUserBoValue.userRoles[0].name =='SuperUser' ? '' : 'hide'}} */}
                                    <IconButton aria-label="share" onClick={UpdateRecordClick}>
                                        <EditIcon />
                                    </IconButton> </> : <> </>}
                            {clientType.toLocaleLowerCase() == 'index' ?
                                <>
                                    {/* <IconButton aria-label="share" title="Individuals List" onClick={getIndividualsList}>
                        <GroupIcon />
                        </IconButton>
                    <button className="caseSearchButton" type="button" onClick={addContcat}>{t('Add contact')}</button> */}
                                </> :
                                <> </>}

                            <IconButton
                                className={clsx(classes.expand, {
                                    [classes.expandOpen]: expanded,
                                })}
                                onClick={handleExpandClick}
                                aria-expanded={expanded}
                                aria-label="show more"
                            >
                            </IconButton>
                        </CardActions>
                    </Card>
                </Grid>
            )
        }


        return (

            (row.viewType == 'card') ? caseCardView() : null)
    }

    // Search tab code END
    function createRegistrationForm(programObj, programRules, programRulesVariables) {

        let programData = programObj.programs[0]
        let registrationFields = programData.programTrackedEntityAttributes

        let initialValues = activeCaseFormData.data ? activeCaseFormData.data.formFormat != null ? activeCaseFormData.data.formFormat : {} : {}

        /*let clientTypeID = null
        registrationFields.map((field, index) => {
            if(field.trackedEntityAttribute.displayName == "Client type"){
                clientTypeID = field.trackedEntityAttribute.id
                if(!initialValues.hasOwnProperty(clientTypeID)){
                    activeCaseFormData.data.formFormat[clientTypeID] = Configuration.ltbiLinkVariables.presumptivetb;
                }
            }
        })*/
        let formDisable = false;
        let fieldDisable = false;

        if (navigator.onLine && sessionUserBoValue && sessionUserBoValue.userCredentials && sessionUserBoValue.userRoles && sessionUserBoValue.userRoles[0].name && (sessionUserBoValue.userRoles[0].name == 'HTC' || sessionUserBoValue.userRoles[0].name == 'ART user' || sessionUserBoValue.userRoles[0].name == 'ART-I user'
            || sessionUserBoValue.userRoles[0].name == 'ORW') && activeCaseDetails && activeCaseDetails.data && activeCaseDetails.data.trackedEntityInstance) {
            formDisable = true
            if (sessionUserBoValue.userRoles[0].name == 'ORW') {
                fieldDisable = true
            }
        }

        // const userRoles = sessionUserBoValue?.userRoles || [];

        // const roleNames = userRoles.map((role) => role.name);
        // const isDataAdminPresent = roleNames.includes("Data  Administrator");

        // if (!isDataAdminPresent) {
        //   const hasRelevantRole = roleNames.some((role) =>
        //     ["HTC", "ART user", "ART-I user", "ORW"].includes(role)
        //   );

        //   const isORW = roleNames.includes("ORW");

        //   if (
        //     navigator.onLine &&
        //     sessionUserBoValue?.userCredentials &&
        //     hasRelevantRole &&
        //     activeCaseDetails?.data?.trackedEntityInstance
        //   ) {
        //     formDisable = true;

        //     if (isORW) {
        //       fieldDisable = true;
        //     }
        //   }
        // }



        return (
            <Form
                onSubmit={onSubmit}
                initialValues={initialValues}
                render={({ handleSubmit, form, submitting, pristine, values }) => (
                    <form className={formDisable ? fieldDisable ? "fullWidth fieldDisable" : "fullWidth disabled" : "fullWidth"} onSubmit={handleSubmit}>
                        <div className="innertabdivreg">
                            <>
                                {// multicheckbox save logic 
                                    programData != null ?
                                        programData.programSections.map(programSection => {
                                            if (programSection.renderType['DESKTOP'].type == "SEQUENTIAL") {
                                                if (values[programSection.id] != undefined) {
                                                    programSection.trackedEntityAttributes.map(elements => {
                                                        delete values[elements.id]
                                                    })
                                                    values[programSection.id].map(value => {
                                                        values[value] = true
                                                    })
                                                }
                                            }
                                        }) : null
                                }
                            </>
                            <> {!openCamera ? <p className={Configuration.registrationForm.showOCR ? "ocrbuttonholder text-right" : "ocrbuttonholder text-right hide"}><Button className="regSearchCancelButton" onClick={() => setCameraStatus(true)}><ControlCameraIcon />{t('OCR')}</Button></p> : <> </>} </>
                            <> {openCamera ? <p className={Configuration.registrationForm.showOCR ? "ocrbuttonholder text-right" : "ocrbuttonholder text-right hide"}><Button className="regSearchCancelButton" onClick={() => setCameraStatus(false)}><ControlCameraIcon />{t('Close OCR')}</Button></p> : <> </>} </>
                            <Grid container spacing={3}>

                                {programData != null ?
                                    // programData.programSections.length > 0 ?
                                    //     renderRegistrationSections()
                                    //     :
                                    registrationFields.map(fieldsObject => {
                                        return renderRegistrationField(fieldsObject, values != null ? values : {}, programData)
                                    }) :
                                    null
                                }
                            </Grid>

                            <div className={sessionUserBoValue ? sessionUserBoValue.userCredentials ? sessionUserBoValue.userRoles ? sessionUserBoValue.userRoles[0].name ? (sessionUserBoValue.userRoles[0].name == 'HTC' || sessionUserBoValue.userRoles[0].name == 'ART user' || sessionUserBoValue.userRoles[0].name == 'ART-I user') ? 'hide buttons' : 'buttons' : 'buttons' : 'buttons' : 'buttons' : 'buttons'}>
                                <button className="regformsubmitbtn" type="submit" disabled={submitting}>
                                    {t('Submit')}
                                </button>
                            </div>

                            {/* <pre>{JSON.stringify(values, 0, 2)}</pre> */}
                        </div>
                    </form>
                )}
            />
        )
    }
    function updateRegDataToIndex() {
        const values = [];
        const UserBO = props.userData;
        const programData = props.programData.programs[0];
        const programId = programData.id
        const orgUnit = UserBO.organisationUnits[0].id
        const trackedEntityType = programData.trackedEntityType.id
        const caseDetails = trackentityInstanceDetails;
        const updateURL = 'trackedEntityInstances/' + caseDetails.trackedEntityInstance

        caseDetails.attributes.map(attr => {
            var obj = {
                "attribute": attr.attribute,
                "value": attr.value
            };
            if (attr.attribute == clientTypeID) {
                obj['value'] = "Index";
            }
            values.push(obj)
        })
        const updateCaseInput = {
            "created": caseDetails.created,
            "orgUnit": orgUnit,
            "createdAtClient": caseDetails.createdAtClient,
            "trackedEntityInstance": caseDetails.trackedEntityInstance,
            "lastUpdated": caseDetails.lastUpdated,
            "trackedEntityType": trackedEntityType,
            "lastUpdatedAtClient": caseDetails.lastUpdatedAtClient,
            "inactive": false,
            "deleted": false,
            "featureType": "NONE",
            "programOwners": [
                {
                    "ownerOrgUnit": orgUnit,
                    "program": programId,
                    "trackedEntityInstance": caseDetails.trackedEntityInstance,
                }
            ],
            "relationships": [],
            "attributes": values
        }
        apiServices.putAPI(updateURL, updateCaseInput)
            .then(updateRes => {

            })

    }

    function saveStage(valueToStore, valueForFormInput, currentStage, currentStageIndex, fetchActiveTab) {
        try {
            valueToStore.push({ "dataElement": usernameID, "value": currentLoginUsername })
        } catch (e) {
            console.log(e);
        }
        console.log("valueForFormInput,valueToStore", valueForFormInput, valueToStore)
        const orgUnit = valueForFormInput ? valueForFormInput[hotspotsID] ? valueForFormInput[hotspotsID] : userData.organisationUnits[0].id : userData.organisationUnits[0].id;
        //    userData.organisationUnits[0].id
        const programId = programData.programs[0].id
        const referalAPIObject = { "events": [] }
        const saveStageInput = {
            "trackedEntityInstance": activeCaseDetails.data.trackedEntityInstance,
            "program": programId,
            "programStage": currentStage.id,
            "enrollment": activeCaseDetails.data.enrollmentId,
            "orgUnit": orgUnit,
            "notes": [],
            "dataValues": valueToStore,
            "status": "COMPLETED",
            "eventDate": moment().format("YYYY-MM-DD")
        }
        if (categoryOptions && categoryOptions.categoryOptions && categoryOptions.categoryOptions[0] && categoryOptions.categoryOptions[0].id) {
            saveStageInput["attributeCategoryOptions"] = categoryOptions.categoryOptions[0].id
        } else {
            //thers is no category option associted with this user plz contact your administartion
            swal({
                title: t("Alert"),
                text: t("Their is no category option associted with this user please contact your administartion!"),
                icon: "error",
                button: t("Close"),
            });
            return;
        }
        console.log("currentStage", currentStage)
        //logic for new service client referring again
        if (currentStage.displayName == 'HTS') {
            console.log("tempActiveCaseFormData ", tempActiveCaseFormData);
            let tempData = tempActiveCaseFormData ? tempActiveCaseFormData.data ? tempActiveCaseFormData.data.formFormat : null : null;
            console.log("tempData", tempData, valueForFormInput);
            if (tempData && ((tempData["ZHoqyBa59km"] || tempData["yzVBu2VffD3"] || tempData["svTN057036v"]) && ((valueForFormInput["HBXuLtCgRHs"] && (valueForFormInput["HBXuLtCgRHs"] == "Referral" || valueForFormInput["HBXuLtCgRHs"] == "Accompanied Referral")) || valueForFormInput["yzVBu2VffD3"] || valueForFormInput["svTN057036v"] || valueForFormInput["yzVBu2VffD3"] || valueForFormInput["svTN057036v"])) && !tempData["HhQNLlyPilm"]) {
                setGlobalSpinner(false)
                swal({
                    title: t("Alert"),
                    text: t("Client is already referred!"),
                    icon: "error",
                    button: t("Close"),
                });
                return;
            } else if (tempData && tempData["HhQNLlyPilm"] && tempData["ZHoqyBa59km"] && !valueForFormInput["ZHoqyBa59km"]) { // value not set for htc center 
                if ((valueForFormInput["HBXuLtCgRHs"] && (valueForFormInput["HBXuLtCgRHs"] == "Referral" || valueForFormInput["HBXuLtCgRHs"] == "Accompanied Referral")) || valueForFormInput["yzVBu2VffD3"]) {
                    valueForFormInput["ZHoqyBa59km"] = tempData["ZHoqyBa59km"];
                }
            }
        } else if (currentStage.displayName == 'STI') {
            let tempData = tempActiveCaseFormData ? tempActiveCaseFormData.data ? tempActiveCaseFormData.data.formFormat : null : null;
            if (tempData && tempData["W2GQ7PJIHHh"] && ((valueForFormInput["ppnkyJJlASL"] && (valueForFormInput["ppnkyJJlASL"] == "Referral" || valueForFormInput["ppnkyJJlASL"] == "Accomoanied referral") || valueForFormInput["W2GQ7PJIHHh"])) && !tempData["HhQNLlyPilm"]) {
                setGlobalSpinner(false)
                swal({
                    title: t("Alert"),
                    text: t("Client is already referred!"),
                    icon: "error",
                    button: t("Close"),
                });
                return;
            }
        } else if (currentStage.displayName == 'TB') {
            let tempData = tempActiveCaseFormData ? tempActiveCaseFormData.data ? tempActiveCaseFormData.data.formFormat : null : null;
            if (tempData && tempData["JsObII1YufJ"] && ((valueForFormInput["bHc1NH28nW2"] && (valueForFormInput["bHc1NH28nW2"] == "Referral" || valueForFormInput["bHc1NH28nW2"] == "Accomoanied referral") || valueForFormInput["JsObII1YufJ"])) && !tempData["HhQNLlyPilm"]) {
                setGlobalSpinner(false)
                swal({
                    title: t("Alert"),
                    text: t("Client is already referred!"),
                    icon: "error",
                    button: t("Close"),
                });
                return;
            }
        }
        // logic for regimen stage save data
        if (currentStage.attributeValues && currentStage.attributeValues.length > 0) {
            currentStage.attributeValues.map((val) => {
                if (medicineTable.length > 0) {
                    if (val.attribute.displayName === "Regimen") {
                        // focefully remove treatmentAdherenceId
                        valueToStore.map((ele, idx) => {
                            if (ele.dataElement == treatmentAdherenceId) {
                                valueToStore.splice(idx, 1)
                            }
                        })
                        medicineTable.map(row => {

                            const regimenConfigObject = _.find(Configuration.treatmentRegimens, { 'code': row[treatmentRegimenId], 'phase': row[treatmentPhaseId] });

                            if (regimenConfigObject != undefined) {
                                let fieldDetails = _.filter(currentStage.programStageDataElements, ['dataElement.displayName', regimenConfigObject.associatedFieldName])

                                let objvalueToStore = _.cloneDeep(valueToStore);
                                let rowdata = Object.assign({}, row);
                                //medicine
                                let obj = {
                                    "dataElement": fieldDetails[0].dataElement.id,
                                    "value": rowdata['medicine']['code']
                                }
                                /*objvalueToStore.map((ele,idx)=>{
                                    if(ele.dataElement == fixedDoseChildren.id){
                                        //ele.value = rowdata['medicine']['code']
                                        objvalueToStore.splice(idx,1)
                                    }
                                })*/
                                objvalueToStore.push(Object.assign({}, obj))
                                objvalueToStore.push({ "dataElement": treatmentAdherenceId, "value": rowdata[treatmentAdherenceId] })

                                let tempSaveStageInput = _.cloneDeep(saveStageInput);
                                tempSaveStageInput['dataValues'] = objvalueToStore
                                referalAPIObject.events.push(tempSaveStageInput)

                            }
                            /*if(row[treatmentRegimenId] == Configuration.treatmentRegimens.option1){
                                let objvalueToStore = _.cloneDeep(valueToStore);
                                let rowdata = Object.assign({},row);
                                //medicine
                                let obj =  {
                                        "dataElement":fixedDoseChildren.id,
                                        "value":rowdata['medicine']['code']
                                        }
                                objvalueToStore.push(Object.assign({},obj))
                                objvalueToStore.push({"dataElement":treatmentAdherenceId,"value":rowdata[treatmentAdherenceId]})
                                
                                let tempSaveStageInput = _.cloneDeep(saveStageInput);
                                tempSaveStageInput['dataValues'] = objvalueToStore
                                referalAPIObject.events.push(tempSaveStageInput)
                            }else if(row[treatmentRegimenId] == Configuration.treatmentRegimens.option2){
                                let objvalueToStore = _.cloneDeep(valueToStore);
                                let rowdata = Object.assign({},row);
                                let obj =  {
                                        "dataElement":singleDoseChildren.id,
                                        "value":rowdata['medicine']['code']
                                        }
                                
                                objvalueToStore.push(Object.assign({},obj))
                                objvalueToStore.push({"dataElement":treatmentAdherenceId,"value":rowdata[treatmentAdherenceId]})
                                let tempSaveStageInput = _.cloneDeep(saveStageInput);
                                tempSaveStageInput['dataValues'] = objvalueToStore
                                referalAPIObject.events.push(tempSaveStageInput)
                            }else if(row[treatmentRegimenId] == Configuration.treatmentRegimens.option3){
                                let objvalueToStore = _.cloneDeep(valueToStore);
                                let rowdata = Object.assign({},row);
                                let obj =  {
                                        "dataElement":fixedDoseAdult.id,
                                        "value":rowdata['medicine']['code']
                                        }
                                
                                objvalueToStore.push(Object.assign({},obj))
                                objvalueToStore.push({"dataElement":treatmentAdherenceId,"value":rowdata[treatmentAdherenceId]})
                                let tempSaveStageInput = _.cloneDeep(saveStageInput);
                                tempSaveStageInput['dataValues'] = objvalueToStore
                                referalAPIObject.events.push(tempSaveStageInput)
         
                            }else if(row[treatmentRegimenId] == Configuration.treatmentRegimens.option4){
                                let objvalueToStore = _.cloneDeep(valueToStore);
                                let rowdata = Object.assign({},row);
                                let obj =  {
                                        "dataElement":singleDoseAdult.id,
                                        "value":rowdata['medicine']['code']
                                        }
                                objvalueToStore.push(Object.assign({},obj))
                                objvalueToStore.push({"dataElement":treatmentAdherenceId,"value":rowdata[treatmentAdherenceId]})
                                let tempSaveStageInput = _.cloneDeep(saveStageInput);
                                tempSaveStageInput['dataValues'] = objvalueToStore
                                referalAPIObject.events.push(tempSaveStageInput)
                            }*/
                        })
                    } else if (val.attribute.displayName === "showFullCalender") {
                        if (fullCalendarEvents.length > 0) {
                            fullCalendarEvents.map(event => {
                                medicineTable.map(row => {
                                    // debugger;
                                    // focefully remove fixed dose value
                                    /*valueToStore.map((ele,idx)=>{
                                        if(ele.dataElement == fixedDoseChildren.id){
                                            valueToStore.splice(idx,1)
                                        }
                                    })*/
                                    const regimenConfigObject = _.find(Configuration.treatmentRegimens, { 'code': row[treatmentRegimenId], 'phase': row[treatmentPhaseId] });
                                    if (regimenConfigObject != undefined) {

                                        let fieldDetails = _.filter(currentStage.programStageDataElements, ['dataElement.displayName', regimenConfigObject.associatedFieldName])

                                        let objvalueToStore = _.cloneDeep(valueToStore);
                                        objvalueToStore = _.reject(objvalueToStore, { 'value': "" });
                                        let rowdata = Object.assign({}, row);
                                        //medicine
                                        let obj = {
                                            "dataElement": fieldDetails[0].dataElement.id,
                                            "value": rowdata['medicine']['code']
                                        }
                                        objvalueToStore.map((ele, idx) => {
                                            /* if (ele.dataElement == fieldDetails[0].dataElement.id) {
                                                 //ele.value = rowdata['medicine']['code']
                                                 objvalueToStore.splice(idx, 1)
                                             }*/
                                            switch (ele.dataElement) {
                                                case fieldDetails[0].dataElement.id:
                                                    objvalueToStore.splice(idx, 1)
                                                    break;
                                                case treatmentAdherenceId:
                                                    objvalueToStore.splice(idx, 1)
                                                    break;
                                                case medicineColorCodeId:
                                                    objvalueToStore.splice(idx, 1)
                                                    break;
                                                case medicineTakenId:
                                                    objvalueToStore.splice(idx, 1)
                                                    break;
                                            }
                                        })
                                        objvalueToStore.push(Object.assign({}, obj))

                                        //radioValue

                                        objvalueToStore.push(Object.assign({},
                                            {
                                                "dataElement": medicineTakenId,
                                                "value": (_.get(radioValue, rowdata['medicine']['code'])) ? _.get(radioValue, rowdata['medicine']['code']) : 'yes'
                                            }
                                        ))
                                        //push date medicine taken
                                        objvalueToStore.push({ "dataElement": dateMedicineTakenId, "value": event.start })

                                        //push color code
                                        objvalueToStore.push(Object.assign({}, { "dataElement": medicineColorCodeId, "value": event.backgroundColor }))

                                        //push adherenceid
                                        objvalueToStore.push(Object.assign({}, { "dataElement": treatmentAdherenceId, "value": rowdata[treatmentAdherenceId] }))

                                        let tempSaveStageInput = _.cloneDeep(saveStageInput);
                                        tempSaveStageInput['dataValues'] = _.cloneDeep(objvalueToStore);

                                        referalAPIObject.events.push(tempSaveStageInput)
                                    }
                                    /*if(row[treatmentRegimenId] == Configuration.treatmentRegimens.option1){
                                        let objvalueToStore = _.cloneDeep(valueToStore);
                                        let rowdata = Object.assign({},row);
                                        //medicine
                                        let obj =  {
                                                "dataElement":fixedDoseChildren.id,
                                                "value":rowdata['medicine']['code']
                                                }
                                        objvalueToStore.map((ele,idx)=>{
                                            if(ele.dataElement == fixedDoseChildren.id){
                                                //ele.value = rowdata['medicine']['code']
                                                objvalueToStore.splice(idx,1)
                                            }
                                        })
                                        objvalueToStore.push(Object.assign({},obj))
                                       
                                        //radioValue
                                        
                                        objvalueToStore.push(Object.assign({},
                                            {
                                                "dataElement":medicineTakenId,
                                                "value":(_.get(radioValue, rowdata['medicine']['code'])) ? _.get(radioValue, rowdata['medicine']['code']) : 'yes'
                                            }
                                        ))
                                        //push date medicine taken
                                        objvalueToStore.push({"dataElement":dateMedicineTakenId,"value":event.start})
                                        //push adherenceid
                                        objvalueToStore.push(Object.assign({},{"dataElement":treatmentAdherenceId,"value":rowdata[treatmentAdherenceId]}))
                                        
                                        let tempSaveStageInput = _.cloneDeep(saveStageInput);
                                        tempSaveStageInput['dataValues'] = _.cloneDeep(objvalueToStore);
                                        
                                        referalAPIObject.events.push(tempSaveStageInput)
                                    }else if(row[treatmentRegimenId] == Configuration.treatmentRegimens.option2){
                                        let objvalueToStore = _.cloneDeep(valueToStore);
                                        let rowdata = Object.assign({},row);
                                        let obj =  {
                                                "dataElement":singleDoseChildren.id,
                                                "value":rowdata['medicine']['code']
                                                }
                                        objvalueToStore.map((ele,idx)=>{
                                            if(ele.dataElement == singleDoseChildren.id){
                                                objvalueToStore.splice(idx,1)
                                            }
                                        })
                                        objvalueToStore.push(Object.assign({},obj))
         
                                        //radioValue
                                        objvalueToStore.push(Object.assign({},
                                            {
                                                "dataElement":medicineTakenId,
                                                "value":(_.get(radioValue, rowdata['medicine']['code'])) ? _.get(radioValue, rowdata['medicine']['code']) : 'yes'
                                            }
                                        ))
                                        //push date medicine taken
                                        objvalueToStore.push({"dataElement":dateMedicineTakenId,"value":event.start})
                                        objvalueToStore.push({"dataElement":treatmentAdherenceId,"value":rowdata[treatmentAdherenceId]})
                                        let tempSaveStageInput = _.cloneDeep(saveStageInput);
                                        tempSaveStageInput['dataValues'] = objvalueToStore
                                        referalAPIObject.events.push(tempSaveStageInput)
                                    }else if(row[treatmentRegimenId] == Configuration.treatmentRegimens.option3){
                                        let objvalueToStore = _.cloneDeep(valueToStore);
                                        let rowdata = Object.assign({},row);
                                        let obj =  {
                                                "dataElement":fixedDoseAdult.id,
                                                "value":rowdata['medicine']['code']
                                                }
                                        objvalueToStore.map((ele,idx)=>{
                                            if(ele.dataElement == fixedDoseAdult.id){
                                                objvalueToStore.splice(idx,1)
                                            }
                                        })
                                        objvalueToStore.push(Object.assign({},obj))
         
                                        //radioValue
                                        objvalueToStore.push(Object.assign({},
                                            {
                                                "dataElement":medicineTakenId,
                                                "value":(_.get(radioValue, rowdata['medicine']['code'])) ? _.get(radioValue, rowdata['medicine']['code']) : 'yes'
                                            }
                                        ))
                                        //push date medicine taken
                                        objvalueToStore.push({"dataElement":dateMedicineTakenId,"value":event.start})
                                        //push adherenceid
                                        objvalueToStore.push({"dataElement":treatmentAdherenceId,"value":rowdata[treatmentAdherenceId]})
                                        let tempSaveStageInput = _.cloneDeep(saveStageInput);
                                        tempSaveStageInput['dataValues'] = objvalueToStore
                                        referalAPIObject.events.push(tempSaveStageInput)
                
                                    }else if(row[treatmentRegimenId] == Configuration.treatmentRegimens.option4){
                                        let objvalueToStore = _.cloneDeep(valueToStore);
                                        let rowdata = Object.assign({},row);
                                        let obj =  {
                                                "dataElement":singleDoseAdult.id,
                                                "value":rowdata['medicine']['code']
                                                }
                                        objvalueToStore.map((ele,idx)=>{
                                            if(ele.dataElement == singleDoseAdult.id){
                                                objvalueToStore.splice(idx,1)
                                            }
                                        })
                                        objvalueToStore.push(Object.assign({},obj))
                                        
                                        //radioValue
                                        objvalueToStore.push(Object.assign({},
                                            {
                                                "dataElement":medicineTakenId,
                                                "value":(_.get(radioValue, rowdata['medicine']['code'])) ? _.get(radioValue, rowdata['medicine']['code']) : 'yes'
                                            }
                                        ))
                                        //push date medicine taken
                                        objvalueToStore.push({"dataElement":dateMedicineTakenId,"value":event.start})
                                        //push adherenceid
                                        objvalueToStore.push({"dataElement":treatmentAdherenceId,"value":rowdata[treatmentAdherenceId]})
                                        let tempSaveStageInput = _.cloneDeep(saveStageInput);
                                        tempSaveStageInput['dataValues'] = objvalueToStore
                                        referalAPIObject.events.push(tempSaveStageInput)
                                    }*/
                                })

                            })
                        }
                    }
                } else if (sputumTable.length > 0) {
                    if (val.attribute.displayName === "SpecimenTable") {
                        // console.log('sputumtable??', sputumTable)
                        sputumTable.map(row => {
                            let objvalueToStore = _.cloneDeep(valueToStore);
                            for (const key in row) {
                                if (Object.hasOwnProperty.call(row, key)) {
                                    const val = row[key];
                                    let obj = {
                                        "dataElement": key,
                                        "value": val
                                    }
                                    objvalueToStore.push(Object.assign({}, obj))
                                }
                            }

                            let tempSaveStageInput = _.cloneDeep(saveStageInput);
                            tempSaveStageInput['dataValues'] = objvalueToStore
                            referalAPIObject.events.push(tempSaveStageInput)
                        })
                    }
                } else {
                    if (referalAPIObject.events && referalAPIObject.events.length > 0) {
                        let currentEvent = _.filter(referalAPIObject.events, { "programStage": currentStage.id });
                        if (currentEvent && currentEvent.length == 0) {
                            referalAPIObject.events.push(saveStageInput)
                        }
                    } else {
                        referalAPIObject.events.push(saveStageInput)
                    }
                }
            })
        } else {
            referalAPIObject.events.push(saveStageInput)
        }

        const getAllKeys = Object.keys(valueForFormInput)

        let OUFieldSelectedLocation = ''

        const filterReferalField = getAllKeys.map(keys => {
            const filter = currentStage.programStageDataElements.filter(obj => obj.dataElement.id == keys)
            if (filter.length > 0) {
                filter.map(filteredField => {
                    if (filteredField.dataElement.fieldMask == 'Facility Referral') {

                        const filteredKey = filteredField.dataElement.id
                        const selectedOUField = currentStage.programStageDataElements.filter(obj => obj.dataElement.fieldMask == 'Facility Referral OU')

                        let selectedOUFieldData = selectedOUField.length > 0 ? valueForFormInput[selectedOUField[0].dataElement.id] : ''
                        OUFieldSelectedLocation = selectedOUFieldData

                        if (!selectedOUFieldData) {
                            selectedOUField.map(ouField => {
                                if (valueForFormInput[ouField.dataElement.id]) {
                                    selectedOUFieldData = valueForFormInput[ouField.dataElement.id]
                                }
                            })
                        }
                        //console.log('Facility Referral',selectedOUFieldData,valueForFormInput);
                        const referalFieldValue = valueForFormInput[filteredKey]
                        referalFieldValue.map(stageId => {
                            const obj = {
                                "trackedEntityInstance": trackentityInstanceDetails.trackedEntityInstance,
                                "program": programId,
                                "programStage": stageId,
                                "enrollment": navigator.onLine ? trackentityInstanceDetails.enrollments[0].enrollment : "",
                                "orgUnit": selectedOUFieldData,
                                "notes": [],
                                "dataValues": [],
                                "status": "SCHEDULE",
                                "dueDate": moment().format("YYYY-MM-DD")
                            }
                            if (categoryOptions && categoryOptions.categoryOptions && categoryOptions.categoryOptions[0] && categoryOptions.categoryOptions[0].id) {
                                obj["attributeCategoryOptions"] = categoryOptions.categoryOptions[0].id
                            }
                            if (selectedOUFieldData) {
                                referalAPIObject.events.push(obj)
                            }
                        })
                    } else if (filteredField.dataElement.fieldMask == 'Transfer Out') {

                        const stageId = currentStage.id
                        const selectedOUField = filteredField.dataElement.id
                        const selectedOUFieldData = selectedOUField.length > 0 ? valueForFormInput[selectedOUField] : ''
                        OUFieldSelectedLocation = selectedOUFieldData

                        const obj = {
                            "trackedEntityInstance": trackentityInstanceDetails.trackedEntityInstance,
                            "program": programId,
                            "programStage": stageId,
                            "enrollment": trackentityInstanceDetails.enrollments[0].enrollment,
                            "orgUnit": selectedOUFieldData,
                            "notes": [],
                            "dataValues": valueToStore,
                            "status": "SCHEDULE",
                            "dueDate": moment().format("YYYY-MM-DD")
                        }
                        if (selectedOUFieldData) {
                            referalAPIObject.events = []
                            referalAPIObject.events.push(obj)

                        }
                    } else if (filteredField.dataElement.fieldMask == 'Transfer In') {
                        const stageId = currentStage.id
                        const selectedOUField = filteredField.dataElement.id
                        const selectedOUFieldData = selectedOUField.length > 0 ? valueForFormInput[selectedOUField] : ''
                        OUFieldSelectedLocation = selectedOUFieldData

                        const obj = {
                            "trackedEntityInstance": trackentityInstanceDetails.trackedEntityInstance,
                            "program": programId,
                            "programStage": stageId,
                            "enrollment": trackentityInstanceDetails.enrollments[0].enrollment,
                            "orgUnit": selectedOUFieldData,
                            "notes": [],
                            "dataValues": valueToStore,
                            "status": "SCHEDULE",
                            "dueDate": moment().format("YYYY-MM-DD")
                        }
                        if (selectedOUFieldData) {
                            referalAPIObject.events = []
                            referalAPIObject.events.push(obj)

                        }
                    }
                })
            }
        })
        // for Asign task stage logic
        if (currentStage.attributeValues && currentStage.attributeValues.length > 0 && currentStage.attributeValues[0].attribute.name == 'Assign Task') {
            let taskAssignUserDataElement = currentStage.programStageDataElements.filter(obj => obj.dataElement.displayFormName == "Task Assign User")
            referalAPIObject.events[0].status = "SCHEDULE";
            referalAPIObject.events[0]["assignedUser"] = valueForFormInput[taskAssignUserDataElement[0].dataElement.id];
        }
        // console.log("currentStage.attributeValues[0].attribute.name",currentStage.attributeValues[0].attribute.name)
        if (currentStage.attributeValues && currentStage.attributeValues.length > 0 && currentStage.attributeValues[0].attribute.name == 'Assign Task') {
            let taskAssignUserDataElement = currentStage.programStageDataElements.filter(obj => obj.dataElement.displayFormName == "Task Assign User")
            referalAPIObject.events[0].status = "SCHEDULE";
            referalAPIObject.events[0]["assignedUser"] = valueForFormInput[taskAssignUserDataElement[0].dataElement.id];

        }

        // if (userData.displayName == "User Facility") {
        //     const eventsList = trackentityInstanceDetails.enrollments[0].events
        //     const ScheduledEvents = trackentityInstanceDetails.enrollments[0].events.filter(obj => obj.status == "SCHEDULE")
        //     const url = 'events/' + ScheduledEvents[0].event + '/eventDate'

        //     const PUTObject = ScheduledEvents.length > 0 ? {
        //         "event": ScheduledEvents[0].event,
        //         "enrollment": ScheduledEvents[0].enrollment,
        //         "dueDate": "2020-10-12",
        //         "status": "COMPLETED",
        //         "program": ScheduledEvents[0].program,
        //         "programStage": ScheduledEvents[0].programStage,
        //         "orgUnit": ScheduledEvents[0].orgUnit,
        //         "eventDate": "2020-10-12",
        //         "trackedEntityInstance": ScheduledEvents[0].trackedEntityInstance
        //     } : {}

        //     apiServices.putAPI(url, PUTObject)
        //         .then(ReferalResponse => {
        //             apiServices.postAPI('events.json', referalAPIObject)
        //                 .then(stageResponse => {
        //                     swal({
        //                         title: t("Success"),
        //                         text: t("Successfully submited event"),
        //                         icon: "success",
        //                         button: t("Close"),
        //                     });
        //                 })
        //         })
        // } else {
        //console.log("referalAPIObject",referalAPIObject,categoryOptions)
        //return;
        if (navigator.onLine) {
            setGlobalSpinner(true)
            apiServices.postAPI('events.json', referalAPIObject)
                .then(stageResponse => {
                    setGlobalSpinner(false)
                    if (!workFlow) {
                        OfflineDb.setDataIntoPouchDB('newSeviceStart', false)
                        setServiceStartFlag(false)
                    }

                    if (currentStageIndex == 1 && programData.programs[0].useFirstStageDuringRegistration == true && relationShipId != "" && Configuration.registrationForm.linkContactInAlert) {
                        swal({
                            title: t("Individual Registered"),
                            text: t("Do you want to initiate the individual registration?"),
                            icon: "success",
                            buttons: [t("No"), t("Yes")],
                        })
                            .then((AlertRes) => {
                                if (AlertRes) {
                                    //save data
                                    const linkContact = {
                                        "enabled": true,
                                        "linkTrackedEntityInstance": activeCaseDetails.data.trackedEntityInstance
                                    }
                                    const activeStageCaseFormData = {
                                        'formFormat': null, //valueForFormInput,
                                        'dhisFormat': null //
                                    }

                                    OfflineDb.setDataIntoPouchDB('activeCaseFormData', activeStageCaseFormData)
                                    OfflineDb.setDataIntoPouchDB('linkContactFlag', linkContact)

                                    setActiveCaseFormData({
                                        "data": {
                                            'formFormat': null, //valueForFormInput,
                                            'dhisFormat': null //
                                        }
                                    })
                                    setValue(0)
                                } else {
                                    const linkContact = {
                                        "enabled": false,
                                        "linkTrackedEntityInstance": activeCaseDetails.data.trackedEntityInstance
                                    }
                                    const activeStageCaseFormData = {
                                        'formFormat': valueForFormInput, //valueForFormInput,
                                        'dhisFormat': null //
                                    }

                                    OfflineDb.setDataIntoPouchDB('activeCaseFormData', activeStageCaseFormData)
                                    OfflineDb.setDataIntoPouchDB('linkContactFlag', linkContact)

                                    //check next active tab
                                    const nextTab = fetchActiveTab[fetchActiveTab.indexOf(currentStage.id) + 1]
                                    if (nextTab) {
                                        const indexOfNextTab = programData.programs[0].programStages.findIndex(obj => obj.id == nextTab)
                                        setValue(indexOfNextTab + stepIncrement)
                                    } else {
                                        setValue(value)
                                        swal({
                                            title: t("Success"),
                                            text: t("Successfully submitted event"),
                                            icon: "success",
                                            button: t("Close"),
                                        });
                                        history.push('/layout/home');
                                    }
                                }
                            })
                    } else if (props.stageTabValue && props.stageTabValue != 0 && props.stageInstanceID) {
                        let submittedDataValues = ''
                        let stageID = ''
                        let orgUnit = ''
                        let trackeInstanceID = trackentityInstanceDetails.trackedEntityInstance
                        trackentityInstanceDetails.enrollments[0].events.map(event => {
                            submittedDataValues = event.dataValues
                            stageID = event.programStage
                            orgUnit = event.orgUnit
                        })
                        const updateURL = 'events/' + props.stageInstanceID
                        let UpdateStageInput =
                        {
                            "dataValues": submittedDataValues,
                            "event": props.stageInstanceID,
                            "program": programId,
                            "programStage": stageID,
                            "orgUnit": orgUnit,
                            "trackedEntityInstance": trackeInstanceID,
                            "status": "COMPLETED",
                            "dueDate": moment().format("YYYY-MM-DD"),
                            "eventDate": moment().format("YYYY-MM-DD"),
                            "completedDate": moment().format("YYYY-MM-DD")
                        }

                        apiServices.putAPI(updateURL, UpdateStageInput)
                            .then(stageResponse => {
                                const trasferAPI = '30/tracker/ownership/transfer?trackedEntityInstance=' + trackeInstanceID + '&program=' + programId + '&ou=' + referalAPIObject.events[0].orgUnit
                                apiServices.putAPI(trasferAPI, {})
                                    .then(trasferResponse => {

                                        swal({
                                            title: t("Success"),
                                            text: t("Successfully submitted event"),
                                            icon: "success",
                                            button: t("Close"),
                                        });
                                        history.push('/layout/home');
                                    })
                            })

                    } else {
                        let redirectedHome = false;
                        const getURL = 'trackedEntityInstances/' + activeCaseDetails.data.trackedEntityInstance + '.json?program=' + programId + '&fields=*?'
                        setGlobalSpinner(true)
                        apiServices.getAPI(getURL)
                            .then(res => {
                                setGlobalSpinner(false)
                                setTrackentityInstanceDetails(res.data)

                                const previousFilledData = activeCaseFormData
                                //debugger;
                                setActiveCaseFormData({
                                    "data": {
                                        'formFormat': valueForFormInput, //,
                                        'dhisFormat': null //
                                    },
                                    "setdata": true
                                })
                                //checkTabs(currentStage)

                                const linkContact = {
                                    "enabled": false,
                                    "linkTrackedEntityInstance": activeCaseDetails.data.trackedEntityInstance
                                }
                                const activeStageCaseFormData = {
                                    'formFormat': valueForFormInput, //valueForFormInput,
                                    'dhisFormat': null //
                                }

                                setActiveCaseFormData({
                                    "data": {
                                        'formFormat': valueForFormInput, //valueForFormInput,
                                        'dhisFormat': null //
                                    }
                                })

                                OfflineDb.setDataIntoPouchDB('activeCaseFormData', activeStageCaseFormData)
                                OfflineDb.setDataIntoPouchDB('linkContactFlag', linkContact)
                                if (currentStage.name.trim().toLocaleLowerCase() == "tb testing form") {

                                    let testResultTBObj = currentStage.programStageDataElements.filter(obj => obj.dataElement.displayName.trim() == "Test result (TB)")
                                    let testResultTBId = (testResultTBObj.length > 0) ? testResultTBObj[0].dataElement.id : null;
                                    if (valueForFormInput[clientTypeID] == Configuration.ltbiLinkVariables.presumptivetb && valueForFormInput[testResultTBId].trim().toUpperCase() == "POSITIVE") {
                                        updateRegDataToIndex();
                                    }
                                }
                                if (currentStage.name.trim().toLocaleLowerCase() == "transfer out") {
                                    redirectedHome = true;
                                }
                                if (currentStage.name.trim().toLocaleLowerCase() == "commodities" || currentStage.name.trim().toLocaleLowerCase() == "art enrollment" || currentStage.name.trim().toLocaleLowerCase() == "orw component" || currentStage.name.trim().toLocaleLowerCase() == "htc" || currentStage.name.trim().toLocaleLowerCase() == "art initiation") {
                                    redirectedHome = true;
                                }
                                if (currentStage.name.trim().toLocaleLowerCase() == "htc") {
                                    let determineTest = "HhQNLlyPilm", uniGold = "IfgPLHu0Pf3", statpak = "EmKOoPr5JGU";
                                    /*if(valueForFormInput[determineTest] && valueForFormInput[uniGold] && valueForFormInput[statpak] && valueForFormInput[determineTest] == 'Determine Reactive Result' && ((valueForFormInput[uniGold] == 'Uni-gold Non-reactive' && valueForFormInput[statpak] == 'Stat-pak reactive') || (valueForFormInput[uniGold] == 'Uni-gold Reactive' && valueForFormInput[statpak] == 'Stat-pak Non reactive') || (valueForFormInput[uniGold] == 'Uni-gold Invalid' && valueForFormInput[statpak] == 'Stat-pak reactive') || (valueForFormInput[uniGold] == 'Uni-gold Reactive' && valueForFormInput[statpak] == 'Stat-pak Invalid'))){
                                        redirectedHome = true;
                                    }*/
                                }
                                //next tab
                                const nextTab = fetchActiveTab[fetchActiveTab.indexOf(currentStage.id) + 1]
                                console.log("nextTab", nextTab, redirectedHome);
                                if (nextTab && !redirectedHome) {
                                    /*swal({
                                        title: t("Success"),
                                        text: t("Successfully submited event"),
                                        icon: "success",
                                        button: t("Close"),
                                    });*/
                                    const indexOfNextTab = programData.programs[0].programStages.findIndex(obj => obj.id == nextTab)
                                    setValue(indexOfNextTab + stepIncrement)
                                } else {
                                    setValue(value)
                                    swal({
                                        title: t("Success"),
                                        text: t("Successfully submitted event"),
                                        icon: "success",
                                        button: t("Close"),
                                    });
                                    history.push('/layout/home');
                                }
                                setGlobalSpinner(false)
                            }).catch(err => {
                                swal({
                                    title: t("Error"),
                                    text: t("Sorry, something went wrong"),
                                    icon: "error",
                                    buttons: t('Close')
                                })

                            })
                    }
                    //Remove as per ramesh suggestion
                    // if (OUFieldSelectedLocation != '') {
                    //     setGlobalSpinner(true)
                    //     let subURLApi = 'tracker/ownership/transfer?trackedEntityInstance=' + activeCaseDetails.data.trackedEntityInstance + '&program=' + programId + '&ou=' + OUFieldSelectedLocation
                    //     apiServices.putAPI(subURLApi, {})
                    //         .then(ReferalResponse => {
                    //             setGlobalSpinner(false)
                    //         })
                    // }
                    setGlobalSpinner(false)
                    setMedicineTable([]);
                }).catch(err => {
                    setGlobalSpinner(false)
                    // swal({
                    //     title: t("Error"),
                    //     text: t("Sorry, something went wrong"),
                    //     icon: "error",
                    //     buttons: t('Close')
                    // })
                    loadErrorPopup(err)
                })
            // if offline    
        } else {
            console.log("valueForFormInput,valueToStore1", valueForFormInput, valueToStore, referalAPIObject)
            updateOfflineServiceData(valueForFormInput, valueToStore, currentStage, referalAPIObject, fetchActiveTab)
            /*return;
            let instance = { "data": valueForFormInput, "servicedata": referalAPIObject }
            setGlobalSpinner(false)
            OfflineDb.updateEntity(activeCaseDetails.data.trackedEntityInstance, instance).then(res => {
    
                const linkContact = {
                    "enabled": false,
                    "linkTrackedEntityInstance": activeCaseDetails.data.trackedEntityInstance
                }
                const activeStageCaseFormData = {
                    'formFormat': valueForFormInput,
                    'dhisFormat': null
                }
    
                setActiveCaseFormData({
                    "data": {
                        'formFormat': valueForFormInput,
                        'dhisFormat': null
                    }
                })
    
                OfflineDb.setDataIntoPouchDB('activeCaseFormData', activeStageCaseFormData)
                OfflineDb.setDataIntoPouchDB('linkContactFlag', linkContact)
    
                //next tab
                const nextTab = fetchActiveTab[fetchActiveTab.indexOf(currentStage.id) + stepIncrement]
                if (nextTab) {
                    swal({
                        title: t("Success"),
                        text: t("Successfully submited event offline"),
                        icon: "success",
                        button: t("Close"),
                    });
                    const indexOfNextTab = programData.programs[0].programStages.findIndex(obj => obj.id == nextTab)
                    setValue(indexOfNextTab + stepIncrement)
                } else {
                    setValue(value)
                    swal({
                        title: t("Success"),
                        text: t("Successfully submited event offline"),
                        icon: "success",
                        button: t("Close"),
                    });
                    history.push('/layout/home');
                }
            })*/
        }

    }

    function updateStage(valueToStore, valueForFormInput, currentStage, currentStageIndex, eventId, fetchActiveTab) {
        //debugger;
        try {
            valueToStore.push({ "dataElement": usernameID, "value": currentLoginUsername })
        } catch (e) {
            console.log(e);
        }
        const orgUnit = valueForFormInput ? valueForFormInput[hotspotsID] ? valueForFormInput[hotspotsID] : userData.organisationUnits[0].id : userData.organisationUnits[0].id;
        //userData.organisationUnits[0].id
        const programId = programData.programs[0].id
        const updateURL = '33/events?strategy=CREATE_AND_UPDATE'//'events/' + eventId
        let UpdateStageInput =
        {
            "dataValues": valueToStore,
            "event": eventId,
            "program": programId,
            "programStage": currentStage.id,
            "orgUnit": orgUnit,
            "trackedEntityInstance": activeCaseDetails.data.trackedEntityInstance,
            "status": "COMPLETED",
            "dueDate": moment().format("YYYY-MM-DD"),
            "eventDate": moment().format("YYYY-MM-DD"),
            "completedDate": moment().format("YYYY-MM-DD")
        }
        if (categoryOptions && categoryOptions.categoryOptions && categoryOptions.categoryOptions[0] && categoryOptions.categoryOptions[0].id) {
            UpdateStageInput["attributeCategoryOptions"] = categoryOptions.categoryOptions[0].id
        }
        const referalAPIObject = { "events": [] }

        if (currentStage.id == regimenStageId && medicineTable.length > 0) {
            //remove forecefully
            _.remove(valueToStore, { value: "Ethambutol" })
            let CreateStageEventInput =
            {
                //"dataValues": valueToStore,
                //"event": eventId,
                "program": programId,
                "programStage": currentStage.id,
                "orgUnit": orgUnit,
                "trackedEntityInstance": activeCaseDetails.data.trackedEntityInstance,
                "status": "COMPLETED",
                "dueDate": moment().format("YYYY-MM-DD"),
                "eventDate": moment().format("YYYY-MM-DD"),
                "completedDate": moment().format("YYYY-MM-DD")
            }
            let treatmentAdherenceVal = "";
            medicineTable.map(row => {

                if (row['eventdetails']) {
                    treatmentAdherenceVal = row[treatmentAdherenceId]
                    UpdateStageInput = {
                        "dataValues": row['eventdetails']['dataValues'],
                        "event": row['eventdetails']['event'],
                        "program": programId,
                        "programStage": currentStage.id,
                        "orgUnit": orgUnit,
                        "trackedEntityInstance": activeCaseDetails.data.trackedEntityInstance,
                        "status": "COMPLETED",
                        "dueDate": moment().format("YYYY-MM-DD"),
                        "eventDate": moment().format("YYYY-MM-DD"),
                        "completedDate": moment().format("YYYY-MM-DD")
                    }
                    referalAPIObject.events.push(UpdateStageInput)
                } else {

                    const regimenConfigObject = _.find(Configuration.treatmentRegimens, { 'code': row[treatmentRegimenId], 'phase': row[treatmentPhaseId] });
                    if (regimenConfigObject != undefined) {
                        let fieldDetails = _.filter(currentStage.programStageDataElements, ['dataElement.displayName', regimenConfigObject.associatedFieldName])
                        let objvalueToStore = _.cloneDeep(valueToStore);
                        let rowdata = Object.assign({}, row);
                        //medicine
                        let obj = {
                            "dataElement": fieldDetails[0].dataElement.id,
                            "value": rowdata['medicine']['code']
                        }
                        objvalueToStore.push(Object.assign({}, obj))
                        objvalueToStore.push({ "dataElement": treatmentAdherenceId, "value": treatmentAdherenceVal })
                        objvalueToStore.push({ "dataElement": treatmentRegimenId, "value": rowdata[treatmentRegimenId] })
                        objvalueToStore.push({ "dataElement": treatmentStartDateId, "value": moment(rowdata[treatmentStartDateId]).format("YYYY-MM-DD") })
                        objvalueToStore.push({ "dataElement": treatmentEndDateId, "value": moment(rowdata[treatmentEndDateId]).format("YYYY-MM-DD") })
                        objvalueToStore.push({ "dataElement": treatmentDoseId, "value": rowdata[treatmentDoseId] })

                        CreateStageEventInput['dataValues'] = _.uniqBy(objvalueToStore, 'dataElement');
                        referalAPIObject.events.push(Object.assign({}, CreateStageEventInput))
                    }
                    /*if(row[treatmentRegimenId] == Configuration.treatmentRegimens.option1){
                        let objvalueToStore = _.cloneDeep(valueToStore);
                        let rowdata = Object.assign({},row);
                        //medicine
                        let obj =  {
                                "dataElement":fixedDoseChildren.id,
                                "value":rowdata['medicine']['code']
                                }
                        objvalueToStore.push(Object.assign({},obj))
                        objvalueToStore.push({"dataElement":treatmentAdherenceId,"value":treatmentAdherenceVal})
                        objvalueToStore.push({"dataElement":treatmentRegimenId,"value":rowdata[treatmentRegimenId]})
                        objvalueToStore.push({"dataElement":treatmentStartDateId,"value":moment(rowdata[treatmentStartDateId]).format("YYYY-MM-DD")})
                        objvalueToStore.push({"dataElement":treatmentEndDateId,"value":moment(rowdata[treatmentEndDateId]).format("YYYY-MM-DD")})
                        objvalueToStore.push({"dataElement":treatmentDoseId,"value":rowdata[treatmentDoseId]})
                        
                        CreateStageEventInput['dataValues'] = _.uniqBy(objvalueToStore, 'dataElement');
                        referalAPIObject.events.push(Object.assign({},CreateStageEventInput))
                    }else if(row[treatmentRegimenId] == Configuration.treatmentRegimens.option2){
                        let objvalueToStore = _.cloneDeep(valueToStore);
                        let rowdata = Object.assign({},row);
                        let obj =  {
                                "dataElement":singleDoseChildren.id,
                                "value":rowdata['medicine']['code']
                                }
                        
                        objvalueToStore.push(Object.assign({},obj))
                        objvalueToStore.push({"dataElement":treatmentAdherenceId,"value":treatmentAdherenceVal})
                        objvalueToStore.push({"dataElement":treatmentRegimenId,"value":rowdata[treatmentRegimenId]})
                        objvalueToStore.push({"dataElement":treatmentStartDateId,"value":moment(rowdata[treatmentStartDateId]).format("YYYY-MM-DD")})
                        objvalueToStore.push({"dataElement":treatmentEndDateId,"value":moment(rowdata[treatmentEndDateId]).format("YYYY-MM-DD")})
                        objvalueToStore.push({"dataElement":treatmentDoseId,"value":rowdata[treatmentDoseId]})
                        
                        CreateStageEventInput['dataValues'] = _.uniqBy(objvalueToStore, 'dataElement');
                        referalAPIObject.events.push(Object.assign({},CreateStageEventInput))
                    }else if(row[treatmentRegimenId] == Configuration.treatmentRegimens.option3){
                        let objvalueToStore = _.cloneDeep(valueToStore);
                        let rowdata = Object.assign({},row);
                        let obj =  {
                                "dataElement":fixedDoseAdult.id,
                                "value":rowdata['medicine']['code']
                                }
                        
                        objvalueToStore.push(Object.assign({},obj))
                        objvalueToStore.push({"dataElement":treatmentAdherenceId,"value":treatmentAdherenceVal})
                        objvalueToStore.push({"dataElement":treatmentRegimenId,"value":rowdata[treatmentRegimenId]})
                        objvalueToStore.push({"dataElement":treatmentStartDateId,"value":moment(rowdata[treatmentStartDateId]).format("YYYY-MM-DD")})
                        objvalueToStore.push({"dataElement":treatmentEndDateId,"value":moment(rowdata[treatmentEndDateId]).format("YYYY-MM-DD")})
                        objvalueToStore.push({"dataElement":treatmentDoseId,"value":rowdata[treatmentDoseId]})
                        
                        CreateStageEventInput['dataValues'] = _.uniqBy(objvalueToStore, 'dataElement');
                        referalAPIObject.events.push(Object.assign({},CreateStageEventInput))
    
                    }else if(row[treatmentRegimenId] == Configuration.treatmentRegimens.option4){
                        let objvalueToStore = _.cloneDeep(valueToStore);
                        let rowdata = Object.assign({},row);
                        let obj =  {
                                "dataElement":singleDoseAdult.id,
                                "value":rowdata['medicine']['code']
                                }
                        objvalueToStore.push(Object.assign({},obj))
                        objvalueToStore.push({"dataElement":treatmentAdherenceId,"value":treatmentAdherenceVal})
                        objvalueToStore.push({"dataElement":treatmentRegimenId,"value":rowdata[treatmentRegimenId]})
                        objvalueToStore.push({"dataElement":treatmentStartDateId,"value":moment(rowdata[treatmentStartDateId]).format("YYYY-MM-DD")})
                        objvalueToStore.push({"dataElement":treatmentEndDateId,"value":moment(rowdata[treatmentEndDateId]).format("YYYY-MM-DD")})
                        objvalueToStore.push({"dataElement":treatmentDoseId,"value":rowdata[treatmentDoseId]})
                        
                        CreateStageEventInput['dataValues'] = _.uniqBy(objvalueToStore, 'dataElement');
                        referalAPIObject.events.push(Object.assign({},CreateStageEventInput))
                    }*/
                }
            })
        } else if (currentStage.id == adherenceStageId && medicineTable.length > 0) {
            if (fullCalendarEvents.length > 0) {
                let CreateStageEventInput =
                {
                    "program": programId,
                    "programStage": currentStage.id,
                    "orgUnit": orgUnit,
                    "trackedEntityInstance": activeCaseDetails.data.trackedEntityInstance,
                    "status": "COMPLETED",
                    "dueDate": moment().format("YYYY-MM-DD"),
                    "eventDate": moment().format("YYYY-MM-DD"),
                    "completedDate": moment().format("YYYY-MM-DD")
                }
                //console.log("fullCalendarEvents",fullCalendarEvents)
                fullCalendarEvents.map(event => {
                    if (!event.hasOwnProperty("editmode")) {
                        medicineTable.map(row => {
                            const regimenConfigObject = _.find(Configuration.treatmentRegimens, { 'code': row[treatmentRegimenId], 'phase': row[treatmentPhaseId] });
                            if (regimenConfigObject != undefined) {
                                //debugger
                                let fieldDetails = _.filter(currentStage.programStageDataElements, ['dataElement.displayName', regimenConfigObject.associatedFieldName])

                                let objvalueToStore = _.cloneDeep(valueToStore);
                                objvalueToStore = _.reject(objvalueToStore, { 'value': "" });
                                let rowdata = Object.assign({}, row);
                                //medicine
                                let obj = {
                                    "dataElement": fieldDetails[0].dataElement.id,
                                    "value": rowdata['medicine']['code']
                                }
                                objvalueToStore.map((ele, idx) => {
                                    switch (ele.dataElement) {
                                        case fieldDetails[0].dataElement.id:
                                            objvalueToStore.splice(idx, 1)
                                            break;
                                        case treatmentAdherenceId:
                                            objvalueToStore.splice(idx, 1)
                                            break;
                                        case medicineColorCodeId:
                                            objvalueToStore.splice(idx, 1)
                                            break;
                                        case medicineTakenId:
                                            objvalueToStore.splice(idx, 1)
                                            break;
                                    }

                                })
                                objvalueToStore.push(Object.assign({}, obj))

                                //radioValue

                                objvalueToStore.push(Object.assign({},
                                    {
                                        "dataElement": medicineTakenId,
                                        "value": (_.get(radioValue, rowdata['medicine']['code'])) ? _.get(radioValue, rowdata['medicine']['code']) : 'yes'
                                    }
                                ))
                                //push date medicine taken
                                objvalueToStore.push({ "dataElement": dateMedicineTakenId, "value": event.start })

                                //push color code
                                objvalueToStore.push(Object.assign({}, { "dataElement": medicineColorCodeId, "value": event.backgroundColor }))

                                //push adherenceid
                                objvalueToStore.push(Object.assign({}, { "dataElement": treatmentAdherenceId, "value": rowdata[treatmentAdherenceId] }))

                                CreateStageEventInput['dataValues'] = _.uniqBy(objvalueToStore, 'dataElement');
                                referalAPIObject.events.push(Object.assign({}, CreateStageEventInput))

                                /*let tempSaveStageInput = _.cloneDeep(saveStageInput);
                                tempSaveStageInput['dataValues'] = _.cloneDeep(objvalueToStore);
                                referalAPIObject.events.push(tempSaveStageInput)*/
                            }

                        })
                    }
                })
            }
        } else if (currentStage.id == specimenStageId && sputumTable.length > 0) {
            let CreateStageEventInput = {
                "program": programId,
                "programStage": currentStage.id,
                "orgUnit": orgUnit,
                "trackedEntityInstance": activeCaseDetails.data.trackedEntityInstance,
                "status": "COMPLETED",
                "dueDate": moment().format("YYYY-MM-DD"),
                "eventDate": moment().format("YYYY-MM-DD"),
                "completedDate": moment().format("YYYY-MM-DD")
            }

            sputumTable.map(row => {
                if (row['eventdetails']) {
                    UpdateStageInput = {
                        "dataValues": row['eventdetails']['dataValues'],
                        "event": row['eventdetails']['event'],
                        "program": programId,
                        "programStage": currentStage.id,
                        "orgUnit": orgUnit,
                        "trackedEntityInstance": activeCaseDetails.data.trackedEntityInstance,
                        "status": "COMPLETED",
                        "dueDate": moment().format("YYYY-MM-DD"),
                        "eventDate": moment().format("YYYY-MM-DD"),
                        "completedDate": moment().format("YYYY-MM-DD")
                    }
                    referalAPIObject.events.push(UpdateStageInput)
                } else {

                    let objvalueToStore = _.cloneDeep(valueToStore);
                    for (const key in row) {
                        if (Object.hasOwnProperty.call(row, key)) {
                            const val = row[key];
                            let obj = {
                                "dataElement": key,
                                "value": val || null
                            }
                            objvalueToStore.push(Object.assign({}, obj))
                        }
                    }
                    let tempCSEI = _.cloneDeep(CreateStageEventInput)
                    tempCSEI['dataValues'] = _.uniqBy(objvalueToStore, 'dataElement');
                    referalAPIObject.events.push(tempCSEI)


                }
            })

        } else {
            const getAllKeys = Object.keys(valueForFormInput)

            let OUFieldSelectedLocation = ''

            const filterReferalField =
                getAllKeys.map(keys => {
                    const filter = currentStage.programStageDataElements.filter(obj => obj.dataElement.id == keys)
                    if (filter.length > 0) {
                        filter.map(filteredField => {
                            if (filteredField.dataElement.fieldMask == 'Facility Referral') {
                                const filteredKey = filteredField.dataElement.id
                                const selectedOUField = currentStage.programStageDataElements.filter(obj => obj.dataElement.fieldMask == 'Facility Referral OU')

                                let selectedOUFieldData = selectedOUField.length > 0 ? valueForFormInput[selectedOUField[0].dataElement.id] : ''
                                OUFieldSelectedLocation = selectedOUFieldData

                                if (!selectedOUFieldData) {
                                    selectedOUField.map(ouField => {
                                        if (valueForFormInput[ouField.dataElement.id]) {
                                            selectedOUFieldData = valueForFormInput[ouField.dataElement.id]
                                        }
                                    })
                                }
                                const referalFieldValue = valueForFormInput[filteredKey]

                                referalFieldValue.map(stageId => {
                                    const obj = {
                                        "trackedEntityInstance": activeCaseDetails.data.trackedEntityInstance,
                                        "program": programId,
                                        "programStage": stageId,
                                        "enrollment": navigator.onLine ? trackentityInstanceDetails.enrollments[0].enrollment : "",
                                        "orgUnit": selectedOUFieldData,
                                        "notes": [],
                                        "dataValues": [],
                                        "status": "SCHEDULE",
                                        "dueDate": moment().format("YYYY-MM-DD")
                                    }
                                    if (categoryOptions && categoryOptions.categoryOptions && categoryOptions.categoryOptions[0] && categoryOptions.categoryOptions[0].id) {
                                        obj["attributeCategoryOptions"] = categoryOptions.categoryOptions[0].id
                                    }
                                    if (selectedOUFieldData) {
                                        referalAPIObject.events.push(obj)
                                    }

                                })
                            } else if (filteredField.dataElement.fieldMask == 'Transfer In' || filteredField.dataElement.fieldMask == 'Transfer Out') {
                                const stageId = currentStage.id
                                const selectedOUField = filteredField.dataElement.id
                                const selectedOUFieldData = selectedOUField.length > 0 ? valueForFormInput[selectedOUField] : ''
                                OUFieldSelectedLocation = selectedOUFieldData

                                let eventStatus = "COMPLETED";
                                if (filteredField.dataElement.fieldMask == 'Transfer Out') {
                                    eventStatus = "SCHEDULE";
                                }
                                UpdateStageInput =
                                {
                                    "dataValues": valueToStore,
                                    "event": eventId,
                                    "program": programId,
                                    "programStage": currentStage.id,
                                    "orgUnit": selectedOUFieldData,
                                    "trackedEntityInstance": activeCaseDetails.data.trackedEntityInstance,
                                    "status": eventStatus,
                                    "dueDate": moment().format("YYYY-MM-DD"),
                                    "eventDate": moment().format("YYYY-MM-DD"),
                                    "completedDate": moment().format("YYYY-MM-DD")
                                }
                                console.log("filteredField.dataElement.fieldMask", filteredField.dataElement)
                            }
                        })
                    }
                })
            referalAPIObject.events.push(UpdateStageInput)
        }
        //console.log("valueToStore[facilityofEnrollment]",valueForFormInput[facilityofEnrollment],valueToStore[facilityofEnrollment], valueToStore, valueToStore[facilityofEnrollment])
        if (currentStage.name.trim().toLocaleLowerCase() == "art enrollment" && valueForFormInput[patientenrolledincare] == "Yes") {
            try {
                referalAPIObject.events = []
                const orgID = valueForFormInput[facilityofEnrollment]

                // const orgID = localStorage.getItem("artEnrollmentFacilities") ?  _.find(JSON.parse(localStorage.getItem("artEnrollmentFacilities")),{label : valueForFormInput[facilityofEnrollment]}) : ''
                console.log("orgID", orgID, localStorage.getItem("artEnrollmentFacilities"))
                const obj = {
                    "dataValues": valueToStore,
                    "event": eventId,
                    "program": programId,
                    "programStage": currentStage.id,
                    "orgUnit": orgUnit,
                    "trackedEntityInstance": activeCaseDetails.data.trackedEntityInstance,
                    "status": "COMPLETED",
                    "dueDate": moment().format("YYYY-MM-DD"),
                    "eventDate": moment().format("YYYY-MM-DD"),
                    "completedDate": moment().format("YYYY-MM-DD")
                }
                if (categoryOptions && categoryOptions.categoryOptions && categoryOptions.categoryOptions[0] && categoryOptions.categoryOptions[0].id) {
                    obj["attributeCategoryOptions"] = categoryOptions.categoryOptions[0].id
                }
                if (orgID) {
                    const refferobj = {
                        "trackedEntityInstance": activeCaseDetails.data.trackedEntityInstance,
                        "program": programId,
                        "programStage": artInitiationStage ? artInitiationStage : "s62gtsI2DAB",
                        "enrollment": navigator.onLine ? trackentityInstanceDetails.enrollments[0].enrollment : "",
                        "orgUnit": orgID,
                        "notes": [],
                        "dataValues": [],
                        "status": "SCHEDULE",
                        "dueDate": moment().format("YYYY-MM-DD")
                    }
                    if (categoryOptions && categoryOptions.categoryOptions && categoryOptions.categoryOptions[0] && categoryOptions.categoryOptions[0].id) {
                        refferobj["attributeCategoryOptions"] = categoryOptions.categoryOptions[0].id
                    }
                    referalAPIObject.events.push(refferobj)
                }
                referalAPIObject.events.push(obj)
            } catch (e) {
                console.log(e)
            }
        }
        console.log("referalAPIObject", referalAPIObject)

        //  const getAllKeys = Object.keys(valueForFormInput)
        //     let OUFieldSelectedLocation = ''

        //     getAllKeys.map(keys => {
        //     const filter = currentStage.programStageDataElements.filter(obj => obj.dataElement.id == keys)
        //     if (filter.length > 0) {
        //         filter.map(filteredField => {
        //             if (filteredField.dataElement.displayFormName == 'ART 1 - Patient enrolled in care'){
        //                 const filteredKey = filteredField.dataElement.id
        //                 const FacilityofEnrollment = ''
        //                 const DateofEnrollment = ''
        //                 const selectedOUField = filteredField.dataElement.id
        //                 const selectedOUFieldData = selectedOUField.length > 0 ? valueForFormInput[selectedOUField] : ''
        //                 OUFieldSelectedLocation = selectedOUFieldData
        //                 if(valueForFormInput[filteredKey]== "Yes"){
        //                     if(filteredField.dataElement.displayFormName == "ART 4 - Facility of Enrollment"){
        //                         FacilityofEnrollment = filteredField.dataElement.id
        //                     }
        //                     if(filteredField.dataElement.displayFormName == "ART 2 - Date of Enrollment"){
        //                         DateofEnrollment = filteredField.dataElement.id
        //                     }
        //                     console.log("valueToStore[FacilityofEnrollment]",valueToStore, FacilityofEnrollment,filteredField)
        //                     const valueFacilityofEnrollment = valueToStore[FacilityofEnrollment]
        //                     const orgID = _.find(localStorage.getItem("artEnrollmentFacilities"),{label : valueFacilityofEnrollment})
        //                     console.log("orgID",orgID,valueFacilityofEnrollment)
        //                     //s62gtsI2DAB
        //                     const obj = {
        //                         "dataValues": valueToStore,
        //                         "event": eventId,
        //                         "program": programId,
        //                         "programStage": currentStage.id,
        //                         "orgUnit": orgUnit,
        //                         "trackedEntityInstance": activeCaseDetails.data.trackedEntityInstance,
        //                         "status": "COMPLETED",
        //                         "dueDate": moment().format("YYYY-MM-DD"),
        //                         "eventDate": moment().format("YYYY-MM-DD"),
        //                         "completedDate": moment().format("YYYY-MM-DD")
        //                     }
        //                         const refferobj = {
        //                             "trackedEntityInstance": activeCaseDetails.data.trackedEntityInstance,
        //                             "program": programId,
        //                             "programStage": "s62gtsI2DAB",
        //                             "enrollment": navigator.onLine ? trackentityInstanceDetails.enrollments[0].enrollment : "",
        //                             "orgUnit": valueFacilityofEnrollment,
        //                             "notes": [],
        //                             "dataValues": [],
        //                             "status": "SCHEDULE",
        //                             "dueDate": moment().format("YYYY-MM-DD")
        //                         }
        //                     referalAPIObject.events.push(obj)
        //                     referalAPIObject.events.push(refferobj)
        //                 }
        //                 console.log("referalAPIObject",referalAPIObject)
        //             }
        //         }
        //     )
        // }
        // })
        // return 
        // currentStage.programStageDataElements.filter(obj={
        //     if(obj.dataElement.displayFormName == "ART 1 - Patient enrolled in care"){

        //     }
        // })

        // setGlobalSpinner(false)
        //return

        if (navigator.onLine) {
            setGlobalSpinner(true)
            apiServices.postAPI(updateURL, referalAPIObject)
                .then(stageResponse => {
                    if (props.stageTabValue && props.stageTabValue != 0 && props.stageInstanceID) {
                        swal({
                            title: t("Success"),
                            text: t("Successfully submitted event"),
                            icon: "success",
                            button: t("Close"),
                        });
                        history.push('/layout/home');
                        setGlobalSpinner(false)
                    } else {
                        let redirectedHome = false;
                        const getURL = 'trackedEntityInstances/' + activeCaseDetails.data.trackedEntityInstance + '.json?program=' + programId + '&fields=*?'
                        setGlobalSpinner(true)
                        apiServices.getAPI(getURL)
                            .then(res => {
                                setGlobalSpinner(false)
                                setTrackentityInstanceDetails(res.data)
                                if (!workFlow) {
                                    OfflineDb.setDataIntoPouchDB('newSeviceStart', false)
                                    setServiceStartFlag(false)
                                }


                                const linkContact = {
                                    "enabled": false,
                                    "linkTrackedEntityInstance": activeCaseDetails.data.trackedEntityInstance
                                }
                                const activeCaseFormData = {
                                    'formFormat': valueForFormInput, //valueForFormInput,
                                    'dhisFormat': null //
                                }

                                OfflineDb.setDataIntoPouchDB('activeCaseFormData', activeCaseFormData)
                                OfflineDb.setDataIntoPouchDB('linkContactFlag', linkContact)
                                if (currentStage.name.trim().toLocaleLowerCase() == "tb testing form") {
                                    let testResultTBObj = currentStage.programStageDataElements.filter(obj => obj.dataElement.displayName.trim() == "Test result (TB)")
                                    let testResultTBId = (testResultTBObj.length > 0) ? testResultTBObj[0].dataElement.id : null;
                                    if (valueForFormInput[clientTypeID] == Configuration.ltbiLinkVariables.presumptivetb && valueForFormInput[testResultTBId].trim().toUpperCase() == "POSITIVE") {
                                        updateRegDataToIndex();
                                    }
                                }
                                if (currentStage.name.trim().toLocaleLowerCase() == "transfer out") {
                                    redirectedHome = true;
                                }

                                //debugger;
                                //next tabs
                                if (currentStage.name.trim().toLocaleLowerCase() == "commodities" || currentStage.name.trim().toLocaleLowerCase() == "art enrollment" || currentStage.name.trim().toLocaleLowerCase() == "orw component" || currentStage.name.trim().toLocaleLowerCase() == "htc" || currentStage.name.trim().toLocaleLowerCase() == "art initiation") {
                                    redirectedHome = true;
                                }

                                if (currentStage.name.trim().toLocaleLowerCase() == "htc") {
                                    let determineTest = "HhQNLlyPilm", uniGold = "IfgPLHu0Pf3", statpak = "EmKOoPr5JGU";
                                    /*if(valueForFormInput[determineTest] && valueForFormInput[uniGold] && valueForFormInput[statpak] && valueForFormInput[determineTest] == 'Determine Reactive Result' && ((valueForFormInput[uniGold] == 'Uni-gold Non-reactive' && valueForFormInput[statpak] == 'Stat-pak reactive') || (valueForFormInput[uniGold] == 'Uni-gold Reactive' && valueForFormInput[statpak] == 'Stat-pak Non reactive') || (valueForFormInput[uniGold] == 'Uni-gold Invalid' && valueForFormInput[statpak] == 'Stat-pak reactive') || (valueForFormInput[uniGold] == 'Uni-gold Reactive' && valueForFormInput[statpak] == 'Stat-pak Invalid'))){
                                        redirectedHome = true;
                                    }*/
                                    /*if(valueForFormInput[determineTest] && valueForFormInput[uniGold] && valueForFormInput[statpak] && valueForFormInput[determineTest] == 'Determine Reactive Result' && valueForFormInput[uniGold] == 'Uni-gold Reactive' && valueForFormInput[statpak] == 'Stat-pak reactive'){
                                        redirectedHome = false;
                                    }else{
                                        redirectedHome = true;
                                    }*/
                                }
                                const nextTab = fetchActiveTab[fetchActiveTab.indexOf(currentStage.id) + 1]
                                console.log("next tab", redirectedHome, nextTab);
                                if (nextTab && !redirectedHome) {
                                    /*swal({
                                        title: t("Updated"),
                                        text: t("Successfully updated event"),
                                        icon: "success",
                                        button: t("Close"),
                                    });*/
                                    const indexOfNextTab = programData.programs[0].programStages.findIndex(obj => obj.id == nextTab)
                                    setValue(indexOfNextTab + stepIncrement)
                                } else {
                                    setValue(value);
                                    swal({
                                        title: t("Updated"),
                                        text: t("Successfully updated event"),
                                        icon: "success",
                                        button: t("Close"),
                                    });
                                    history.push('/layout/home');
                                }
                            }).catch(err => {
                                setGlobalSpinner(false)
                                swal({
                                    title: t("Error"),
                                    text: t("Sorry something went wrong"),
                                    icon: "error",
                                    button: t("Close"),
                                });
                            })
                        setGlobalSpinner(false)
                    }
                }).catch(err => {
                    setGlobalSpinner(false)
                    // swal({
                    //     title: t("Error"),
                    //     text: t("Sorry, something went wrong"),
                    //     icon: "error",
                    //     button: t("Close"),
                    // });
                    loadErrorPopup(err)
                })
        } else {
            updateOfflineServiceData(valueForFormInput, valueToStore, currentStage, referalAPIObject, fetchActiveTab)
        }
    }
    function updateOfflineServiceData(valueForFormInput, valueToStore, currentStage, referalAPIObject, fetchActiveTab) {
        setGlobalSpinner(false)
        OfflineDb.getSingleEntity(activeCaseDetails.data.trackedEntityInstance).then(res => {
            const tempdata = { ...res }
            tempdata.formVersion = programData.programs[0].version
            tempdata.data = { ...tempdata.data, ...valueForFormInput };
            //debugger
            if (tempdata.services && tempdata.services.length > 0) {

                //console.log(_.find(tempdata.services, { events: [{ programStage:currentStage.id }] }))
                let servicedetails = _.find(tempdata.services, { events: [{ programStage: currentStage.id }] });
                if (servicedetails != undefined) {
                    servicedetails.events[0].dataValues = valueToStore
                } else {
                    tempdata.services.push(referalAPIObject)
                }
                /*tempdata.services.map((service,idx)=>{
                    let servicedetails = _.filter(service.events, ['programStage',currentStage.id])
                    //console.log(servicedetails)
                    if(servicedetails.length > 0){
                        tempdata.services[idx].events[0].dataValues = valueToStore
                    }else{
                        tempdata.services.push(referalAPIObject)
                    }
                })*/
            } else {
                tempdata.services.push(referalAPIObject)
            }
            let redirectedHome = false;
            OfflineDb.updateFullEntity(tempdata).then(response => {
                const linkContact = {
                    "enabled": false,
                    "linkTrackedEntityInstance": activeCaseDetails.data.trackedEntityInstance
                }
                const activeStageCaseFormData = {
                    'formFormat': valueForFormInput,
                    'dhisFormat': null
                }

                setActiveCaseFormData({
                    "data": {
                        'formFormat': valueForFormInput,
                        'dhisFormat': null
                    }
                })

                //OfflineDb.setDataIntoPouchDB('activeCaseFormData', activeStageCaseFormData)
                //OfflineDb.setDataIntoPouchDB('linkContactFlag', linkContact)
                if (currentStage.name.trim().toLocaleLowerCase() == "commodities" || currentStage.name.trim().toLocaleLowerCase() == "art enrollment" || currentStage.name.trim().toLocaleLowerCase() == "orw component" || currentStage.name.trim().toLocaleLowerCase() == "htc" || currentStage.name.trim().toLocaleLowerCase() == "art initiation") {
                    redirectedHome = true;
                }
                //next tab
                const nextTab = fetchActiveTab[fetchActiveTab.indexOf(currentStage.id) + stepIncrement]
                if (nextTab && !redirectedHome) {
                    swal({
                        title: t("Success"),
                        text: t("Successfully submitted event offline"),
                        icon: "success",
                        button: t("Close"),
                    });
                    const indexOfNextTab = programData.programs[0].programStages.findIndex(obj => obj.id == nextTab)
                    setValue(indexOfNextTab + stepIncrement)
                } else {
                    setValue(value)
                    swal({
                        title: t("Success"),
                        text: t("Successfully submitted event offline"),
                        icon: "success",
                        button: t("Close"),
                    });
                    history.push('/layout/home');
                }
            })
        })
    }

    function getMultiserviceArray() {
        //programRules activeCaseFormData
        let programStages = programData.programs[0].programStages
        let stageSequenceArr = [];
        if (programRules != null) {
            programRules.map(rules => {
                const filteredRule = rules.programRuleActions.filter(obj => obj.programRuleActionType == "DISPLAYKEYVALUEPAIR")
                if (filteredRule.length > 0) {
                    //const operators = ['==', '!=']
                    const condition = rules.condition
                    const splitConditions = condition.split("&&")

                    splitConditions.map(splitCondition => {
                        let StageDetails = {};
                        StageDetails['name'] = splitCondition.split('V{program_stage_name} == ')[1].replace(/\'/g, "").trim();
                        let stageObj = programStages.filter(obj => obj.displayName.toLocaleLowerCase() == StageDetails['name'].toLocaleLowerCase());
                        StageDetails['id'] = stageObj.length > 0 ? stageObj[0].id : undefined;
                        stageSequenceArr.push(StageDetails);
                    })
                }

            })
        }

        if (trackentityInstanceDetails.enrollments) {
            if (trackentityInstanceDetails.enrollments[0].events.length >= stageSequenceArr.length) {
                return true;
            }
        }
        return false;
    }

    function gotoNewService() {
        let registrationFormData = {}
        programData.programs[0].programTrackedEntityAttributes.map(attribute => {
            if (activeCaseFormData.data.formFormat.hasOwnProperty(attribute.trackedEntityAttribute.id)) {
                registrationFormData[attribute.trackedEntityAttribute.id] = activeCaseFormData.data.formFormat[attribute.trackedEntityAttribute.id]
            }
        })
        const activeCaseFormData = {
            'formFormat': registrationFormData, //valueForFormInput,
            'dhisFormat': null //
        }

        OfflineDb.setDataIntoPouchDB('newSeviceStart', true)
        setServiceStartFlag(true)

        OfflineDb.setDataIntoPouchDB('activeCaseFormData', activeCaseFormData)
        if (location?.state?.stageId != "individualrecord") {
            setValue(1);
        }
    }
    const handleDateClick = (arg) => { // bind with an arrow function

        //arg.jsEvent.target.classList.add("bg-green");
    }
    const handleEventClick = (arg) => { // bind with an arrow function


    }
    const handleDateSelect = (selectInfo) => {
        //let title = prompt("Please enter a new title for your event");
        //let calendarApi = selectInfo.view.calendar;


        //selectInfo.jsEvent.target.classList.add("bg-green");

        // set selected date in state variable
        setFullCalenderSelectedDate(selectInfo.startStr)
        //getMedicinesListFromEvents()
        //calendarApi.unselect() // clear date selection

        /*if (title) {
          calendarApi.addEvent({
            id: 1,
            title,
            start: selectInfo.startStr,
            end: selectInfo.endStr,
            allDay: selectInfo.allDay
          });
        }*/
    }
    function checkIsMedicineTakenOnSelectedDate(dateSelected) {
        if (trackentityInstanceDetails.enrollments[0].events.length > 0) {
            let sortedEvents = _.filter(trackentityInstanceDetails.enrollments[0].events, { 'programStage': adherenceStageId });
            if (sortedEvents.length > 0) {
                let finalEvents = _.filter(sortedEvents, { dataValues: [{ dataElement: dateMedicineTakenId, value: dateSelected }] });
                return (finalEvents.length > 0) ? true : false
            }
        } else {
            return false;
        }
    }

    const getSputumTableDetail = () => {
        let sortedEvents = _.filter(trackentityInstanceDetails.enrollments[0].events, { 'programStage': specimenStageId });
        if (sortedEvents.length > 0) {
            // console.log('sortedEvents>>>', sortedEvents)

            let arrTemp = [];
            sortedEvents.map(event => {
                let sputumTableObj = {}
                sputumTableObj['eventdetails'] = Object.assign({}, event);
                event.dataValues.map(dv => {
                    if (dv.dataElement == dateOfSampleCollection) {
                        sputumTableObj[dateOfSampleCollection] = moment(dv.value).format('MM/DD/YYYY');
                    } else if (dv.dataElement == specimenid) {
                        sputumTableObj[specimenid] = dv.value
                    } else if (dv.dataElement == specimenType) {
                        sputumTableObj[specimenType] = dv.value
                    } else if (dv.dataElement == noOfSputumCollected) {
                        sputumTableObj[noOfSputumCollected] = dv.value
                    } else if (dv.dataElement == sputumQRCode) {
                        sputumTableObj[sputumQRCode] = dv.value
                    }
                })
                sputumTableObj['action'] = 'edit';
                arrTemp.push(sputumTableObj)
            })
            setsputumTable(arrTemp)
        }
    }

    function getMedicinesListFromEvents(currentStage) {
        //debugger
        let sortedEvents = _.filter(trackentityInstanceDetails.enrollments[0].events, { 'programStage': regimenStageId });
        if (sortedEvents.length > 0) {
            //get treatment adherence value
            let objTreatmentAdherence = _.find(sortedEvents[sortedEvents.length - 1].dataValues, { 'dataElement': treatmentAdherenceId });

            let treatmentAdherenceValue = (objTreatmentAdherence != undefined) ? objTreatmentAdherence.value : "";
            //filter events by treatmentAdherenceId 
            let finalEvents = _.filter(sortedEvents, { dataValues: [{ dataElement: treatmentAdherenceId, value: treatmentAdherenceValue }] });


            //return;
            if (finalEvents.length > 0) {
                setMedicineTable([])
                let arrTemp = [];
                finalEvents.map(eventObj => {
                    /*let objRegimen =  _.find(eventObj.dataValues, { 'dataElement':  treatmentRegimenId});
                    let medicineid = null;
                    if(objRegimen.value == "Regimen 1 - Child (Fixed)"){
                        medicineid = fixedDoseChildren.id;
                    }else if(objRegimen.value == "Regimen 1 - Child (Single dose)"){
                        medicineid = singleDoseChildren.id;
                    }else if(objRegimen.value == "Regimen 1 - Adult (Fixed dose)"){
                        medicineid = fixedDoseAdult.id;
                    }else if(objRegimen.value == "Regimen 1 - Adult (Single dose)"){
                        medicineid = singleDoseAdult.id;
                    }
                    
                    setMedicineRadioId(medicineid)
                    let objMedicine =  _.find(eventObj.dataValues, { 'dataElement':  medicineid});
                    let finalObj = {};
                    if(objMedicine) {
                        if(objMedicine.value){
                            finalObj[medicineid] = objMedicine.value;
                        }
                    }
                    
                    
                    let objTreatmentAdherence =  _.find(eventObj.dataValues, { 'dataElement':  treatmentAdherenceId});
                    finalObj[treatmentAdherenceId] = objTreatmentAdherence ? objTreatmentAdherence.value : {};
                    arrTemp.push(finalObj)  */


                    let regmineTableObj = {}; //arrTemp=[];
                    //arrTemp=_.cloneDeep(medicineTable)
                    regmineTableObj['eventdetails'] = Object.assign({}, eventObj);
                    let objRegimen = _.find(eventObj.dataValues, { 'dataElement': treatmentRegimenId });
                    regmineTableObj[treatmentRegimenId] = objRegimen.value

                    let objPhase = _.find(eventObj.dataValues, { 'dataElement': treatmentPhaseId });
                    regmineTableObj[treatmentPhaseId] = objPhase.value
                    eventObj.dataValues.map(DE => {
                        /*if(DE.dataElement == treatmentRegimenId){
                            regmineTableObj[treatmentRegimenId] = DE.value
                        }else*/
                        if (DE.dataElement == treatmentStartDateId) {
                            regmineTableObj[treatmentStartDateId] = moment(DE.value).format('MM/DD/YYYY');
                        } else if (DE.dataElement == treatmentEndDateId) {
                            regmineTableObj[treatmentEndDateId] = moment(DE.value).format('MM/DD/YYYY');
                        } else if (DE.dataElement == treatmentDoseId) {
                            regmineTableObj[treatmentDoseId] = DE.value
                        } else if (DE.dataElement == treatmentAdherenceId) {
                            regmineTableObj[treatmentAdherenceId] = DE.value
                        }
                    })

                    const regimenConfigObject = _.find(Configuration.treatmentRegimens, { 'code': regmineTableObj[treatmentRegimenId], 'phase': regmineTableObj[treatmentPhaseId] });
                    if (regimenConfigObject != undefined) {
                        let fieldDetails = _.filter(currentStage.programStageDataElements, ['dataElement.displayName', regimenConfigObject.associatedFieldName])
                        let objMedicineName = _.find(eventObj.dataValues, { 'dataElement': fieldDetails[0].dataElement.id });
                        fieldDetails[0].dataElement.optionSet.options.map(ele => {
                            if (objMedicineName.value == ele.code) {
                                let obj = Object.assign({}, regmineTableObj)
                                obj['medicine'] = Object.assign({}, ele);
                                arrTemp.push(obj)

                                //setMedicineTable(arrTemp)
                            }

                        })
                    }
                    /*if(regmineTableObj[treatmentRegimenId] == Configuration.treatmentRegimens.option1){
                        let objMedicineName =  _.find(eventObj.dataValues, { 'dataElement':  fixedDoseChildren.id});
                        fixedDoseChildren.optionSet.options.map(ele=>{
                            if(objMedicineName.value == ele.code){
                                let obj = Object.assign({},regmineTableObj)
                                obj['medicine'] = Object.assign({},ele);
                                arrTemp.push(obj)
                                
                                //setMedicineTable(arrTemp)
                            }
                            
                        })
                    }else if(regmineTableObj[treatmentRegimenId] == Configuration.treatmentRegimens.option2){
                        let objMedicineName =  _.find(eventObj.dataValues, { 'dataElement':  singleDoseChildren.id});
                        singleDoseChildren.optionSet.options.map(ele=>{
                            if(objMedicineName.value == ele.code){
                                let obj = Object.assign({},regmineTableObj)
                                obj['medicine'] = Object.assign({},ele);
                                arrTemp.push(obj)
                            }
                        })
                    }else if(regmineTableObj[treatmentRegimenId] == Configuration.treatmentRegimens.option3){
                        let objMedicineName =  _.find(eventObj.dataValues, { 'dataElement':  fixedDoseAdult.id});
                        fixedDoseAdult.optionSet.options.map(ele=>{
                            if(objMedicineName.value == ele.code){
                                let obj = Object.assign({},regmineTableObj)
                                obj['medicine'] = Object.assign({},ele);
                                arrTemp.push(obj)
                            }
                        })
                    }else if(regmineTableObj[treatmentRegimenId] == Configuration.treatmentRegimens.option4){
                        let objMedicineName =  _.find(eventObj.dataValues, { 'dataElement':  singleDoseAdult.id});
                        singleDoseAdult.optionSet.options.map(ele=>{
                            if(objMedicineName.value == ele.code){
                                let obj = Object.assign({},regmineTableObj)
                                obj['medicine'] = Object.assign({},ele);
                                arrTemp.push(obj)
                            }
                        })
                    }*/

                })



                setMedicineTable(_.sortBy(arrTemp, treatmentRegimenId))
                /*setMedicineListForCalender(arrTemp)
                */
            }
        }
    }
    function renderFullCalender(stageDataElements) {

        //trackentityInstanceDetails.enrollments[0].events;
        /*let sortedEvents = _.filter(trackentityInstanceDetails.enrollments[0].events, { 'programStage':  regimenStageId});
        
        if(sortedEvents.length > 0){
            let arrTemp = [];
            sortedEvents.map(eventObj=>{
                let objRegimen =  _.find(eventObj.dataValues, { 'dataElement':  treatmentRegimenId});
                let medicineid = null;
                if(objRegimen.value == "Regimen 1 - Child (Fixed)"){
                    medicineid = fixedDoseChildren.id;
                }else if(objRegimen.value == "Regimen 1 - Child (Single dose)"){
                    medicineid = singleDoseChildren.id;
                }else if(objRegimen.value == "Regimen 1 - Adult (Fixed dose)"){
                    medicineid = fixedDoseAdult.id;
                }else if(objRegimen.value == "Regimen 1 - Adult (Single dose)"){
                    medicineid = singleDoseAdult.id;
                }
    
                let objMedicine =  _.find(eventObj.dataValues, { 'dataElement':  medicineid});
                let finalObj = {};
                finalObj[medicineid] = objMedicine.value;
    
                let objTreatmentAdherence =  _.find(eventObj.dataValues, { 'dataElement':  treatmentAdherenceId});
                finalObj[treatmentAdherenceId] = objTreatmentAdherence.value;
                arrTemp.push(finalObj)  
            })
            //setMedicineListForCalender(arrTemp)
            
        }*/
        //setIsFullCalenderPresentInStage(true)
        /*stageDataElements.map(field=>{
            if(field.dataElement.displayName.trim().toLocaleLowerCase() == "date medicine taken"){
                setDateMedicineTakenId(field.dataElement.id)
            }else if(field.dataElement.displayName.trim().toLocaleLowerCase() == "medicine taken"){
                setMedicineTakenId(field.dataElement.id)
            } 
        })*/
        return (
            <FullCalendar
                plugins={[dayGridPlugin, interactionPlugin]}
                initialView="dayGridMonth"
                weekends={true}
                //dateClick={handleDateClick}
                selectable={true}
                unselectAuto={false}
                select={handleDateSelect}
                longPressDelay={100}
                //eventClick={handleEventClick}
                //ref={calendarComponentRef}
                events={fullCalendarEvents}
            /*eventSources={
                [
                    {
                        //color: 'lightgreen',
                        events:fullCalendarEvents
                    }
                ]
            }*/
            />
        )
    }
    // function handleMedicineRadioChange(event,name){

    //     let bgColor = "#00bcd4";
    //     if(name == 'rhzRadio'){
    //         if(event.target.value == 'yes' && ethambutolRadio == 'yes'){
    //             bgColor = '#4caf50'
    //         }else if(event.target.value == 'yes' && ethambutolRadio == 'no'){
    //             bgColor = '#f58634'
    //         }else if(event.target.value == 'no' && ethambutolRadio == 'yes'){
    //             bgColor = '#f58634'
    //         }else if(event.target.value == 'no' && ethambutolRadio == 'no'){
    //             bgColor = '#ce1212'
    //         }
    //         setRhzRadio(event.target.value)
    //     }else if(name == 'ethambutolRadio'){
    //         if(rhzRadio == 'yes' && event.target.value == 'yes'){
    //             bgColor = '#4caf50'
    //         }else if(rhzRadio == 'yes' && event.target.value == 'no'){
    //             bgColor = '#f58634'
    //         }else if(rhzRadio == 'no' && event.target.value == 'yes'){
    //             bgColor = '#f58634'
    //         }else if(rhzRadio == 'no' && event.target.value == 'no'){
    //             bgColor = '#ce1212'
    //         }
    //         setEthambutolRadio(event.target.value)
    //     }
    //     let events = [...fullCalendarEvents];

    //     if(events.length > 0) {
    //        let findCurrentDateValue = events.find(obj => obj.start == fullCalenderSelectedDate)
    //        if(findCurrentDateValue) {
    //             findCurrentDateValue.backgroundColor = bgColor
    //        } else {
    //         events.push(
    //             {
    //                 start  : fullCalenderSelectedDate,
    //                 end    : fullCalenderSelectedDate,
    //                 allDay : true,
    //                 backgroundColor: bgColor,
    //                 display: 'background',
    //                 overlap: false
    //             }
    //         )
    //        }
    //     } else {
    //         events.push(
    //             {
    //                 start  : fullCalenderSelectedDate,
    //                 end    : fullCalenderSelectedDate,
    //                 allDay : true,
    //                 backgroundColor: bgColor,
    //                 display: 'background',
    //                 overlap: false
    //             }
    //         )
    //     }
    //     //  events[0] = {
    //     //     start  : fullCalenderSelectedDate,
    //     //     end    : fullCalenderSelectedDate,
    //     //     allDay : true,
    //     //     backgroundColor: bgColor,
    //     //     display: 'background',
    //     //     overlap: false
    //     // }
    //     setFullCalendarEvents(null)
    //     setTimeout(()=>{
    //         setFullCalendarEvents(events)
    //     },10)

    // }

    function handleMedicineRadioChange(event, value, name) {
        let bgColor = "#00bcd4";
        const noArray = []
        const yesArray = []
        const temp1 = radioValue
        temp1[name] = event.target.value
        setRadioValue(temp1)

        Object.keys(temp1).map(radio => {

            if (temp1[radio] == 'yes') {
                if (noArray.find(obj => obj.name == radio)) {
                    noArray = noArray.filter(obj => obj.name != radio)
                }
                yesArray.push({
                    'name': radio,
                    'value': 'yes'
                })
            } else {
                if (yesArray.find(obj => obj.name == radio)) {
                    yesArray = yesArray.filter(obj => obj.name != radio)
                }
                noArray.push({
                    'name': radio,
                    'value': 'no'
                })
            }
        })



        if (noArray.length > 0) {

            if (noArray.length == medicineTable.length) {
                bgColor = '#ce1212'
            } else {
                bgColor = '#f58634'
            }
        } else if (yesArray.length == medicineTable.length) {
            bgColor = '#4caf50'
        } else {
            bgColor = "#00bcd4";
        }




        let events = [...fullCalendarEvents];

        if (events.length > 0) {
            let findCurrentDateValue = events.find(obj => obj.start == fullCalenderSelectedDate)
            if (findCurrentDateValue) {
                findCurrentDateValue.backgroundColor = bgColor
            } else {
                events.push(
                    {
                        start: fullCalenderSelectedDate,
                        end: fullCalenderSelectedDate,
                        allDay: true,
                        backgroundColor: bgColor,
                        display: 'background',
                        overlap: false
                    }
                )
            }
        } else {
            events.push(
                {
                    start: fullCalenderSelectedDate,
                    end: fullCalenderSelectedDate,
                    allDay: true,
                    backgroundColor: bgColor,
                    display: 'background',
                    overlap: false
                }
            )
        }

        setFullCalendarEvents(null)
        setTimeout(() => {

            setFullCalendarEvents(events)
        }, 10)

    }
    function setRegimenStageDEIds(stage) {
        stage.programStageDataElements.map(DE => {
            if (DE.dataElement.displayName.trim().toLocaleLowerCase() == "treatment regimen") {
                setTreatmentRegimenId(DE.dataElement.id)
            } else if (DE.dataElement.displayName.trim().toLocaleLowerCase() == "treatment phase") {
                setTreatmentPhaseId(DE.dataElement.id)
            } else if (DE.dataElement.displayName.trim().toLocaleLowerCase() == "fixed dose (adult)") {
                setFixedDoseAdult(DE.dataElement)
            } else if (DE.dataElement.displayName.trim().toLocaleLowerCase() == "fixed dose (children)") {
                setFixedDoseChildren(DE.dataElement)
            } else if (DE.dataElement.displayName.trim().toLocaleLowerCase() == "single dose (adult)") {
                setSingleDoseAdult(DE.dataElement)
            } else if (DE.dataElement.displayName.trim().toLocaleLowerCase() == "single dose (children)") {
                setSingleDoseChildren(DE.dataElement)
            } else if (DE.dataElement.displayName.trim().toLocaleLowerCase() == "treatment start date") {
                setTreatmentStartDateId(DE.dataElement.id)
            } else if (DE.dataElement.displayName.trim().toLocaleLowerCase() == "treatment end date") {
                setTreatmentEndDateId(DE.dataElement.id)
            } else if (DE.dataElement.displayName.trim().toLocaleLowerCase() == "treatment dosage(mg)") {
                setTreatmentDoseId(DE.dataElement.id)
            } else if (DE.dataElement.displayName.trim().toLocaleLowerCase() == "treatment adherence id") {
                setTreatmentAdherenceId(DE.dataElement.id)
            }
        })
    }
    function addRegimen(stage, formvalues) {

        //formvalues[treatmentRegimenId] = "";
        let regmineTableObj = {}, arrTemp = [];
        arrTemp = _.cloneDeep(medicineTable)
        regmineTableObj[treatmentRegimenId] = formvalues[treatmentRegimenId]
        regmineTableObj[treatmentPhaseId] = formvalues[treatmentPhaseId]
        regmineTableObj[treatmentStartDateId] = moment(formvalues[treatmentStartDateId]).format('MM/DD/YYYY');
        regmineTableObj[treatmentEndDateId] = moment(formvalues[treatmentEndDateId]).format('MM/DD/YYYY');
        regmineTableObj[treatmentDoseId] = formvalues[treatmentDoseId]
        regmineTableObj[treatmentAdherenceId] = userData.username + '_' + Date.now();
        const regimenConfigObject = _.find(Configuration.treatmentRegimens, { 'code': formvalues[treatmentRegimenId], 'phase': formvalues[treatmentPhaseId] });

        if (regimenConfigObject != undefined) {

            let fieldDetails = _.filter(stage.programStageDataElements, ['dataElement.displayName', regimenConfigObject.associatedFieldName])
            fieldDetails[0].dataElement.optionSet.options.map(ele => {
                let obj = Object.assign({}, regmineTableObj)
                obj['medicine'] = ele;
                arrTemp.push(obj)
                setMedicineTable(arrTemp)
            })
        }
        /*if(formvalues[treatmentRegimenId] == Configuration.treatmentRegimens.option1){
            fixedDoseChildren.optionSet.options.map(ele=>{
                let obj = Object.assign({},regmineTableObj)
                obj['medicine'] = ele;
                arrTemp.push(obj)
                
                setMedicineTable(arrTemp)
            })
        }else if(formvalues[treatmentRegimenId] == Configuration.treatmentRegimens.option2){
            singleDoseChildren.optionSet.options.map(ele=>{
                let obj = Object.assign({},regmineTableObj)
                obj['medicine'] = ele;
                arrTemp.push(obj)
                setMedicineTable(arrTemp)
            })
        }else if(formvalues[treatmentRegimenId] == Configuration.treatmentRegimens.option3){
            fixedDoseAdult.optionSet.options.map(ele=>{
                let obj = Object.assign({},regmineTableObj)
                obj['medicine'] = ele;
                arrTemp.push(obj)
                setMedicineTable(arrTemp)
            })
        }else if(formvalues[treatmentRegimenId] == Configuration.treatmentRegimens.option4){
            singleDoseAdult.optionSet.options.map(ele=>{
                let obj = Object.assign({},regmineTableObj)
                obj['medicine'] = ele;
                arrTemp.push(obj)
                setMedicineTable(arrTemp)
            })
        }*/

    }

    const resetSpecimen = () => {
        if (activeCaseFormData && activeCaseFormData.data && activeCaseFormData.data.formFormat) {
            if (activeCaseFormData.data.formFormat[specimenType]) {
                activeCaseFormData.data.formFormat[dateOfSampleCollection] = moment().format();
                // delete activeCaseFormData.data.formFormat[specimenid];
                delete activeCaseFormData.data.formFormat[noOfSputumCollected];
                delete activeCaseFormData.data.formFormat[sputumQRCode];
                delete activeCaseFormData.data.formFormat[sampleCollectionAt];
                delete activeCaseFormData.data.formFormat[specimenType];
                let tempobj = _.cloneDeep(activeCaseFormData)
                setActiveCaseFormData(tempobj)
            }
        }
    }

    const addSpecimen = (stage, formvalues) => {
        // console.log("addSpecimen>>>", stage, formvalues);
        let sputumTableObj = {}, arrTemp = [];
        arrTemp = _.cloneDeep(sputumTable)
        // const [specimenType, setspecimenType] = useState(null);
        // const [dateOfSampleCollection, setdateOfSampleCollection] = useState(null);
        // const [specimenid, setspecimenid] = useState(null);
        // const [noOfSputumCollected, setnoOfSputumCollected] = useState(null);
        sputumTableObj[dateOfSampleCollection] = formvalues[dateOfSampleCollection];
        sputumTableObj[specimenid] = formvalues[specimenid]
        sputumTableObj[specimenType] = formvalues[specimenType]
        sputumTableObj[noOfSputumCollected] = formvalues[noOfSputumCollected]
        sputumTableObj[sputumQRCode] = formvalues[sputumQRCode]
        arrTemp.push(sputumTableObj)
        setsputumTable(arrTemp)

        formvalues[dateOfSampleCollection] = moment().format();
        delete formvalues[specimenid];
        delete formvalues[noOfSputumCollected];
        delete formvalues[sputumQRCode];
        delete formvalues[sampleCollectionAt];
        delete formvalues[specimenType];

        const activeCaseFormData = {
            data: {
                'formFormat': formvalues, //valueForFormInput,
                'dhisFormat': null //
            }
        }
        let tempobj = _.cloneDeep(activeCaseFormData)
        setActiveCaseFormData(tempobj)
    };

    const removeFromTable = (array, index) => {
        let temparr = _.cloneDeep(array)
        temparr.splice(temparr.indexOf(index), 1)
        setsputumTable(temparr)
    }

    function starttoNewService(currentStage) {
        const body = document.getElementById('innertabdivreg')
        body.scroll({
            top: 0,
            left: 0,
            behavior: 'smooth'
        });
        let currentStageDataToRemove = []
        let updatedFormData = {}
        let tempFormData = {}
        let htsSection = ["pGm3J84yrAb", "syiVItRrDgP", "u30iHcjgaz6", "OEJhAj3i1yX", "HBXuLtCgRHs", "ZHoqyBa59km", "svTN057036v", "t94TTOWs3QI", "ydFtqaCs0IV", "T2w3pT8DFeC", "fbbEnmGrs7a", "Du1mvHcJlA5", "rubrYJZ78Ds", "tgft2rEpVts", "Bm6GvfF7OOj"]
        programData.programs[0].programTrackedEntityAttributes.map(attribute => {
            if (activeCaseFormData.data.formFormat.hasOwnProperty(attribute.trackedEntityAttribute.id)) {
                updatedFormData[attribute.trackedEntityAttribute.id] = activeCaseFormData.data.formFormat[attribute.trackedEntityAttribute.id]
                tempFormData[attribute.trackedEntityAttribute.id] = activeCaseFormData.data.formFormat[attribute.trackedEntityAttribute.id]
            }
        })

        //console.log("activeCaseFormData",activeCaseFormData,updatedFormData)
        programData.programs[0].programStages.map((stages, index) => {
            /*if (stages.id != currentStage.id) {
                stages.programStageDataElements.map(attribute => {
                    if (activeCaseFormData.data.formFormat.hasOwnProperty(attribute.dataElement.id)) {
                        updatedFormData[attribute.dataElement.id] = activeCaseFormData.data.formFormat[attribute.dataElement.id]
                    }
    
                    dataElementGroup.map(dataElements => {
                        if (dataElements.displayName == attribute.dataElement.displayName) {
                            if (activeCaseFormData.data.formFormat.hasOwnProperty(dataElements.id)) {
                                updatedFormData[dataElements.id] = activeCaseFormData.data.formFormat[dataElements.id]
                            }
                        }
    
                    })
                })
    
    
            }*/
            stages.programStageDataElements.map(attribute => {
                if (activeCaseFormData.data.formFormat.hasOwnProperty(attribute.dataElement.id)) {
                    tempFormData[attribute.dataElement.id] = activeCaseFormData.data.formFormat[attribute.dataElement.id]
                    if (activeCaseFormData.data.formFormat.hasOwnProperty("tgft2rEpVts") && activeCaseFormData.data.formFormat["tgft2rEpVts"] == "Yes" && htsSection.includes(attribute.dataElement.id)) {
                        updatedFormData[attribute.dataElement.id] = activeCaseFormData.data.formFormat[attribute.dataElement.id]
                    }
                }
                // if(tempFormData[FirsttimeyoureceivePreventionservicesinyourlife]&&
                //     attribute.dataElement.attributeValues[0].attribute.displayName == "enableInIndividualRecord" 
                // ){
                if (activeCaseFormData.data.formFormat.hasOwnProperty(FirsttimeyoureceivePreventionservicesinyourlife) &&
                    (activeCaseFormData.data.formFormat[FirsttimeyoureceivePreventionservicesinyourlife] == "No" ||
                        activeCaseFormData.data.formFormat[FirsttimeyoureceivePreventionservicesinyourlife] == "Yes")
                ) {
                    // isDisabled = true;
                    setCustomIsDisable(true)
                    updatedFormData[FirsttimeyoureceivePreventionservicesinyourlife] = "No";

                }
                // }

                dataElementGroup.map(dataElements => {
                    if (dataElements.displayName == attribute.dataElement.displayName) {
                        if (activeCaseFormData.data.formFormat.hasOwnProperty(dataElements.id)) {
                            tempFormData[dataElements.id] = activeCaseFormData.data.formFormat[dataElements.id]
                            if (activeCaseFormData.data.formFormat.hasOwnProperty("tgft2rEpVts") && activeCaseFormData.data.formFormat["tgft2rEpVts"] == "Yes" && htsSection.includes(attribute.dataElement.id)) {
                                updatedFormData[attribute.dataElement.id] = activeCaseFormData.data.formFormat[attribute.dataElement.id]
                            }
                        }
                    }

                })
            })

        })
        //console.log("activeCaseFormData111 ",activeCaseFormData,updatedFormData,tempFormData)

        let tempobj = _.cloneDeep(updatedFormData)
        if (tempobj["tgft2rEpVts"] && tempobj["tgft2rEpVts"] == "Yes") {
            if (tempobj["tgft2rEpVts"] && tempobj["tgft2rEpVts"] == "Yes" && tempobj["Bm6GvfF7OOj"] && tempobj["Bm6GvfF7OOj"] == 'Yes') {
                tempobj["u30iHcjgaz6"] = 'Yes'
                tempFormData["u30iHcjgaz6"] = 'Yes'
                delete tempFormData["OEJhAj3i1yX"];
                delete tempFormData["ydFtqaCs0IV"];
                delete tempFormData["HBXuLtCgRHs"];
                delete tempFormData["ZHoqyBa59km"];
                delete tempFormData["t94TTOWs3QI"];
                delete tempFormData["T2w3pT8DFeC"];
                delete tempFormData["fbbEnmGrs7a"];
                delete tempFormData["Du1mvHcJlA5"];
                delete tempFormData["svTN057036v"];
                delete tempFormData["LUmtLdsG4Am"];
                delete tempobj["OEJhAj3i1yX"];
                delete tempobj["ydFtqaCs0IV"];
                delete tempobj["HBXuLtCgRHs"];
                delete tempobj["ZHoqyBa59km"];
                delete tempobj["t94TTOWs3QI"];
                delete tempobj["T2w3pT8DFeC"];
                delete tempobj["fbbEnmGrs7a"];
                delete tempobj["Du1mvHcJlA5"];
                delete tempobj["svTN057036v"];
                delete tempobj["LUmtLdsG4Am"];
            } else if (tempobj["tgft2rEpVts"] && tempobj["tgft2rEpVts"] == "Yes" && (!tempobj["Bm6GvfF7OOj"] || (tempobj["Bm6GvfF7OOj"] && tempobj["Bm6GvfF7OOj"] == 'No'))) {
                tempobj["u30iHcjgaz6"] = 'No'
                tempFormData["u30iHcjgaz6"] = 'No'
                delete tempFormData["OEJhAj3i1yX"];
                delete tempFormData["ydFtqaCs0IV"];
                delete tempFormData["HBXuLtCgRHs"];
                delete tempFormData["ZHoqyBa59km"];
                delete tempFormData["t94TTOWs3QI"];
                delete tempFormData["T2w3pT8DFeC"];
                delete tempFormData["fbbEnmGrs7a"];
                delete tempFormData["Du1mvHcJlA5"];
                delete tempFormData["LUmtLdsG4Am"];
                delete tempobj["OEJhAj3i1yX"];
                delete tempobj["ydFtqaCs0IV"];
                delete tempobj["HBXuLtCgRHs"];
                delete tempobj["ZHoqyBa59km"];
                delete tempobj["t94TTOWs3QI"];
                delete tempobj["T2w3pT8DFeC"];
                delete tempobj["fbbEnmGrs7a"];
                delete tempobj["Du1mvHcJlA5"];
                delete tempobj["LUmtLdsG4Am"];
            }
        }

        //console.log("tempobj",tempobj)
        const activeCaseFormData1 = {
            'formFormat': tempobj, //valueForFormInput,//updatedFormData
            'dhisFormat': null //
        }
        setActiveCaseFormData({
            'data': {
                'formFormat': tempobj, //valueForFormInput,//updatedFormData
                'dhisFormat': null //
            }
        })

        OfflineDb.setDataIntoPouchDB('newSeviceStart', true)
        setServiceStartFlag(true)

        OfflineDb.setDataIntoPouchDB('activeCaseFormData', activeCaseFormData1)

        const tempCaseFormData1 = {
            'formFormat': tempFormData, //valueForFormInput,
            'dhisFormat': null //
        }
        setTempActiveCaseFormData({
            'data': {
                'formFormat': tempFormData, //valueForFormInput,
                'dhisFormat': null //
            }
        })
        //console.log("activeCaseFormDatanew ",activeCaseFormData,updatedFormData,tempFormData)
        //console.log("createStageForms 0 ",newServiceStartFlag,activeCaseFormData,tempobj);
    }

    function checkNewServiceStatus(currentStage) {
        let updatedFormData = {}
        const events = _.isEmpty(trackentityInstanceDetails) ? [] : trackentityInstanceDetails.enrollments[0].events
        const filterCurrentEvent = events.filter(obj => obj.programStage == currentStage.id)
        /*new code for to show new service if htc stage given
        //ZZcqCX95AmO - test result /htc
        let htcStage = ''
        programData.programs[0].programStages.map((stages, index) => {
            if(stages.displayName.toLowerCase() == 'htc'){
                htcStage = stages.id
            }
        })
        const filterCurrentEvent = events.filter(obj => obj.programStage == htcStage)
        */
        /*end*/
        //console.log("events",trackentityInstanceDetails,events,filterCurrentEvent,htcStage);
        if (filterCurrentEvent.length > 0) {
            //return true
            /*custom loginc for save to show new service if only referred*/
            let htcReferral = _.filter(filterCurrentEvent, { dataValues: [{ dataElement: "ZHoqyBa59km" }] }); //htcservice
            //pGm3J84yrAb
            let htsGiven = _.filter(filterCurrentEvent, { dataValues: [{ dataElement: "pGm3J84yrAb" }] });
            let artReferral = _.filter(filterCurrentEvent, { dataValues: [{ dataElement: "rubrYJZ78Ds" }] });
            //HhQNLlyPilm - Determine Test Result"
            let testResult = _.filter(filterCurrentEvent, { dataValues: [{ dataElement: "HhQNLlyPilm" }] });
            //console.log("htcReferral",testResult,filterCurrentEvent);
            /*if(htcReferral.length > 0 || artReferral.length > 0){
            //if(testResult.length > 0){*/
            if (htsGiven.length > 0) {
                return true
            } else {
                return false
            }
            /*end*/
        } else {
            return false
        }


    }

    function createStageForms(stage, index) {

        const stageIndex = index
        const currentStage = stage
        let initialValues = activeCaseFormData.data ? activeCaseFormData.data.formFormat != null ? activeCaseFormData.data.formFormat : {} : {}
        let uicUID = null;
        let nameUID = null;
        let ageUID = null;
        let genderUID = null;
        let clientTypeUID = null;
        programData.programs[0].programTrackedEntityAttributes.map((field, index) => {
            if (field.trackedEntityAttribute.displayName == t("Nick Name")) {
                nameUID = field.trackedEntityAttribute.id
            }
            if (field.trackedEntityAttribute.displayName == t("UIC")) {
                uicUID = field.trackedEntityAttribute.id
            }
            /*if (field.trackedEntityAttribute.displayName == t("Age")) {
                ageUID = field.trackedEntityAttribute.id
            }*/
            if (field.trackedEntityAttribute.displayName == t("Client type")) {
                clientTypeUID = field.trackedEntityAttribute.id
            }
            if (field.trackedEntityAttribute.displayName == t("Gender")) {
                genderUID = field.trackedEntityAttribute.id
            }
        })
        var getCordovaFilePath = (imageObj) => {
            return new Promise((resolve, reject) => {
                //console.log("imageObj",imageObj)
                window.resolveLocalFileSystemURL(imageObj[0]['uri'],
                    function (fileEntry) {
                        window.requestFileSystem(window.LocalFileSystem.PERSISTENT, 0, function (fileSys) {
                            fileSys.root.getDirectory("RTMUPLOADS", { create: true, exclusive: false }, function (dir) {
                                //var imageName = new Date().getTime() +".jpg";
                                fileEntry.copyTo(dir, imageObj[0]['name'], function (entry) {
                                    var path = "cdvfile://localhost/persistent" + entry.fullPath;
                                    //console.log("path "+path);
                                    resolve(path)
                                },
                                    function (error) {
                                        console.log("error 4895", JSON.stringify(error));
                                        reject(error)
                                    });
                            },
                                function (error) {
                                    console.log("error 4902", JSON.stringify(error));
                                    reject(error)
                                });
                        }, function (error) {
                            console.log("error 4908", JSON.stringify(error));
                            reject(error)
                        });
                    }, function (error) {
                        console.log("error 4914", JSON.stringify(error));
                        reject(error)
                    });
            });

        }
        async function onStageSubmit(values, index) {
            setGlobalSpinner(true)
            //if(navigator.onLine){
            let fieldValueWithAttribute = []


            programData.programs[0].programStages.map((stages, index) => {
                fetchActiveTabs(stages, values)
                // return <TabPanel value={value} index={index + 1}>
                //     {createStageForms(stages, index + 1)}
                // </TabPanel>
            })
            let fetchActiveTab = fetchActiveTabs(currentStage, values)


            //set date maually at the time of save satge
            /*if(isFullCalenderPresentInStage){
                values[dateMedicineTakenId] = fullCalenderSelectedDate;
            }*/
            const data = values
            let promises = []

            for (let objectKey of Object.keys(values)) {

                //Object.keys(values).map(async function (objectKey, index) {

                if (dataElementGroup.find(array => array.id == objectKey) == undefined) {

                    var obj = {
                        "dataElement": objectKey,
                        "value": Array.isArray(data[objectKey]) == true ? data[objectKey].toString() : data[objectKey]
                    }
                    const CurrentStageValueFilter = stage.programStageDataElements.find(obj => obj.dataElement.id == objectKey)


                    if (CurrentStageValueFilter != undefined) {
                        if (CurrentStageValueFilter.dataElement.valueType == "IMAGE" || CurrentStageValueFilter.dataElement.valueType == "FILE_RESOURCE") {
                            if (data[objectKey]) {
                                let formData = new FormData();
                                formData.append('file', data[objectKey][0]);
                                //formData.append('file', data[objectKey][0]);
                                //if online
                                if (navigator.onLine) {
                                    promises.push(apiServices.postAPI('fileResources', formData)
                                        .then(res => {

                                            if (res.data) {

                                                //fieldValueWithAttribute.push({"dataElement": objectKey, "value": res.data.response.fileResource.id })
                                                return { "dataElement": objectKey, "value": res.data.response.fileResource.id }
                                            }
                                        }))
                                } else {
                                    if (window.cordova) {
                                        //console.log(data[objectKey])
                                        let path = await getCordovaFilePath(data[objectKey]);
                                        //console.log("4913",path) 
                                        fieldValueWithAttribute.push({ "dataElement": objectKey, "value": path })
                                        values[objectKey] = path;
                                        // await getCordovaFilePath(data[objectKey]).then(res => {
                                        //     console.log("4919",res)   
                                        // });
                                    }
                                }
                            }

                        } else {
                            fieldValueWithAttribute.push(obj)
                        }

                    }

                } else {

                    if (data[objectKey].length > 0) {
                        data[objectKey].map(eachFields => {
                            var obj = {
                                "dataElement": eachFields,
                                "value": true
                            }
                            const CurrentStageValueFilter = stage.programStageDataElements.find(obj => obj.dataElement.id == objectKey)
                            if (CurrentStageValueFilter != undefined) {
                                fieldValueWithAttribute.push(obj)
                            }
                        })
                    }

                }
                //})
            }

            //return;


            const events = _.isEmpty(trackentityInstanceDetails) ? [] : trackentityInstanceDetails.enrollments[0].events
            const filterCurrentEvent = events.filter(obj => obj.programStage == currentStage.id)
            //debugger;
            if (promises.length == 0) {


                if (filterCurrentEvent.length > 0 && newServiceStartFlag == false) {
                    if (currentStage.attributeValues && currentStage.attributeValues.length > 0 && currentStage.attributeValues[0].attribute.name == 'Assign Task') {
                        saveStage(fieldValueWithAttribute, values, currentStage, stageIndex, fetchActiveTab)
                    } else {
                        const eventId = filterCurrentEvent[filterCurrentEvent.length - 1].event
                        if (filterCurrentEvent.length == 1) {
                            updateStage(fieldValueWithAttribute, values, currentStage, stageIndex, eventId, fetchActiveTab)
                        }

                        if (filterCurrentEvent.length > 1) {
                            const scheduledEvent = filterCurrentEvent.filter(obj => obj.status == "SCHEDULE")
                            if (scheduledEvent.length > 0) {
                                const eventId = scheduledEvent[scheduledEvent.length - 1].event
                                updateStage(fieldValueWithAttribute, values, currentStage, stageIndex, eventId, fetchActiveTab)
                            }
                            if (scheduledEvent.length == 0) {
                                updateStage(fieldValueWithAttribute, values, currentStage, stageIndex, eventId, fetchActiveTab)
                            }
                        }
                    }

                } else {

                    saveStage(fieldValueWithAttribute, values, currentStage, stageIndex, fetchActiveTab)
                }
            } else {
                Promise.all(promises).then((responses) => {
                    responses.map(imageData => {
                        fieldValueWithAttribute.push(imageData)

                    })



                    if (filterCurrentEvent.length > 0 && newServiceStartFlag == false) {
                        if (currentStage.attributeValues && currentStage.attributeValues.length > 0 && currentStage.attributeValues[0].attribute.name == 'Assign Task') {
                            saveStage(fieldValueWithAttribute, values, currentStage, stageIndex, fetchActiveTab)
                        } else {
                            const eventId = filterCurrentEvent[filterCurrentEvent.length - 1].event
                            if (filterCurrentEvent.length == 1) {
                                updateStage(fieldValueWithAttribute, values, currentStage, stageIndex, eventId, fetchActiveTab)
                            }

                            if (filterCurrentEvent.length > 1) {
                                const scheduledEvent = filterCurrentEvent.filter(obj => obj.status == "SCHEDULE")
                                if (scheduledEvent.length > 0) {
                                    const eventId = scheduledEvent[scheduledEvent.length - 1].event
                                    updateStage(fieldValueWithAttribute, values, currentStage, stageIndex, eventId, fetchActiveTab)
                                }
                                if (scheduledEvent.length == 0) {
                                    updateStage(fieldValueWithAttribute, values, currentStage, stageIndex, eventId, fetchActiveTab)
                                }
                            }
                        }

                    } else {

                        saveStage(fieldValueWithAttribute, values, currentStage, stageIndex, fetchActiveTab)
                    }
                })

            }


            /*}else{
                //offline
                //activeCaseDetails.data.trackedEntityInstance
                OfflineDb.getDataFromPouchDB('activeCaseDetails').then(activeCaseDetails=>{
                    OfflineDb.updateEntity(activeCaseDetails.data.trackedEntityInstance,values).then(res=>{
                        
                    })
                })
                OfflineDb.getSingleEntity(activeCaseDetails.data.trackedEntityInstance).then(res=>{
                    
                })
                
            }*/

        }

        const checkNewServiceVisibility = (currentStage) => {
            return Configuration.hidenewservicebutton[currentStage.displayName]
        }

        const checkAccordianVisibility = (currentStage) => {
            return Configuration.hideformhistoryaccordian[currentStage.displayName]
        }
        let ageGender = initialValues ? initialValues[genderUID] ? ' (' + initialValues[genderUID] + ')' : '' : ''

        return (
            <Form
                onSubmit={onStageSubmit}
                initialValues={initialValues}
                // initialValues={newItem} //
                render={({ handleSubmit, form, submitting, pristine, values }) => (
                    <form className="fullWidth" onSubmit={handleSubmit} encrypt="multipart/form-data">
                        <div className="nameuicinfoholder">
                            <Grid container spacing={0} xs={12} lg={12}>
                                <Grid container spacing={0} xs={6} lg={3}>
                                    <Grid item>
                                        {t('Name')}: {initialValues ? initialValues[nameUID] ? initialValues[nameUID] : "N/A" : ''}
                                    </Grid>
                                </Grid>
                                <Grid container className={initialValues[ageUID] ? '' : "hide"} spacing={0} xs={6} lg={3}>
                                    <Grid item>
                                        {t('Age')}: {initialValues ? initialValues[ageUID] ? initialValues[ageUID] + ageGender : "N/A" : ''}
                                    </Grid>
                                </Grid>
                                <Grid container spacing={0} xs={6} lg={3} className={navigator.onLine ? '' : 'hide'}>
                                    <Grid item>
                                        {t('UIC')}: {initialValues ? initialValues[uicUID] ? initialValues[uicUID] : "N/A" : ''}
                                    </Grid>
                                </Grid>
                                <Grid container className={initialValues[clientTypeUID] ? '' : "hide"} spacing={0} xs={6} lg={3}>
                                    <Grid item>
                                        {t('Client Type')}: {initialValues ? initialValues[clientTypeUID] ? initialValues[clientTypeUID] : "N/A" : ''}
                                    </Grid>
                                </Grid>
                            </Grid>
                        </div>
                        <div className="innertabdivreg" id="innertabdivreg">
                            <> {
                                dataElementGroup.map(DataElementGroup => {

                                    if (values != undefined) {
                                        if (values[DataElementGroup.id] != undefined) {


                                            DataElementGroup.dataElements.map(elements => {
                                                // delete values[elements.id]
                                                //if(values[elements.id] != undefined)
                                                values[elements.id] = false
                                            })
                                            if (values[DataElementGroup.id].length > 0 && Array.isArray(values[DataElementGroup.id])) {

                                                values[DataElementGroup.id].map(value => {
                                                    values[value] = true
                                                })
                                            }
                                        }
                                    }

                                })
                            } </>

                            <Grid container spacing={3}>
                                <>{
                                    (stage.attributeValues && stage.attributeValues.length > 0) ?
                                        stage.attributeValues.map((val) => {
                                            if (val.attribute.displayName === "showFullCalender" && fullCalendarEvents != null) {

                                                return renderFullCalender(stage.programStageDataElements)

                                            }
                                            if (val.attribute.displayName === "Task List") {
                                                return <TaskList
                                                    programData={programData}
                                                    stagedetails={stage}
                                                    userdetails={userData}
                                                    trackentityInstanceDetails={trackentityInstanceDetails}
                                                />
                                            }
                                            if (val.attribute.displayName === "Regimen") {
                                                setregimenStageId(stage.id)
                                            }
                                        })
                                        : null
                                }</>

                                {(stage.programStageSections && stage.programStageSections.length > 0) ?
                                    renderStageBySection(stage, values ? values : {}, form, stage.programStageDataElements)
                                    //console.log('renderSection')
                                    /*stage.programStageDataElements.map(fields => {
                                        return renderStageField(fields, values ? values : {}, form, stage.programStageDataElements)
                                    })*/
                                    :
                                    stage.programStageDataElements.map(fields => {
                                        return renderStageField(fields, values ? values : {}, form, stage.programStageDataElements)
                                    })
                                }
                            </Grid>
                            {/* code for Regimen custom module */}
                            {
                                (stage.attributeValues && stage.attributeValues.length > 0 && radioValue) ?
                                    stage.attributeValues.map((val) => {
                                        if (val.attribute.displayName === "Regimen") {
                                            return <Grid container spacing={3} style={{ marginTop: '10px' }}>

                                                {setRegimenStageDEIds(stage)}
                                                <div className="addbuttonholder">
                                                    <button className="regformsubmitbtn" type="button" onClick={() => addRegimen(stage, values)}>
                                                        {t('Add')}
                                                    </button>
                                                </div>

                                                <TableContainer component={Paper} className="ml-10px mr-10px mb-20px">
                                                    <Table className={classes.table} aria-label="simple table">
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell>Treatment regimen</TableCell>
                                                                <TableCell align="right">Medicine Name</TableCell>
                                                                <TableCell align="right">Start date</TableCell>
                                                                <TableCell align="right">End date</TableCell>
                                                                <TableCell align="right">Dosage</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>

                                                            {medicineTable.map((row, index) => {
                                                                return <TableRow key={row[treatmentRegimenId] + index}>
                                                                    <TableCell component="th" scope="row">
                                                                        {row[treatmentRegimenId]}
                                                                    </TableCell>
                                                                    <TableCell align="right">{row.medicine.displayName}</TableCell>
                                                                    <TableCell align="right">{row[treatmentStartDateId]}</TableCell>
                                                                    <TableCell align="right">{row[treatmentEndDateId]}</TableCell>
                                                                    <TableCell align="right">{row[treatmentDoseId]}</TableCell>

                                                                </TableRow>
                                                            })}
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>

                                            </Grid>
                                        } else if (val.attribute.displayName === "showFullCalender" && radioValue && medicineTable) {
                                            return <Grid container spacing={3} style={{ marginTop: '10px', marginBottom: '10px' }}>
                                                {medicineTable.map(med => {
                                                    return <Grid container spacing={3} className="ml-10px mr-10px mt-10px mb-10px bg-lightgrey" component={Paper}>
                                                        <Grid item xs={6} lg={4} className="align-items-center">
                                                            {med.medicine.displayName}{/*JSON.stringify(med)*/}
                                                        </Grid>
                                                        <Grid item xs={6} lg={2} className="formradioholder">
                                                            {/* <Formradio></Formradio> */}

                                                            <FormControl component="fieldset">
                                                                <RadioGroup aria-label="gender" name={med.medicine.code} value={radioValue[med.medicine.code] ? radioValue[med.medicine.code] : 'yes'} onChange={(env) => handleMedicineRadioChange(env, value, med.medicine.code)}>
                                                                    <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                                                                    <FormControlLabel value="no" control={<Radio />} label="No" />
                                                                </RadioGroup>
                                                            </FormControl>
                                                        </Grid>

                                                    </Grid>
                                                })}
                                            </Grid>
                                        } else if (val.attribute.displayName === "SpecimenTable") {

                                            return (
                                                <Grid
                                                    container
                                                    spacing={0}
                                                    style={{ marginTop: "10px" }}
                                                >
                                                    <Grid item xs={12} md={12}>
                                                        <div className="addbuttonholder">
                                                            <button
                                                                className="regformsubmitbtn"
                                                                type="button"
                                                                onClick={() => addSpecimen(stage, values)}
                                                            >
                                                                {t("Add")}
                                                            </button>
                                                        </div>
                                                    </Grid>
                                                    <Grid item xs={12} md={12}>
                                                        <TableContainer component={Paper} className="ml-10px mr-10px mb-20px sputumtable">
                                                            <Table className={classes.table} aria-label="simple table">
                                                                <TableHead>
                                                                    <TableRow>
                                                                        <TableCell>Specimen ID</TableCell>
                                                                        <TableCell align="right">Date of sample collection</TableCell>
                                                                        <TableCell align="right">Specimen type</TableCell>
                                                                        <TableCell align="right">Collection Interval</TableCell>
                                                                        <TableCell align="right">QR Code</TableCell>
                                                                        <TableCell align="right">Remove</TableCell>
                                                                    </TableRow>
                                                                </TableHead>
                                                                <TableBody>
                                                                    {sputumTable.map((row, index) => {
                                                                        return <TableRow key={row[specimenid] + index}>
                                                                            <TableCell component="th" scope="row">
                                                                                {row[specimenid]}
                                                                            </TableCell>
                                                                            <TableCell align="right">{moment(row[dateOfSampleCollection]).format('MM/DD/YYYY')}</TableCell>
                                                                            <TableCell align="right">{row[specimenType]}</TableCell>
                                                                            <TableCell align="right">{row[noOfSputumCollected]}</TableCell>
                                                                            <TableCell align="right">{row[sputumQRCode] ? <AttachFileIcon /> : null}</TableCell>
                                                                            <TableCell align="right" onClick={() => removeFromTable(sputumTable, index)}>{row['action'] ? null : <DeleteIcon />}</TableCell>
                                                                        </TableRow>
                                                                    })}
                                                                </TableBody>
                                                            </Table>
                                                        </TableContainer>
                                                    </Grid>
                                                </Grid>
                                            )

                                        }
                                    })
                                    : null
                            }

                            {/* {console.log('currentStage>>>>>>>', currentStage)} */}

                            <div className="buttons">
                                <button className="regformsubmitbtn" type="submit" disabled={submitting}>
                                    {/* {value == props.stageList.length ? 'Submit' : 'Next'} */}
                                    {sessionUserBoValue && sessionUserBoValue.userCredentials && sessionUserBoValue.userRoles && sessionUserBoValue.userRoles[0].name && sessionUserBoValue.userRoles[0].name == 'ORW' ? value == "2" ? t('Submit') : t('Next') : t('Submit')}
                                    {/*{t('Submit')}*/}
                                </button>

                                {/* {programData.programs[0].programStages != null && !workFlow ?
                                <button
                                    className={`regformsubmitbtn ` + (getMultiserviceArray() ? '' : 'hide')}
                                    style={{ float: 'right' }}
                                    type="button"
                                    onClick={() => gotoNewService()}
                                >{t('New Service')}
                                </button>
                                : ""

                            } */}
                                {/* new service for individual stage  */}
                                {programData.programs[0].programStages != null && workFlow ?
                                    <button
                                        className={`regformsubmitbtn ` + (checkNewServiceStatus(currentStage) ? checkNewServiceVisibility(currentStage) ? 'hide' : '' : 'hide')}
                                        //style={{ float: 'right' }}
                                        type="button"
                                        onClick={() => starttoNewService(currentStage)}
                                    >{t('New Service')}
                                    </button>
                                    : ""
                                }
                                {/* <button
                                    className="regformresetbtn hide"
                                    type="button"
                                    //onClick={() => this.resetForm(form, values)}
                                    disabled={submitting || pristine}
                                >
                                    Reset
                              </button> */}
                            </div>
                            {navigator.onLine && currentStage && currentStage.attributeValues && currentStage.attributeValues.length > 0 ?
                                currentStage.attributeValues.map(attr => {
                                    if (attr.attribute.displayName == 'ShowServiceTab' && attr.value) {
                                        return <SeeIndividualRecordAccordian currentStage={currentStage} />
                                    }
                                })
                                :
                                null
                            }
                            {/*<pre>{JSON.stringify(values, 0, 2)}</pre> */}
                        </div>
                    </form>
                )}
            />
        )
    }

    function postSearchSubmit() {
        if (searchEnabled) {
            /*const activeCaseFormData = {
                'formFormat': null, //valueForFormInput, { ["dddXq4Ddh6Z"]: Configuration.ltbiLinkVariables.presumptivetb }
                'dhisFormat': null //
            }
            OfflineDb.setDataIntoPouchDB('activeCaseFormData', activeCaseFormData)*/
            /*setActiveCaseDetails({
                'data': {}
            })*/
            /*const activeCaseDetails = {
            }
            OfflineDb.setDataIntoPouchDB('activeCaseDetails', activeCaseDetails)*/
            setSearchResponse(null)
            if (location?.state?.stageId != "individualrecord") {
                setValue(1)
            }
        } else {
            const trackedEntityType = programData.programs[0].trackedEntityType.id
            let registrationFields = programData.programs[0].programTrackedEntityAttributes
            let valuesToSave = formValuePostDeDup.valuesToSave
            let valueForFormInput = formValuePostDeDup.valueForFormInput
            const orgUnit = valueForFormInput ? valueForFormInput[hotspotsID] ? valueForFormInput[hotspotsID] : userData.organisationUnits[0].id : userData.organisationUnits[0].id;
            //        userData.organisationUnits[0].id
            let saveCaseInput = {
                "trackedEntityType": trackedEntityType,
                "orgUnit": orgUnit,
                "attributes": valuesToSave,
                "enrollments": [
                    {
                        //"trackedEntityInstance": trackedEntityInstance,
                        "program": programData.programs[0].id,
                        //"status": "ACTIVE",
                        "orgUnit": orgUnit,
                        "enrollmentDate": moment().format("YYYY-MM-DD"),
                        "incidentDate": moment().format("YYYY-MM-DD")
                    }
                ],
                "geometry": { "type": "Point", "coordinates": [currentGeolocation.lng, currentGeolocation.lat] }
            }
            setGlobalSpinner(true)
            apiServices.postAPI('trackedEntityInstances', saveCaseInput)
                .then(response => {


                    const trackedEntityInstance = response.data.response.importSummaries[0].reference
                    const programId = programData.programs[0].id
                    const enrollmentInputJson = {
                        "trackedEntityInstance": trackedEntityInstance,
                        "program": programId,
                        "status": "ACTIVE",
                        "orgUnit": orgUnit,
                        "enrollmentDate": moment().format("YYYY-MM-DD"),
                        "incidentDate": moment().format("YYYY-MM-DD")
                    }
                    setGlobalSpinner(false)
                    //apiServices.postAPI('enrollments', enrollmentInputJson)
                    //.then(enrollmentResponse => {
                    const enroll = '';//enrollmentResponse.data.response.importSummaries[0].reference
                    if (programData.programs[0].useFirstStageDuringRegistration == false && relationShipId != "" && Configuration.registrationForm.linkContactInAlert) {
                        swal({
                            title: t("Individual Registered"),
                            text: t("Do you want to initiate the individual registration?"),
                            icon: "success",
                            buttons: [t("No"), t("Yes")],
                        })
                            .then((AlertRes) => {
                                if (AlertRes) {
                                    //save data
                                    const activeCaseDetails = {
                                        'trackedEntityInstance': trackedEntityInstance,
                                        'enrollmentId': enroll,
                                    }
                                    const linkContact = {

                                        "enabled": true,
                                        "linkTrackedEntityInstance": trackedEntityInstance
                                    }
                                    const activeCaseFormData = {
                                        'formFormat': null, //valueForFormInput,
                                        'dhisFormat': null //
                                    }
                                    // setActiveCaseDetails({
                                    //     'data': {

                                    //         'trackedEntityInstance': trackedEntityInstance,
                                    //         'enrollmentId': enroll,

                                    //     }
                                    // })

                                    OfflineDb.setDataIntoPouchDB('activeCaseDetails', activeCaseDetails)
                                    OfflineDb.setDataIntoPouchDB('activeCaseFormData', activeCaseFormData)
                                    OfflineDb.setDataIntoPouchDB('linkContactFlag', linkContact)

                                    setActiveCaseFormData({
                                        "data": {
                                            'formFormat': null, //valueForFormInput,
                                            'dhisFormat': null //
                                        }
                                    })
                                    setValue(0)

                                    //empty form
                                } else {
                                    //save data
                                    const activeCaseDetails = {
                                        'trackedEntityInstance': trackedEntityInstance,
                                        'enrollmentId': enroll,
                                    }
                                    // setActiveCaseDetails({
                                    //     'data': {

                                    //         'trackedEntityInstance': trackedEntityInstance,
                                    //         'enrollmentId': enroll,

                                    //     }
                                    // })
                                    const activeCaseFormData = {
                                        'formFormat': valueForFormInput,
                                        'dhisFormat': valuesToSave
                                    }
                                    const linkContact = {
                                        "enabled": false,
                                        "linkTrackedEntityInstance": trackedEntityInstance
                                    }
                                    OfflineDb.setDataIntoPouchDB('activeCaseDetails', activeCaseDetails)
                                    OfflineDb.setDataIntoPouchDB('activeCaseFormData', activeCaseFormData)
                                    OfflineDb.setDataIntoPouchDB('linkContactFlag', linkContact)

                                    //load next active tabs
                                    const nextTab = activeTabs[0]
                                    if (nextTab) {
                                        const indexOfNextTab = programData.programs[0].programStages.findIndex(obj => obj.id == nextTab)
                                        setValue(indexOfNextTab + stepIncrement)
                                    } else {
                                        setValue(value)
                                    }
                                }
                            })
                    } else {
                        const activeCaseDetails = {
                            'trackedEntityInstance': trackedEntityInstance,
                            'enrollmentId': enroll,
                        }
                        setActiveCaseDetails({
                            'data': {
                                'trackedEntityInstance': trackedEntityInstance,
                                'enrollmentId': enroll,
                            }
                        })
                        const activeCaseFormData = {
                            'formFormat': valueForFormInput,
                            'dhisFormat': valuesToSave
                        }
                        const linkContact = {
                            "enabled": false,
                            "linkTrackedEntityInstance": trackedEntityInstance
                        }
                        OfflineDb.setDataIntoPouchDB('activeCaseDetails', activeCaseDetails)
                        OfflineDb.setDataIntoPouchDB('activeCaseFormData', activeCaseFormData)
                        OfflineDb.setDataIntoPouchDB('linkContactFlag', linkContact)
                        swal({
                            title: t("Success"),
                            text: t("Individual Registered"),
                            icon: "success",
                            button: t("Close"),
                        });
                        //save data 

                        //laod next active tab
                        const nextTab = activeTabs[0]
                        if (nextTab) {
                            const indexOfNextTab = programData.programs[0].programStages.findIndex(obj => obj.id == nextTab)
                            setValue(indexOfNextTab + stepIncrement)
                        } else {
                            setValue(value)
                        }
                    }
                    //})
                    setGlobalSpinner(false)
                }).catch(err => {

                    swal({
                        title: t("Error"),
                        text: "",
                        icon: "error",
                        button: t("Close"),
                    });
                    setGlobalSpinner(false)
                })

            setSearchHeader(null)
            setSearchResponse(null)

        }
    }

    function processImage(imgeUrl) {
        let InitialValueData = {}
        let subscriptionKey = "a53cd4ec9db94138a74c6e4730dfa9e4"; // a53cd4ec9db94138a74c6e4730dfa9e4
        let endpoint = "https://duretech.cognitiveservices.azure.com"; // https://duretech.cognitiveservices.azure.com/
        let uriBase = endpoint + "/vision/v3.1/read/analyze";

        let sourceImageUrl = imgeUrl; //'https://res.cloudinary.com/dh5r8k5vs/image/upload/v1623038963/AppUploads/uubxdg8bi2knbihss9uy.jpg'



        setGlobalSpinner(true)
        axios({
            method: 'post',
            url: uriBase,
            headers: {
                "Content-Type": "application/json",
                "Ocp-Apim-Subscription-Key": subscriptionKey,
                'Content-Security-Policy': 'self',
                'X-Content-Type-Options': 'nosniff',
                'X-XSS-Protection': "1; mode=block"
            },
            data: JSON.stringify({ url: sourceImageUrl })
        })
            .then(response => {
                setGlobalSpinner(false)

                let operationLocation = response.headers['operation-location']
                setGlobalSpinner(true)
                setTimeout(function () {
                    axios({
                        method: 'GET',
                        url: operationLocation,
                        headers: {
                            "Content-Type": "application/json",
                            "Ocp-Apim-Subscription-Key": subscriptionKey,
                            'Content-Security-Policy': 'self',
                            'X-Content-Type-Options': 'nosniff',
                            'X-XSS-Protection': "1; mode=block"
                        }
                    })
                        .then(secondRes => {
                            setGlobalSpinner(false)
                            setCameraStatus(false)
                            var result = secondRes.data.analyzeResult.readResults[0].lines;

                            SetShowOCRDataPopUp(secondRes.data.analyzeResult.readResults)
                        })
                }, 10000)

            })
    }

    function imageUploadSuccessCallback(r) {

        if (r && r.secure_url) {
            processImage(r.secure_url)
        }
    }

    function imageUploadFailureCallback(r) {

    }

    function base64ToBlob(base64, mime) {

        mime = mime || '';
        var sliceSize = 1024;
        var byteChars = window.atob(base64);
        var byteArrays = [];

        for (var offset = 0, len = byteChars.length; offset < len; offset += sliceSize) {
            var slice = byteChars.slice(offset, offset + sliceSize);

            var byteNumbers = new Array(slice.length);
            for (var i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }

            var byteArray = new Uint8Array(byteNumbers);

            byteArrays.push(byteArray);
        }

        return new Blob(byteArrays, { type: mime });
    }

    function dataURLtoFile(dataurl, filename) {

        var arr = dataurl.split(','),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]),
            n = bstr.length,
            u8arr = new Uint8Array(n);

        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }

        return new File([u8arr], filename, { type: mime });
    }

    function handleTakePhoto(dataUri) {
        setGlobalSpinner(true)
        // Do stuff with the photo...


        const API_ENDPOINT = 'https://api.cloudinary.com/v1_1/dh5r8k5vs/upload';
        dataUri = dataUri.includes("data:image/jpeg;base64,") ? dataUri : "data:image/jpeg;base64," + dataUri;
        const fileData = new FormData();
        fileData.append('file', dataUri);
        fileData.append('upload_preset', 'uploadthroughapp');
        //fileData.append('tags', 'xxxxxx'); // optional

        fetch(API_ENDPOINT, {
            method: 'post',
            body: fileData
        })
            .then(response => response.json())
            .then(data => imageUploadSuccessCallback(data))
            .catch(err => {
                console.error('Error:', err)
                setGlobalSpinner(false)
            });

    }

    function handleTakePhotoAnimationDone(dataUri) {
        // Do stuff with the photo...
        setDataUri(dataUri);
    }

    function handleCameraError(error) {
    }

    function handleCameraStart(stream) {
        document.body.classList.add('cameraon')
    }

    function handleCameraStop() {
        document.body.classList.remove('cameraon')
    }

    function updateOCRData(data) {
        const intialValueData = data;

        if (activeCaseFormData && activeCaseFormData.data && activeCaseFormData.data.formFormat) {
            Object.keys(activeCaseFormData.data.formFormat).map(key => {
                intialValueData[key] = activeCaseFormData.data.formFormat[key]
            })
        }

        const activeCaseFormData1 = {
            "data": {
                'formFormat': intialValueData, //valueForFormInput,
                'dhisFormat': null //
            }

        }

        OfflineDb.setDataIntoPouchDB('activeCaseFormData', activeCaseFormData1)
        setActiveCaseFormData(activeCaseFormData1)
        handleCameraStop()
        setCameraStatus(false)
    }

    return (

        <div className={classes.root}>

            {activeCaseDetails != null && activeCaseFormData != null && linkContactFlag != null && trackentityInstanceDetails != null && Configuration != null && statesList != null && townshipList != null ?

                <>
                    {showOCRDataPopUp.length > 0 ? <ImageDatahandle programData={programData} imageResult={showOCRDataPopUp} updateOCRData={updateOCRData} /> : <> </>}
                    <AppBar position="static">
                        <Tabs value={value} onChange={handleChange} aria-label="simple tabs example" variant="scrollable" scrollButtons="auto">
                            {searchEnabled && navigator.onLine ?
                                Configuration.registrationForm.defaultTabOnSearchEnable.map((defaultTabs, index) => {
                                    return (
                                        <Tab className={props.stageInstanceID ? 'hideTabs' : ''} disabled={defaultTabs == "Registration" ? activeCaseDetails.data ? false : true : false} label={t(defaultTabs)} {...a11yProps(index)} />
                                    )
                                })

                                :
                                <Tab className={props.stageInstanceID ? 'hideTabs' : ''} label={t('Registration')} {...a11yProps(0)} />}

                            {programData.programs[0].programStages.map((stages, index) => {
                                let checkAccess = stageAccessCheck(stages)
                                let checkTabVisibility = checkTabs(stages)

                                let initialValues = activeCaseFormData.data ? activeCaseFormData.data.formFormat != null ? activeCaseFormData.data.formFormat : {} : {};

                                if ((initialValues && initialValues[PresentlyOnAntiTBMedicationId] && initialValues[PresentlyOnAntiTBMedicationId] == "YES" && initialValues[verifiedFieldId] && initialValues[verifiedFieldId] == "Yes")) {
                                    checkAccess = true;
                                }
                                /*code fore transfer module service*/
                                if (props.stageInstanceID) {
                                    checkAccess = false;
                                    if (props.stageTabValue == index + stepIncrement) {
                                        checkAccess = true;
                                    }
                                }
                                //console.log("props.stageInstanceID",props);

                                if (stages.id == 'oTbaZad1ZvJ' || stages.id == 'DDFbxxHkywS') {
                                    if ((initialValues && initialValues[PresentlyOnAntiTBMedicationId] && initialValues[PresentlyOnAntiTBMedicationId] == "YES" && initialValues[verifiedFieldId] && initialValues[verifiedFieldId] == "Yes")) {
                                        checkTabVisibility = true;
                                    }
                                }

                                if (stages.id == 'ZZcqCX95AmO') { // test result
                                    if (sessionUserBoValue && sessionUserBoValue.userCredentials && sessionUserBoValue.userRoles && sessionUserBoValue.userRoles[0].name && (sessionUserBoValue.userRoles[0].name == 'HTC'
                                        // || sessionUserBoValue.userRoles.find(item => item.name =='Data  Administrator')
                                    )) {
                                        checkAccess = true;
                                        checkTabVisibility = true;
                                    }

                                    if (localStorage.getItem('referral-type') && localStorage.getItem('referral-type') == 'ART CLINIC') {
                                        checkAccess = false;
                                        checkTabVisibility = false;
                                    }

                                    if (localStorage.getItem('referral-type') && localStorage.getItem('referral-type') == 'HTC CLINIC') {
                                        checkAccess = true;
                                        checkTabVisibility = true;
                                    }
                                }
                                //ART-I user
                                //console.log("stages.id",stages.id,artInitiationStage)
                                if (stages.id == "s62gtsI2DAB" || (artInitiationStage && stages.id == artInitiationStage)) {
                                    if (sessionUserBoValue && sessionUserBoValue.userCredentials && sessionUserBoValue.userRoles && sessionUserBoValue.userRoles[0].name && (sessionUserBoValue.userRoles[0].name == 'ART-I user'
                                        // || sessionUserBoValue.userRoles.find(item => item.name =='Data  Administrator')
                                    )) {
                                        checkAccess = true;
                                        checkTabVisibility = true;
                                    }
                                }
                                if (artInitiationStage && stages.id == artInitiationStage) {
                                    if (sessionUserBoValue && sessionUserBoValue.userCredentials && sessionUserBoValue.userRoles && sessionUserBoValue.userRoles[0].name && (sessionUserBoValue.userRoles[0].name == 'ART user'
                                    )) {
                                        checkAccess = false;
                                        checkTabVisibility = false;
                                    }

                                    if (localStorage.getItem('referral-type') && localStorage.getItem('referral-type') == 'ART CLINIC') {
                                        checkAccess = false;
                                        checkTabVisibility = false;
                                    }

                                    if (localStorage.getItem('referral-type') && localStorage.getItem('referral-type') == 'HTC CLINIC') {
                                        checkAccess = false;
                                        checkTabVisibility = false;
                                    }
                                }

                                if (stages.id == 'iMeA2j4xbUl') { // art enrollment
                                    if (sessionUserBoValue && sessionUserBoValue.userCredentials && sessionUserBoValue.userRoles && sessionUserBoValue.userRoles[0].name && (sessionUserBoValue.userRoles[0].name == 'ART user'
                                        // || sessionUserBoValue.userRoles.find(item => item.name =='Data  Administrator')
                                    )) {
                                        checkAccess = true;
                                        checkTabVisibility = true;
                                    }

                                    if (localStorage.getItem('referral-type') && localStorage.getItem('referral-type') == 'ART CLINIC') {
                                        checkAccess = true;
                                        checkTabVisibility = true;
                                    }

                                    if (localStorage.getItem('referral-type') && localStorage.getItem('referral-type') == 'HTC CLINIC') {
                                        checkAccess = false;
                                        checkTabVisibility = false;
                                    }
                                }
                                //console.log("stages",stages);
                                if (stages.id == 'CYOIOf9hyHL' || stages.name == 'ORW component') { // test result
                                    if (sessionUserBoValue && sessionUserBoValue.userCredentials && sessionUserBoValue.userRoles && sessionUserBoValue.userRoles[0].name && (sessionUserBoValue.userRoles[0].name == 'ORW'
                                        //  || sessionUserBoValue.userRoles.find(item => item.name =='Data  Administrator')
                                    )) {
                                        checkAccess = true;
                                        checkTabVisibility = true;
                                    }
                                }

                                //console.log("stages details",checkAccess,checkTabVisibility);
                                /*if (stages.id == 'd7NYjKu2SCY') { // HTS Stage
                                    if(initialValues && initialValues["tgft2rEpVts"] && initialValues["tgft2rEpVts"] == 'Yes' && initialValues["mnb6wbjMavs"] && (initialValues["mnb6wbjMavs"] == 'Referral' || initialValues["mnb6wbjMavs"] == 'Accompanied Referral') && initialValues['LEP6NIPQ0pZ'] && initialValues['Bm6GvfF7OOj']){ //check if disclosure given
                                        checkAccess = false;
                                        checkTabVisibility = false;
                                    }
                                }*/
                                return <Tab className={checkAccess ? '' : 'hideTabs'} label={getTranslatedLabels(stages)} {...a11yProps(index + stepIncrement)}
                                    disabled={activeCaseDetails.data ? checkTabVisibility ? false : true : true

                                    }

                                />
                            })}
                            <Tab className={props.stageInstanceID ? 'hideTabs' : 'hide'} label={t('Link')} {...a11yProps(programData.programs[0].programStages.length + stepIncrement)} disabled={activeCaseDetails.data ? false : true} />
                        </Tabs>

                    </AppBar>
                    {/* <> <Button className="regSearchCancelButton" onClick={() => setCameraStatus(true)}>{t('OCR')}</Button> </> */}
                    {searchEnabled && navigator.onLine ?
                        <>
                            <TabPanel value={value} index={0}>
                                {createSearchForm(programData)}
                            </TabPanel>
                            <TabPanel value={value} index={1}>
                                {createRegistrationForm(programData, programRules, programRulesVariables)}
                            </TabPanel>
                        </>
                        :
                        <>
                            <TabPanel value={value} index={0}>
                                {createRegistrationForm(programData, programRules, programRulesVariables)}
                            </TabPanel>
                        </>
                    }
                    {programData.programs[0].programStages.map((stages, index) => {
                        return <TabPanel value={value} index={index + stepIncrement}>
                            {createStageForms(stages, index + stepIncrement)}
                        </TabPanel>
                    })}

                    <TabPanel value={value} index={programData.programs[0].programStages.length + stepIncrement}>
                        {createLinkForm(programData)}
                    </TabPanel>
                </> :
                <> </>
            }

            {searchResponse != null ?
                <div className="modaloverlay">
                    <div className="modalcardholder">
                        <Card className="modalcard">
                            <CardHeader
                                className="modalheader"
                                action={
                                    <IconButton aria-label="close">
                                        <CloseIcon onClick={() => setSearchResponse(null)} />
                                    </IconButton>
                                }
                                title={searchResponse.length > 0 ? t("Match found") : t("No Match found")}
                            />
                            <CardContent className='modalbodycontent'>
                                <Grid container spacing={3}>
                                    {searchResponse != null ? searchResponse.map(row => {

                                        return (
                                            <CustomeCaseCard row={row} searchHeader={searchHeader} viewType={'card'} parentPage={'registration'} hideOptions={'false'}></CustomeCaseCard>
                                        )
                                    }) : <> </>}
                                </Grid>
                                <Typography className={sessionUserBoValue ? sessionUserBoValue.userCredentials ? sessionUserBoValue.userRoles ? sessionUserBoValue.userRoles[0].name ? (sessionUserBoValue.userRoles[0].name == 'HTC' || sessionUserBoValue.userRoles[0].name == 'ART user' || sessionUserBoValue.userRoles[0].name == 'ART-I user') ? 'hide modaltext modalinfo' : 'modaltext modalinfo' : 'modaltext modalinfo' : 'modaltext modalinfo' : 'modaltext modalinfo' : 'modaltext modalinfo'} gutterBottom>
                                    {t('Click Continue to register New client')}
                                </Typography>
                            </CardContent>

                            <CardActions className={sessionUserBoValue ? sessionUserBoValue.userCredentials ? sessionUserBoValue.userRoles ? sessionUserBoValue.userRoles[0].name ? (sessionUserBoValue.userRoles[0].name == 'HTC' || sessionUserBoValue.userRoles[0].name == 'ART user' || sessionUserBoValue.userRoles[0].name == 'ART-I user') ? 'hide modalfooter' : 'modalfooter' : 'modalfooter' : 'modalfooter' : 'modalfooter' : 'modalfooter'}>
                                <Button className={sessionUserBoValue ? sessionUserBoValue.userCredentials ? sessionUserBoValue.userRoles ? sessionUserBoValue.userRoles[0].name ? (sessionUserBoValue.userRoles[0].name == 'HTC' || sessionUserBoValue.userRoles[0].name == 'ART user' || sessionUserBoValue.userRoles[0].name == 'ART-I user') ? 'hide regSearchCancelButton' : 'regSearchCancelButton' : 'regSearchCancelButton' : 'regSearchCancelButton' : 'regSearchCancelButton' : 'regSearchCancelButton'} onClick={() => setSearchResponse(null)}>{t('Cancel')}</Button>
                                <Button className={sessionUserBoValue ? sessionUserBoValue.userCredentials ? sessionUserBoValue.userRoles ? sessionUserBoValue.userRoles[0].name ? (sessionUserBoValue.userRoles[0].name == 'HTC' || sessionUserBoValue.userRoles[0].name == 'ART user' || sessionUserBoValue.userRoles[0].name == 'ART-I user') ? 'hide modalactionbtn' : 'modalactionbtn' : 'modalactionbtn' : 'modalactionbtn' : 'modalactionbtn' : 'modalactionbtn'} onClick={() => postSearchSubmit()}>{t('Continue')}</Button>
                            </CardActions>

                        </Card>
                    </div>
                </div>

                : <> </>}

            {
                openCamera && dataUri == '' ?
                    <Camera
                        onTakePhoto={(dataUri) => { handleTakePhoto(dataUri); }}
                        onTakePhotoAnimationDone={(dataUri) => { handleTakePhotoAnimationDone(dataUri); }}
                        onCameraError={(error) => { handleCameraError(error); }}
                        idealFacingMode={FACING_MODES.ENVIRONMENT}
                        idealResolution={{ width: 100, height: 100 }}
                        imageType={IMAGE_TYPES.JPG}
                        imageCompression={0.97}
                        isMaxResolution={true}
                        isImageMirror={false}
                        isSilentMode={false}
                        isDisplayStartCameraError={true}
                        isFullscreen={false}
                        sizeFactor={1}
                        onCameraStart={(stream) => { handleCameraStart(stream); }}
                        onCameraStop={() => { handleCameraStop(); }}
                    /> :
                    <> </>
            }

            {
                openCamera && dataUri == '' ?
                    window.cordova ?
                        navigator.camera.getPicture(handleTakePhoto, handleCameraError, {
                            quality: 60,
                            correctOrientation: true,
                            destinationType: navigator.camera.DestinationType.DATA_URL
                        })
                        :
                        <Camera
                            onTakePhoto={(dataUri) => { handleTakePhoto(dataUri); }}
                            onTakePhotoAnimationDone={(dataUri) => { handleTakePhotoAnimationDone(dataUri); }}
                            onCameraError={(error) => { handleCameraError(error); }}
                            idealFacingMode={FACING_MODES.ENVIRONMENT}
                            idealResolution={{ width: 100, height: 100 }}
                            imageType={IMAGE_TYPES.JPG}
                            imageCompression={0.97}
                            isMaxResolution={true}
                            isImageMirror={false}
                            isSilentMode={false}
                            isDisplayStartCameraError={true}
                            isFullscreen={false}
                            sizeFactor={1}
                            onCameraStart={(stream) => { handleCameraStart(stream); }}
                            onCameraStop={() => { handleCameraStop(); }}
                        /> :
                    <> </>
            }
        </div>
    )
}

export default SimpleTabs
